/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.auth', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('auth', {
          url: 'auth',
          templateUrl: 'auth.html',
          title: 'Sign In',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages', [
            'ui.router',
        /*    'BlurAdmin.pages.dashboard', */
            'BlurAdmin.pages.profile',
			'BlurAdmin.pages.home',
            'BlurAdmin.pages.register',
		/*	'BlurAdmin.pages.enroll',	*/
            'BlurAdmin.pages.form',
			'BlurAdmin.pages.contacted',
			'BlurAdmin.pages.matchingprofiles',
		/*	'BlurAdmin.pages.engaged',	*/
			'BlurAdmin.pages.aboutus',
			'BlurAdmin.pages.contactus'
			


        ])
        .config(routeConfig);

    function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
        $urlRouterProvider.otherwise('home');
    }

    /** @ngInject */
    /* function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
     $urlRouterProvider.otherwise('dashboard');

     baSidebarServiceProvider.addStaticItem({
     title: 'About',
     icon: 'ion-document',
     subMenu: [{
     title: 'Sign In',
     fixedHref: 'auth.html',
     blank: false
     }, {
     title: 'Sign Up',
     fixedHref: 'reg.html',
     blank: false
     }, {
     title: 'User Profile',
     stateRef: 'profile'
     },
     {
     title: '404 Page',
     fixedHref: '404.html',
     blank: false
     }]
     });
     baSidebarServiceProvider.addStaticItem({
     title: 'Menu Level 1',
     icon: 'ion-ios-more',
     subMenu: [{
     title: 'Menu Level 1.1',
     disabled: true
     }, {
     title: 'Menu Level 1.2',
     subMenu: [{
     title: 'Menu Level 1.2.1',
     disabled: true
     }]
     }]
     });
     }*/

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components'
  ]);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.aboutus', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('aboutus', {
                url: '/aboutus',
                templateUrl: 'app/pages/aboutus/aboutus.html',
				/* controller: 'RegisterPageCtrl', */
                title: 'About us',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 1,
                },
            });
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.contacted', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('contacted', {
                url: '/contacted',
               /* title: 'Already Contacted', */
                templateUrl: 'app/pages/contacted/contacted.html',
                controller: 'ContactedPageCtrl'
				/*
                sidebarMeta: {
                    icon: 'ion-profile',
                    order: 0,
                }
				*/
            });
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.contactus', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('contactus', {
                url: '/contactus',
                templateUrl: 'app/pages/contactus/contactus.html',
				/* controller: 'RegisterPageCtrl', */
                title: 'Contact us',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 1,
                },
            });
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard', {
          url: '/dashboard',
          templateUrl: 'app/pages/dashboard/dashboard.html',
          title: 'Dashboard',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.engaged', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('engaged', {
                url: '/engaged',
                title: 'Engaged',
                templateUrl: 'app/pages/engaged/engaged.html',
                controller: 'EngagedPageCtrl',
                sidebarMeta: {
                    icon: 'ion-profile',
                    order: 3
                }
            });
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.enroll', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('enroll', {
                url: '/enroll',
                templateUrl: 'app/pages/enroll/enroll.html',
				controller: 'EnrollPageCtrl',
                title: 'Enroll',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 1,
                },
            });
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
/*    $stateProvider
        .state('form', {
          url: '/form',
          template : '<ui-view></ui-view>',
          abstract: true,
          title: 'Form Elements',
          sidebarMeta: {
            icon: 'ion-compose',
            order: 250,
          },
        })
        .state('form.inputs', {
          url: '/inputs',
          templateUrl: 'app/pages/form/inputs/inputs.html',
          title: 'Form Inputs',
          sidebarMeta: {
            order: 0,
          },
        })
        .state('form.layouts', {
          url: '/layouts',
          templateUrl: 'app/pages/form/layouts/layouts.html',
          title: 'Form Layouts',
          sidebarMeta: {
            order: 100,
          },
        })
        .state('form.wizard',
        {
          url: '/wizard',
          templateUrl: 'app/pages/form/wizard/wizard.html',
          controller: 'WizardCtrl',
          controllerAs: 'vm',
          title: 'Form Wizard',
          sidebarMeta: {
            order: 200,
          },
        });*/
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.home', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('home', {
                url: '/home',
                templateUrl: 'app/pages/home/home.html',
				controller: 'HomePageCtrl', 
                title: 'Home',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 1,
                },
            });
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.matchingprofiles', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('matchingprofiles', {
                url: '/matchingprofiles',
             //   title: 'matchingprofiles',
                templateUrl: 'app/pages/matchingprofiles/matchingprofiles.html',
                controller: 'MatchingprofilesPageCtrl'
				/*
                sidebarMeta: {
                    icon: 'ion-profile',
                    order: 0,
                }
				*/
            });
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.profile', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('profile', {
                url: '/profile?ID&MATCHING_PROFILE&REQUESTER_PROFILE_ID',
             //   title: 'Profile',
                templateUrl: 'app/pages/profile/profile.html',
                controller: 'ProfilePageCtrl'
				/*
				params: {
					ID: '',
					MATCHING_PROFILE: ''
				}
				*/
				/*
                sidebarMeta: {
                    icon: 'ion-profile',
                    order: 0,
                }
				*/
            });
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.register', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('register', {
                url: '/register',
                templateUrl: 'app/pages/register/register.html',
				controller: 'RegisterPageCtrl',
                title: 'Register',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 1,
                },
            });
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('tables', {
          url: '/tables',
          template : '<ui-view></ui-view>',
          abstract: true,
          controller: 'TablesPageCtrl',
          title: 'Tables',
          sidebarMeta: {
            icon: 'ion-grid',
            order: 300,
          },
        }).state('tables.basic', {
          url: '/basic',
          templateUrl: 'app/pages/tables/basic/tables.html',
          title: 'Basic Tables',
          sidebarMeta: {
            order: 0,
          },
        }).state('tables.smart', {
          url: '/smart',
          templateUrl: 'app/pages/tables/smart/tables.html',
          title: 'Smart Tables',
          sidebarMeta: {
            order: 100,
          },
        });
    $urlRouterProvider.when('/tables','/tables/basic');
  }

})();

/**
 * @author k.danovsky
 * created on 12.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui', [
    'BlurAdmin.pages.ui.typography',
    'BlurAdmin.pages.ui.buttons',
    'BlurAdmin.pages.ui.icons',
    'BlurAdmin.pages.ui.modals',
    'BlurAdmin.pages.ui.grid',
    'BlurAdmin.pages.ui.alerts',
    'BlurAdmin.pages.ui.progressBars',
    'BlurAdmin.pages.ui.notifications',
    'BlurAdmin.pages.ui.tabs',
    'BlurAdmin.pages.ui.slider',
    'BlurAdmin.pages.ui.panels'
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui', {
          url: '/ui',
          template : '<ui-view></ui-view>',
          abstract: true,
          title: 'UI Features',
          sidebarMeta: {
            icon: 'ion-android-laptop',
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.alerts', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.alerts', {
          url: '/alerts',
          templateUrl: 'app/pages/ui/alerts/alerts.html',
          title: 'Alerts',
          sidebarMeta: {
            order: 500,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.buttons', {
          url: '/buttons',
          templateUrl: 'app/pages/ui/buttons/buttons.html',
          controller: 'ButtonPageCtrl',
          title: 'Buttons',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.grid', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.grid', {
          url: '/grid',
          templateUrl: 'app/pages/ui/grid/grid.html',
          title: 'Grid',
          sidebarMeta: {
            order: 400,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.icons', {
          url: '/icons',
          templateUrl: 'app/pages/ui/icons/icons.html',
          controller: 'IconsPageCtrl',
          title: 'Icons',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.modals', {
          url: '/modals',
          templateUrl: 'app/pages/ui/modals/modals.html',
          controller: 'ModalsPageCtrl',
          title: 'Modals',
          sidebarMeta: {
            order: 300,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.notifications', {
          url: '/notifications',
          templateUrl: 'app/pages/ui/notifications/notifications.html',
          controller: 'NotificationsPageCtrl',
          title: 'Notifications',
          sidebarMeta: {
            order: 700,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.panels', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.panels', {
          url: '/panels',
          templateUrl: 'app/pages/ui/panels/panels.html',
          controller: 'NotificationsPageCtrl',
          title: 'Panels',
          sidebarMeta: {
            order: 1100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.progressBars', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.progressBars', {
          url: '/progressBars',
          templateUrl: 'app/pages/ui/progressBars/progressBars.html',
          title: 'Progress Bars',
          sidebarMeta: {
            order: 600,
          },
        });
  }

})();

/**
 * @author a.demeshko
 * created on 12/22/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.slider', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.slider', {
          url: '/slider',
          templateUrl: 'app/pages/ui/slider/slider.html',
          title: 'Sliders',
          sidebarMeta: {
            order: 1000,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 21.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.tabs', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.tabs', {
          url: '/tabs',
          templateUrl: 'app/pages/ui/tabs/tabs.html',
          title: 'Tabs & Accordions',
          sidebarMeta: {
            order: 800,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.typography', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.typography', {
          url: '/typography',
          templateUrl: 'app/pages/ui/typography/typography.html',
          title: 'Typography',
          sidebarMeta: {
            order: 0,
          },
        });
  }

})();

'use strict';

angular.module('BlurAdmin', [
  'ngAnimate',
  'ui.bootstrap',
 /* 'ui.sortable', */
  'ui.router',
  /* 'ngTouch', 
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',
	*/
  'BlurAdmin.theme',
  'BlurAdmin.pages'
]);
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper) {
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ContactedPageCtrl', ContactedPageCtrl);

  /** @ngInject */
  function ContactedPageCtrl($scope, fileReader, $filter, $uibModal) {
    $scope.picture = $filter('profilePicture')('Nasta');

    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function () {
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };

    $scope.socialProfiles = [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (item) {
		alert("showModal");
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      });/*.result.then(function (link) {
          item.href = link;
        });
		*/
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
          .then(function (result) {
            $scope.picture = result;
          });
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();

/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.register')
        .controller('RegisterModalCtrl', SearchModalCtrl);

    /** @ngInject */
    function SearchModalCtrl($scope, $uibModalInstance) {
        $scope.link = '';
        $scope.ok = function () {
            $uibModalInstance.close($scope.link);
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.register')
        .controller('RegisterPageCtrl', RegisterPageCtrl);
		
	RegisterPageCtrl.$inject = ['$scope', 'fileReader', '$filter', '$uibModal', '$timeout', '$http', 'commonService'];		

    /** @ngInject */
    function RegisterPageCtrl($scope, fileReader, $filter, $uibModal, $timeout, $http, commonService) {
        var vm = this;
		var register = this;
		
		//$scope.stateList = [{"id":"1", "name":"Rajasthan"}];
		// states
        $scope.states = commonService.states; 
		
		// districts      
        $scope.districts = commonService.districts; 

		// tehsils      
		$scope.tehsils = commonService.tehsils;
		
		//$scope.selectedDistrict = '{"district": {"code":'+registerInfo.district.code+'}}';

		
		//register.registerInfo = {};
		//alert("RegisterPageCtrl");
		$scope.userName = 'user hi aaa six';
		
		//register.registerUserdetails = registerUserdetails;
		
		//$scope.registerInfo = {};
		$scope.registerInfo ={
			Name:'', 
			state:'', 
			district: '', 
			City: ''
		};
		
		$scope.registerInfo.education = 'BE Six';
		$scope.educationVal = '111'; 
		// guardian_otp_generated
		$scope.registerInfo.guardian_otp_generated = 'no'; 
		$scope.registerInfo.previous_mobile_no = ''; 

        vm.personalInfo = {};
        vm.productInfo = {};
        vm.shipment = {};

        vm.arePersonalInfoPasswordsEqual = function () {
            return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
        };


        $scope.picture = $filter('profilePicture')('Nasta');

        $scope.removePicture = function () {
            $scope.picture = $filter('appImage')('theme/no-photo.png');
            $scope.noPicture = true;
        };
		
		$scope.refreshCaptcha = function() {
			//alert("refreshCaptcha");
			var img = document.images['captchaimg'];
			// img.src = img.src.substring(0,img.src.lastIndexOf("?"))+"?rand="+Math.random()*1000;
			img.src = img.src+"?rand="+Math.random()*1000;
		}

        $scope.uploadPicture = function () {
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();

        };
		
		$scope.radioChanged = function(radioName,radioVal) {
			commonService.updateRadioValue($scope.registerInfo,radioName,radioVal);    
		}
		
		$scope.registerUser = function() {
			//register
			// alert("registerUser seven");
			console.log("$scope.registerInfo");
			
			console.log("$scope.registerInfo");
			console.log($scope.registerInfo);
			
			if($scope.registerInfo.guardian_contact_no != $scope.registerInfo.previous_mobile_no) {
				$scope.registerInfo.previous_mobile_no = $scope.registerInfo.guardian_contact_no;
				$scope.registerInfo.guardian_otp_generated = 'no'
			}
			
			console.log($scope.registerInfo);
			var info = $scope.registerInfo;// $scope.registerDetails;
			var errorMsgList = register.validateUserDetails(info);
			if(info.guardian_otp_generated == 'yes') {
				if(!info.guardian_otp) { 
					errorMsgList.push('Please enter OTP sent to your mobile');
				}
			}
				
			if(errorMsgList.length > 0) {
				$scope.errorMsg = errorMsgList;
				
				$('body,html').animate({
					scrollTop: 0
				}, 3000);
				alert('Please correct the errors');
			}
			else {
				$scope.errorMsg = []; 
				$http.post('http://www.sagaiwale.com/test_api/public/registeruser/', info).success(function (data) {
					  
					 // alert("errorMsgList");
					  console.log(errorMsgList);
					  
					  if(data.status == 'success') { 
						alert(data.msg+". Your registration id is : "+data.user_id);
					  }
					  if(data.status == 'failed') {
						//$scope.errorMsg = data.msg;
						//if($scope.errorMsg.indexOf(data.msg) > -1) {
							alert(data.msg);
							$scope.errorMsg.push(data.msg);
						//}
					  }
					  else if(data.status == '1001') {
						$scope.registerInfo.guardian_otp_generated = 'yes';
						//$scope.errorMsg = data.msg;
						//$scope.errorMsg.push(data.msg);
						//if($scope.errorMsg.indexOf(data.msg) > -1) {							
							$scope.errorMsg.push(data.msg);
							alert(data.msg);
							document.getElementById('guardian_otp').style.backgroundColor = 'blue';
						//}
					  }
					  else {
						$scope.errorMsg = '';
					  }
					  /*
					  $scope.registration.message = data.msg;
					  $timeout(function () {
						console.log($scope.registration);
						$location.path("/dashboard");
					  });
					  */
				});
			}	
			
			//alert("$scope.errorMsg six");
			console.log($scope.errorMsg);
        };
		
		register.validateUserDetails = function(userInfo) {
		
			var errorList = [];
			if(!userInfo.looking_for) {
				errorList.push("Please select value for looking_for");
			}
			if(!userInfo.guardian) {
				errorList.push("Please enter value for guardian");
			}
			if(!userInfo.guardian_name) {
				errorList.push("Please enter value for guardian_name");
			}
			if(!userInfo.guardian_contact_no) {
				errorList.push("Please enter value for guardian_contact_no");
			}
			if(!userInfo.age) {
				errorList.push("Please enter value for age");
			}
			if(!userInfo.education) {
				errorList.push("Please enter value for highest education");
			}
			if(!userInfo.height) {
				errorList.push("Please enter value for height");
			}
			/*
			if(!userInfo.gender) {
				errorList.push("Please select value for gender");
			}
			*/
			if(!userInfo.employed) {
				errorList.push("Please select value for employed");
			}
			if(!userInfo.job_type) {
				errorList.push("Please select value for job_type");
			}
			
			if(!userInfo.address_1) {
				errorList.push("Please enter value for Address Line1");
			}
			if(!userInfo.address_2) {
				errorList.push("Please enter value for Address Line2");
			}
			if(!userInfo.state) {
				errorList.push("Please select value for state");
			}
			if(!userInfo.district) {
				errorList.push("Please select value for district");
			}
			if(!userInfo.tehsil) {
				errorList.push("Please select value for tehsil");
			}
			if(!userInfo.town) {
				errorList.push("Please enter value for town");
			}
			
			if(!userInfo.pin_code) {
				errorList.push("Please enter value for pin_code");
			}			
			if(!userInfo.religion) {
				errorList.push("Please select value for religion");
			}
			if(!userInfo.caste) {
				errorList.push("Please select value for caste");
			}
			if(!userInfo.sibling_details) {
				errorList.push("Please enter value for sibling details");
			}
			if(!userInfo.req_age_from) {
				errorList.push("Please enter value for requirement age from");
			}
			
			if(!userInfo.req_age_to) {
				errorList.push("Please enter value for requirement age to");
			}
			if(!userInfo.req_employed) {
				errorList.push("Please select value for requirement employed");
			}
			if(!userInfo.req_same_caste) {
				errorList.push("Please select value for requirement caste");
			}
			if(!userInfo.req_state) {
				errorList.push("Please select value for requirement state");
			}
			if(!userInfo.captcha_code) {
				errorList.push("Please enter value for security code");
			}
			//var errorListMsg = (errorList.length > 0) ? errorList.join('<br/>') : "";
			//alert("errorListMsg");
			//console.log(errorListMsg);
			return errorList;
		}
		
		$scope.getCaptchaImage = function() {
			
            $http.get('http://www.sagaiwale.com/test_api/public/getcaptcha/', {'user':100}).success(function (data) {
				  //alert('got captcha six');
				  //console.log(data);
				  /*
				  $scope.registration.message = data.msg;
				  $timeout(function () {
					console.log($scope.registration);
					$location.path("/dashboard");
				  });
				  */
			});
        };
		
		$scope.countries = {
			'India': {
				'Maharashtra': ['Pune', 'Mumbai', 'Nagpur', 'Akola'],
				'Madhya Pradesh': ['Indore', 'Bhopal', 'Jabalpur'],
				'Rajasthan': ['Jaipur', 'Ajmer', 'Jodhpur']
			},
			'USA': {
				'Alabama': ['Montgomery', 'Birmingham'],
				'California': ['Sacramento', 'Fremont'],
				'Illinois': ['Springfield', 'Chicago']
			},
			'Australia': {
				'New South Wales': ['Sydney'],
				'Victoria': ['Melbourne']
			}
		};
		
		$scope.states_6 = "USA";
		$scope.cities_6 = "California";
		
		$scope.getDistrictTehsils = function() {
			//alert("getDistrictTehsils nine");	
			console.log("district filter:"+'{district: {code: '+$scope.registerInfo.district.code+' }}');
			//$scope.tehsils = ($filter('filter')(commonService.tehsils, {district: {code: $scope.registerInfo.district.code }}));
			console.log("{district: $scope.registerInfo.district.code}:"+$scope.registerInfo.district.code);
			//id_val : '{ ID:'+  $scope.requestsList[i].id + '}'
			$scope.districtFilter =  "{district: '"+$scope.registerInfo.district.code+"'}";
			/*
			console.log("$scope.districtFilter:"+$scope.districtFilter);
			$scope.tehsils =  ($filter('filter')(commonService.tehsils, {district: $scope.registerInfo.district.code}));
			console.log("filtered tehsils eight");
			console.log($scope.tehsils);
			*/
			var tehsilsArr =  ($filter('filter')(commonService.tehsils, {district: $scope.registerInfo.district.code}));
			console.log("tehsilsArr");
			console.log(tehsilsArr);
			//$scope.cities =[];
			return;
		}

		$scope.countries = commonService.getCountry();

		$scope.getCountryStates = function(fieldId){
			
			console.log("fieldId.indexOf('req_'):"+fieldId.indexOf('req_'));
			if(fieldId.indexOf('req_') > -1) {
				$scope.req_sates = [];
				console.log("value:"+$scope.registerInfo[fieldId]); 
				$scope.req_sates = commonService.getCountryState($scope.registerInfo[fieldId]);
				$scope.req_cities =[];
			}
			else {
				$scope.sates = [];
				console.log("value:"+$scope.registerInfo[fieldId]); 
				$scope.sates = commonService.getCountryState($scope.registerInfo[fieldId]);
				$scope.cities =[];
			}
		}

		$scope.getStateCities = function(fieldId){
			/* debugger; */
			console.log("value:"+$scope.registerInfo[fieldId]); 
			if(fieldId.indexOf('req_') > -1) {
				$scope.req_cities = commonService.getStateCity($scope.registerInfo[fieldId]);
			}
			else {
				$scope.cities = commonService.getStateCity($scope.registerInfo[fieldId]);
			}
		}

        $scope.socialProfiles = [
            {
                name: 'Facebook',
                href: 'https://www.facebook.com/akveo/',
                icon: 'socicon-facebook'
            },
            {
                name: 'Twitter',
                href: 'https://twitter.com/akveo_inc',
                icon: 'socicon-twitter'
            },
            {
                name: 'Google',
                icon: 'socicon-google'
            },
            {
                name: 'LinkedIn',
                href: 'https://www.linkedin.com/company/akveo',
                icon: 'socicon-linkedin'
            },
            {
                name: 'GitHub',
                href: 'https://github.com/akveo',
                icon: 'socicon-github'
            },
            {
                name: 'StackOverflow',
                icon: 'socicon-stackoverflow'
            },
            {
                name: 'Dribbble',
                icon: 'socicon-dribble'
            },
            {
                name: 'Behance',
                icon: 'socicon-behace'
            }
        ];

        $scope.unconnect = function (item) {
            item.href = undefined;
        };

        $scope.showModal = function (item) {
            $uibModal.open({
                animation: false,
                controller: 'RegisterModalCtrl',
                templateUrl: 'app/pages/register/RegisterModal.html'
            }).result.then(function (link) {
                item.href = link;
            });
        };

        $scope.getFile = function () {
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function (result) {
                    $scope.picture = result;
                });
        };

        $scope.switches = [true, true, false, true, true, false];
    }

})();

/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.engaged')
    .controller('EngagedPageCtrl', EngagedPageCtrl);
	
  EngagedPageCtrl.$inject = ['$scope', 'fileReader', '$filter', '$uibModal','$stateParams', 'engagedService', '$location'];	

  /** @ngInject */
  function EngagedPageCtrl($scope, fileReader, $filter, $uibModal, $stateParams, engagedService, $location) {
	  var engaged = this;
    //$scope.picture = $filter('engagedPicture')('Nasta');
	console.log($stateParams);
	//engaged.searchParams = $stateParams.searchParams;
	
	//alert("engaged.searchParams");
	console.log("engagedService.searchParams after");
	//console.log(engagedService.searchParams);
	
	//alert("profile.profileId:"+profile.profileId);
	
	//alert('get profile for id nine : '+$stateParams.ID);
	$scope.userName = 'user hi aaa six';
	//$scope.profile_engaged = {};
	$scope.textVal = "";
	//$scope.profile_engaged = "";
	
	$scope.profile_engaged = { 
        name: 'blue'
    };
	  
	//alert("matchingprofilesService.profileType:"+engagedService.profileType);
	engagedService.getEngagedProfiles().then(function (response) {
		//$scope.data.orders = DataHelper.updateAllOrders(response.data);
		console.log("getengaged");
		console.log(response);
		//$scope.userName = 'got user profile : '+profile.profileId;
		$scope.requestsList = response.data.requests;
		/*
		$scope.page_name = 'matching_profiles';
		$scope.profile_type = engagedService.profileType;
		console.log(engagedService.searchParams);
		console.log("search param id:"+engagedService.searchParams.id);
		console.log("matchingprofilesService.searchParams id:"+matchingprofilesService.searchParams.id)
		*/
		refreshRequestsList();
		//$scope.data.orders = matchingprofilesService.updateRequests(response.data);
	});	
	
	function refreshRequestsList() {
		console.log("refreshRequestsList eight");
		//$scope.requestsList = [];

		//$scope.requestsList = listProfileService.requests; // listProfileService.listUserProfiles();	
		// $scope.requests = requestsList.requests;
		console.log("$scope.requestsList");
		console.log($scope.requestsList);
		
		var totalRequests = $scope.requestsList.length;
		$scope.requests = [];
		$scope.isEngaged = false;
		for(var i=0;i<totalRequests;i++) {
			/*
			if($scope.requestsList[i].status == 'E') {
				$scope.isEngaged = true;
			}
			*/
			$scope.requests.push(
				{
					requester_details : {
					//{
						id_val : '{"ID":"'+$scope.requestsList[i].requester_details.id+'"}',//,"NG_PROFILE" : true, "REQUESTER_PROFILE_ID" : "'+RequesterProfileId+'"}',
						type: 'text-message',
						status: $scope.requestsList[i].requester_details.status,
						author: 'Kostya',
						guardian_name: $scope.requestsList[i].requester_details.guardian_name, // 'Kostya',
						surname: 'Danovsky',
						header: 'Looking for '+$scope.requestsList[i].requester_details.looking_for, // 'Posted new message',
						text: $scope.requestsList[i].requester_details.sibling_details, // 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
						time: $scope.requestsList[i].requester_details.date_created,// 'Today 11:55 pm',
						ago: '25 minutes ago',
						expanded: false
					//}
					},
					engaged_details : {
						//{
							id_val : '{"ID":"'+$scope.requestsList[i].engaged_details.id+'"}',//,"MATCHING_PROFILE" : true, "REQUESTER_PROFILE_ID" : "'+RequesterProfileId+'"}',
							type: 'text-message',
							status: $scope.requestsList[i].engaged_details.status,
							author: 'Kostya',
							guardian_name: $scope.requestsList[i].engaged_details.guardian_name, // 'Kostya',
							surname: 'Danovsky',
							header: 'Looking for '+$scope.requestsList[i].engaged_details.looking_for, // 'Posted new message',
							text: $scope.requestsList[i].engaged_details.sibling_details, // 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
							time: $scope.requestsList[i].engaged_details.date_created,// 'Today 11:55 pm',
							ago: '25 minutes ago',
							expanded: false
						//}
					}
				}
			);
		}
		console.log("$scope.requests in controler");
		console.log($scope.requests);
		console.log("$scope.isEngaged:"+$scope.isEngaged);
	}
	
	/*
	$scope.searchMatchingProfiles = function() {
		//register
		alert("searchMatchingProfiles seven");
		console.log("$scope.registerInfo");
		console.log($scope.registerInfo);
		$scope.registerInfo.search_matching_requests = 1;
		
		var earl = '/dashboard'; 
		$location.path(earl);
		matchingprofilesService.getMatchingProfiles($scope.registerInfo); //.then(function (response) {
			
			
			//$scope.data.orders = matchingprofilesService.updateRequests(response.data);
		//});
	};	
	*/

    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function (idVal) {
		console.log("uploadPicture idVal:"+idVal);
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };
	
	$scope.getContact = function() {
		console.log("getContact");
	}

    $scope.socialProfiles = [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (item) {
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
          item.href = link;
        });
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
          .then(function (result) {
            $scope.picture = result;
          });
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.engaged').service('engagedService', engagedService);

    engagedService.$inject = ['$rootScope', '$http', '$q'];
    function engagedService($rootScope,$http,$q) {
        //var engaged = {};
		var engaged = this;
		//profile.profileDetails = {};
		/*
        var defer = $q.defer();
		
        //var isPayLater=false;
		//var trip = baseService.getTrip();
        profile.profileInfo = null;
        profile.profileInfo = function(){
        	if(onHoldObj.onHoldObjInfo){
        		return onHoldObj.onHoldObjInfo;
        	}else{
        		return defer.promise;
        	}

        }
		*/
        engaged.getUserProfile=getUserProfile;
		engaged.getUserProfileData=getUserProfileData;
		engaged.getProfile=getProfile;
		
		engaged.getProfilesList=getProfilesList;
		engaged.getEngagedProfiles=getEngagedProfiles;
		engaged.profileData = [];
		engaged.matchingProfileData = [];
		engaged.searchParams = "aaa";
		engaged.profileType = "matching";
		engaged.updateEngagedProfile=updateEngagedProfile;
		engaged.saveEngagedProfileResponse = "";
        return engaged;
		
		function getProfile(ProfileId) {
			var data = {profile_id :ProfileId ,auth_token:""};
			return $http.post('http://www.sagaiwale.com/test_api/public/getrequests/?profile_id='+ProfileId);
		}
		
		function getUserProfileData(ProfileId) {
			if(matchingprofiles.profileData.length == 0) {
				return matchingprofiles.getProfile(ProfileId);
			}
			else {
				function createPromise(willSucceed) {
				  var deferred = $q.defer();
				  $timeout(function() {
					if (willSucceed) {
					  var response = {data: {requests:  matchingprofiles.profileData }}
					  deferred.resolve(response);
					} else {
					  deferred.reject(response);
					}
				  });
				  return deferred.promise;
				}

				return createPromise(true);
			}
		}
		
		function getProfilesList(searchParams,profileType) {
			//var data = {search :ProfileId ,auth_token:""};
			console.log("profileType six:"+profileType);
			/*
			if(profileType == 'contacted') {
				var data = {profile_id:searchParams.id};
				return $http.post('http://www.sagaiwale.com/test_api/public/getcontactedprofiles/',data);	
			}
			else {
				*/
				return $http.post('http://www.sagaiwale.com/test_api/public/getengaged/',searchParams);
			//}	
		}
		
		function getEngagedProfiles() {
			if(engaged.matchingProfileData.length == 0) {
				
				return engaged.getProfilesList();
				//console.log("matchingprofiles.searchParams");
				//console.log(matchingprofiles.searchParams);
				//listProfileServiceObj.requests = requestListData;
				//$rootScope.$broadcast('gotRequestsList',{requestsList : requestListData}); 
			}
			else {
				function createPromise(willSucceed) {
				  var deferred = $q.defer();
				  $timeout(function() {
					if (willSucceed) {
					  var response = {data: {requests:  engaged.matchingProfileData }}
					  deferred.resolve(response);
					} else {
					  deferred.reject(response);
					}
				  });
				  return deferred.promise;
				}

				return createPromise(true);
			}
		}

        function getUserProfile(ProfileId){
        	//return $http.post('http://www.sagaiwale.com/api/public/getorders/?supplier_id='+supplierId);
			//var data = {avail_details: JSON.stringify(availDetails),supplier_id :supplierId ,auth_token:""};
			/*
			var data = {user_id :UserId};
			return $http.post('http://www.sagaiwale.com/api/public/getprofile/',data);
			*/
			//alert("UserId:"+UserId);
			var data = {profile_id :ProfileId ,auth_token:""};
			//return $http.post('http://www.sagaiwale.com/api/public/getavailability/',data);
			/*
			$http.post('http://www.sagaiwale.com/api/public/getavailability/',data).then(function(result) {
				console.log("result");
				console.log(result);
			   //return result.data;
			   
			   profile.profileDetails = result;
			});
			*/
			//}
			$http.post('http://www.sagaiwale.com/test_api/public/getrequests/',data).then(function(result) {
				
				//updateRequestsList(result);
				console.log("got profile six");
				console.log(result);
				return result.data.requests[0];
				/*
				$rootScope.$broadcast('refreshRequestsList'); 
				alert("got list of requests seven");
				console.log(result);
				listProfileServiceObj.requests = result.data.requests;
				$rootScope.$broadcast('refreshRequestsList'); 
				*/
			   //return;// result.data;
			   
			   //profile.profileDetails = result;
			});
        } 
		
		function updateEngagedProfile(RequesterProfileId,ContactingProfileId) {
			alert("updateEngagedProfile");    
			if(matchingprofiles.saveEngagedProfileResponse == "") {
				var data = {requesterProfileId : RequesterProfileId,contactingProfileId : ContactingProfileId,engaged : true};
				console.log(data);
				return $http.post('http://www.sagaiwale.com/test_api/public/savecontactedprofile/',data);
			}
			else {
				function createPromise(willSucceed) {
				  var deferred = $q.defer();
				  $timeout(function() {
					if (willSucceed) {
					  var response = {data: matchingprofiles.saveEngagedProfileResponse }
					  deferred.resolve(response);
					} else {
					  deferred.reject(response);
					}
				  });
				  return deferred.promise;
				}

				return createPromise(true);
			}
		}
		//return profile;	
    }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.register')
        .controller('RegisterPageCtrl', RegisterPageCtrl);
		
	RegisterPageCtrl.$inject = ['$scope', 'fileReader', '$filter', '$uibModal', '$timeout', '$http', 'commonService'];		

    /** @ngInject */
    function RegisterPageCtrl($scope, fileReader, $filter, $uibModal, $timeout, $http, commonService) {
        var vm = this;
		var register = this;
		
		//$scope.stateList = [{"id":"1", "name":"Rajasthan"}];
		// states
        $scope.states = commonService.states; 
		
		// districts      
        $scope.districts = commonService.districts; 

		// tehsils      
		$scope.tehsils = commonService.tehsils;
		
		//$scope.selectedDistrict = '{"district": {"code":'+registerInfo.district.code+'}}';

		
		//register.registerInfo = {};
		//alert("RegisterPageCtrl");
		$scope.userName = 'user hi aaa six';
		
		//register.registerUserdetails = registerUserdetails;
		
		//$scope.registerInfo = {};
		$scope.registerInfo ={
			Name:'', 
			state:'', 
			district: '', 
			City: ''
		};
		
		$scope.registerInfo.education = 'BE Six';
		$scope.educationVal = '111'; 
		// guardian_otp_generated
		$scope.registerInfo.guardian_otp_generated = 'no'; 
		$scope.registerInfo.previous_mobile_no = ''; 

        vm.personalInfo = {};
        vm.productInfo = {};
        vm.shipment = {};

        vm.arePersonalInfoPasswordsEqual = function () {
            return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
        };


        $scope.picture = $filter('profilePicture')('Nasta');

        $scope.removePicture = function () {
            $scope.picture = $filter('appImage')('theme/no-photo.png');
            $scope.noPicture = true;
        };
		
		$scope.refreshCaptcha = function() {
			//alert("refreshCaptcha");
			var img = document.images['captchaimg'];
			// img.src = img.src.substring(0,img.src.lastIndexOf("?"))+"?rand="+Math.random()*1000;
			img.src = img.src+"?rand="+Math.random()*1000;
		}

        $scope.uploadPicture = function () {
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();

        };
		
		$scope.radioChanged = function(radioName,radioVal) {
			commonService.updateRadioValue($scope.registerInfo,radioName,radioVal);    
		}
		
		$scope.registerUser = function() {
			//register
			// alert("registerUser seven");
			console.log("$scope.registerInfo");
			
			console.log("$scope.registerInfo");
			console.log($scope.registerInfo);
			
			if($scope.registerInfo.guardian_contact_no != $scope.registerInfo.previous_mobile_no) {
				$scope.registerInfo.previous_mobile_no = $scope.registerInfo.guardian_contact_no;
				$scope.registerInfo.guardian_otp_generated = 'no'
			}
			
			console.log($scope.registerInfo);
			var info = $scope.registerInfo;// $scope.registerDetails;
			var errorMsgList = register.validateUserDetails(info);
			if(info.guardian_otp_generated == 'yes') {
				if(!info.guardian_otp) { 
					errorMsgList.push('Please enter OTP sent to your mobile');
				}
			}
				
			if(errorMsgList.length > 0) {
				$scope.errorMsg = errorMsgList;
				
				$('body,html').animate({
					scrollTop: 0
				}, 3000);
				alert('Please correct the errors');
			}
			else {
				$scope.errorMsg = []; 
				$http.post('http://www.sagaiwale.com/test_api/public/registeruser/', info).success(function (data) {
					  
					 // alert("errorMsgList");
					  console.log(errorMsgList);
					  
					  if(data.status == 'success') { 
						alert(data.msg+". Your registration id is : "+data.user_id);
					  }
					  if(data.status == 'failed') {
						//$scope.errorMsg = data.msg;
						//if($scope.errorMsg.indexOf(data.msg) > -1) {
							alert(data.msg);
							$scope.errorMsg.push(data.msg);
						//}
					  }
					  else if(data.status == '1001') {
						$scope.registerInfo.guardian_otp_generated = 'yes';
						//$scope.errorMsg = data.msg;
						//$scope.errorMsg.push(data.msg);
						//if($scope.errorMsg.indexOf(data.msg) > -1) {							
							$scope.errorMsg.push(data.msg);
							alert(data.msg);
							document.getElementById('guardian_otp').style.backgroundColor = 'blue';
						//}
					  }
					  else {
						$scope.errorMsg = '';
					  }
					  /*
					  $scope.registration.message = data.msg;
					  $timeout(function () {
						console.log($scope.registration);
						$location.path("/dashboard");
					  });
					  */
				});
			}	
			
			//alert("$scope.errorMsg six");
			console.log($scope.errorMsg);
        };
		
		register.validateUserDetails = function(userInfo) {
		
			var errorList = [];
			if(!userInfo.looking_for) {
				errorList.push("Please select value for looking_for");
			}
			if(!userInfo.guardian) {
				errorList.push("Please enter value for guardian");
			}
			if(!userInfo.guardian_name) {
				errorList.push("Please enter value for guardian_name");
			}
			if(!userInfo.guardian_contact_no) {
				errorList.push("Please enter value for guardian_contact_no");
			}
			if(!userInfo.age) {
				errorList.push("Please enter value for age");
			}
			if(!userInfo.education) {
				errorList.push("Please enter value for highest education");
			}
			if(!userInfo.height) {
				errorList.push("Please enter value for height");
			}
			/*
			if(!userInfo.gender) {
				errorList.push("Please select value for gender");
			}
			*/
			if(!userInfo.employed) {
				errorList.push("Please select value for employed");
			}
			if(!userInfo.job_type) {
				errorList.push("Please select value for job_type");
			}
			
			if(!userInfo.address_1) {
				errorList.push("Please enter value for Address Line1");
			}
			if(!userInfo.address_2) {
				errorList.push("Please enter value for Address Line2");
			}
			if(!userInfo.state) {
				errorList.push("Please select value for state");
			}
			if(!userInfo.district) {
				errorList.push("Please select value for district");
			}
			if(!userInfo.tehsil) {
				errorList.push("Please select value for tehsil");
			}
			if(!userInfo.town) {
				errorList.push("Please enter value for town");
			}
			
			if(!userInfo.pin_code) {
				errorList.push("Please enter value for pin_code");
			}			
			if(!userInfo.religion) {
				errorList.push("Please select value for religion");
			}
			if(!userInfo.caste) {
				errorList.push("Please select value for caste");
			}
			if(!userInfo.sibling_details) {
				errorList.push("Please enter value for sibling details");
			}
			if(!userInfo.req_age_from) {
				errorList.push("Please enter value for requirement age from");
			}
			
			if(!userInfo.req_age_to) {
				errorList.push("Please enter value for requirement age to");
			}
			if(!userInfo.req_employed) {
				errorList.push("Please select value for requirement employed");
			}
			if(!userInfo.req_same_caste) {
				errorList.push("Please select value for requirement caste");
			}
			if(!userInfo.req_state) {
				errorList.push("Please select value for requirement state");
			}
			if(!userInfo.captcha_code) {
				errorList.push("Please enter value for security code");
			}
			//var errorListMsg = (errorList.length > 0) ? errorList.join('<br/>') : "";
			//alert("errorListMsg");
			//console.log(errorListMsg);
			return errorList;
		}
		
		$scope.getCaptchaImage = function() {
			
            $http.get('http://www.sagaiwale.com/test_api/public/getcaptcha/', {'user':100}).success(function (data) {
				  //alert('got captcha six');
				  //console.log(data);
				  /*
				  $scope.registration.message = data.msg;
				  $timeout(function () {
					console.log($scope.registration);
					$location.path("/dashboard");
				  });
				  */
			});
        };
		
		$scope.countries = {
			'India': {
				'Maharashtra': ['Pune', 'Mumbai', 'Nagpur', 'Akola'],
				'Madhya Pradesh': ['Indore', 'Bhopal', 'Jabalpur'],
				'Rajasthan': ['Jaipur', 'Ajmer', 'Jodhpur']
			},
			'USA': {
				'Alabama': ['Montgomery', 'Birmingham'],
				'California': ['Sacramento', 'Fremont'],
				'Illinois': ['Springfield', 'Chicago']
			},
			'Australia': {
				'New South Wales': ['Sydney'],
				'Victoria': ['Melbourne']
			}
		};
		
		$scope.states_6 = "USA";
		$scope.cities_6 = "California";
		
		$scope.getDistrictTehsils = function() {
			//alert("getDistrictTehsils nine");	
			console.log("district filter:"+'{district: {code: '+$scope.registerInfo.district.code+' }}');
			//$scope.tehsils = ($filter('filter')(commonService.tehsils, {district: {code: $scope.registerInfo.district.code }}));
			console.log("{district: $scope.registerInfo.district.code}:"+$scope.registerInfo.district.code);
			//id_val : '{ ID:'+  $scope.requestsList[i].id + '}'
			$scope.districtFilter =  "{district: '"+$scope.registerInfo.district.code+"'}";
			/*
			console.log("$scope.districtFilter:"+$scope.districtFilter);
			$scope.tehsils =  ($filter('filter')(commonService.tehsils, {district: $scope.registerInfo.district.code}));
			console.log("filtered tehsils eight");
			console.log($scope.tehsils);
			*/
			var tehsilsArr =  ($filter('filter')(commonService.tehsils, {district: $scope.registerInfo.district.code}));
			console.log("tehsilsArr");
			console.log(tehsilsArr);
			//$scope.cities =[];
			return;
		}

		$scope.countries = commonService.getCountry();

		$scope.getCountryStates = function(fieldId){
			
			console.log("fieldId.indexOf('req_'):"+fieldId.indexOf('req_'));
			if(fieldId.indexOf('req_') > -1) {
				$scope.req_sates = [];
				console.log("value:"+$scope.registerInfo[fieldId]); 
				$scope.req_sates = commonService.getCountryState($scope.registerInfo[fieldId]);
				$scope.req_cities =[];
			}
			else {
				$scope.sates = [];
				console.log("value:"+$scope.registerInfo[fieldId]); 
				$scope.sates = commonService.getCountryState($scope.registerInfo[fieldId]);
				$scope.cities =[];
			}
		}

		$scope.getStateCities = function(fieldId){
			/* debugger; */
			console.log("value:"+$scope.registerInfo[fieldId]); 
			if(fieldId.indexOf('req_') > -1) {
				$scope.req_cities = commonService.getStateCity($scope.registerInfo[fieldId]);
			}
			else {
				$scope.cities = commonService.getStateCity($scope.registerInfo[fieldId]);
			}
		}

        $scope.socialProfiles = [
            {
                name: 'Facebook',
                href: 'https://www.facebook.com/akveo/',
                icon: 'socicon-facebook'
            },
            {
                name: 'Twitter',
                href: 'https://twitter.com/akveo_inc',
                icon: 'socicon-twitter'
            },
            {
                name: 'Google',
                icon: 'socicon-google'
            },
            {
                name: 'LinkedIn',
                href: 'https://www.linkedin.com/company/akveo',
                icon: 'socicon-linkedin'
            },
            {
                name: 'GitHub',
                href: 'https://github.com/akveo',
                icon: 'socicon-github'
            },
            {
                name: 'StackOverflow',
                icon: 'socicon-stackoverflow'
            },
            {
                name: 'Dribbble',
                icon: 'socicon-dribble'
            },
            {
                name: 'Behance',
                icon: 'socicon-behace'
            }
        ];

        $scope.unconnect = function (item) {
            item.href = undefined;
        };

        $scope.showModal = function (item) {
            $uibModal.open({
                animation: false,
                controller: 'RegisterModalCtrl',
                templateUrl: 'app/pages/register/RegisterModal.html'
            }).result.then(function (link) {
                item.href = link;
            });
        };

        $scope.getFile = function () {
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function (result) {
                    $scope.picture = result;
                });
        };

        $scope.switches = [true, true, false, true, true, false];
    }

})();

/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.register')
        .controller('RegisterModalCtrl', SearchModalCtrl);

    /** @ngInject */
    function SearchModalCtrl($scope, $uibModalInstance) {
        $scope.link = '';
        $scope.ok = function () {
            $uibModalInstance.close($scope.link);
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.home')
        .controller('HomePageCtrl', HomePageCtrl);
		
	HomePageCtrl.$inject = ['$scope', '$location'];		

    /** @ngInject */
    function HomePageCtrl($scope,$location) {
        var vm = this;
		var register = this;
		
		$scope.displayRegister = function() {
			$location.path("/register"); 
		}
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.matchingprofiles')
    .controller('MatchingprofilesPageCtrl', MatchingprofilesPageCtrl);
	
  MatchingprofilesPageCtrl.$inject = ['$scope', 'fileReader', '$filter', '$uibModal','$stateParams', 'matchingprofilesService', '$location'];	

  /** @ngInject */
  function MatchingprofilesPageCtrl($scope, fileReader, $filter, $uibModal, $stateParams, matchingprofilesService, $location) {
	  var matchingprofiles = this;
    //$scope.picture = $filter('matchingprofilesPicture')('Nasta');
	console.log($stateParams);
	//matchingprofiles.searchParams = $stateParams.searchParams;
	
	//alert("matchingprofiles.searchParams");
	console.log("matchingprofilesService.searchParams after");
	console.log(matchingprofilesService.searchParams);
	
	//alert("profile.profileId:"+profile.profileId);
	
	//alert('get profile for id nine : '+$stateParams.ID);
	$scope.userName = 'user hi aaa six';
	//$scope.profile_engaged = {};
	$scope.textVal = "";
	//$scope.profile_engaged = "";
	
	$scope.profile_engaged = { 
        name: 'blue'
    };
	  
	/*
	profile.profileDetials = matchingprofilesService.getUserProfile(profile.profileId);
	console.log("before print profile.profileDetials");
	console.log(profile.profileDetials);
	console.log("after print profile.profileDetials");
	*/
	/*
	matchingprofilesService.getUserProfile(profile.profileId).then(function (response) {
		alert("getUserProfile");
		console.log(response);
		$scope.data.orders = DataHelper.updateAllOrders(response.data);
	});
	*/
	//alert("matchingprofilesService.profileType:"+matchingprofilesService.profileType);
	matchingprofilesService.getMatchingProfiles(matchingprofilesService.searchParams,matchingprofilesService.profileType).then(function (response) {
		//$scope.data.orders = DataHelper.updateAllOrders(response.data);
		console.log("getMatchingProfiles");
		console.log(response);
		//$scope.userName = 'got user profile : '+profile.profileId;
		$scope.requestsList = response.data.requests;
		$scope.page_name = 'matching_profiles';
		$scope.profile_type = matchingprofilesService.profileType;
		console.log(matchingprofilesService.searchParams);
		console.log("search param id:"+matchingprofilesService.searchParams.id);
		console.log("matchingprofilesService.searchParams id:"+matchingprofilesService.searchParams.id)
		refreshRequestsList(matchingprofilesService.searchParams.id);
		//$scope.data.orders = matchingprofilesService.updateRequests(response.data);
	});	
	
	$scope.saveEngagedProfile = function(engagedProfileObj) {
		
		var engagedText = $scope.profile_engaged.name;
		var engagedProfileObj = JSON.parse(engagedText);
		matchingprofilesService.updateEngagedProfile(engagedProfileObj.REQUESTER_PROFILE_ID,engagedProfileObj.ID).then(function (response) {
			
			alert("Congratulations! Engaged profile has been saved successfully!");
			console.log(response);
			/*
			$uibModal.open({
				animation: false,
				controller: 'ProfileModalCtrl',
				templateUrl: 'app/pages/profile/profileModal.html'
			}).result.then(function (link) {
				  item.href = link;
				});
			*/	
		});	
	}
	
	function refreshRequestsList(RequesterProfileId) {
		console.log("refreshRequestsList seven");
		//$scope.requestsList = [];

		//$scope.requestsList = listProfileService.requests; // listProfileService.listUserProfiles();	
		// $scope.requests = requestsList.requests;
		console.log("$scope.requestsList");
		console.log($scope.requestsList);
		
		var totalRequests = $scope.requestsList.length;
		$scope.requests = [];
		$scope.isEngaged = false;
		for(var i=0;i<totalRequests;i++) {
			if($scope.requestsList[i].status == 'E') {
				$scope.isEngaged = true;
			}
			$scope.requests.push(
				{
					id_val : '{"ID":"'+$scope.requestsList[i].id+'","MATCHING_PROFILE" : true, "REQUESTER_PROFILE_ID" : "'+RequesterProfileId+'"}',
					type: 'text-message',
					status: $scope.requestsList[i].status,
					author: 'Kostya',
					guardian_name: $scope.requestsList[i].guardian_name, // 'Kostya',
					surname: 'Danovsky',
					header: 'Looking for '+$scope.requestsList[i].looking_for, // 'Posted new message',
					text: $scope.requestsList[i].sibling_details, // 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
					time: $scope.requestsList[i].date_created,// 'Today 11:55 pm',
					ago: '25 minutes ago',
					expanded: false,
				}
			);
		}
		console.log("$scope.requests in controler");
		console.log($scope.requests);
		console.log("$scope.isEngaged:"+$scope.isEngaged);
	}
	
	/*
	$scope.searchMatchingProfiles = function() {
		//register
		alert("searchMatchingProfiles seven");
		console.log("$scope.registerInfo");
		console.log($scope.registerInfo);
		$scope.registerInfo.search_matching_requests = 1;
		
		var earl = '/dashboard'; 
		$location.path(earl);
		matchingprofilesService.getMatchingProfiles($scope.registerInfo); //.then(function (response) {
			
			
			//$scope.data.orders = matchingprofilesService.updateRequests(response.data);
		//});
	};	
	*/

    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function (idVal) {
		console.log("uploadPicture idVal:"+idVal);
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };
	
	$scope.getContact = function() {
		console.log("getContact");
	}

    $scope.socialProfiles = [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (item) {
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
          item.href = link;
        });
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
          .then(function (result) {
            $scope.picture = result;
          });
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.matchingprofiles').service('matchingprofilesService', matchingprofilesService);

    matchingprofilesService.$inject = ['$rootScope', '$http', '$q'];
    function matchingprofilesService($rootScope,$http,$q) {
        //var matchingprofiles = {};
		var matchingprofiles = this;
		//profile.profileDetails = {};
		/*
        var defer = $q.defer();
		
        //var isPayLater=false;
		//var trip = baseService.getTrip();
        profile.profileInfo = null;
        profile.profileInfo = function(){
        	if(onHoldObj.onHoldObjInfo){
        		return onHoldObj.onHoldObjInfo;
        	}else{
        		return defer.promise;
        	}

        }
		*/
        matchingprofiles.getUserProfile=getUserProfile;
		matchingprofiles.getUserProfileData=getUserProfileData;
		matchingprofiles.getProfile=getProfile;
		
		matchingprofiles.getProfilesList=getProfilesList;
		matchingprofiles.getMatchingProfiles=getMatchingProfiles;
		matchingprofiles.profileData = [];
		matchingprofiles.matchingProfileData = [];
		matchingprofiles.searchParams = "aaa";
		matchingprofiles.profileType = "matching";
		matchingprofiles.updateEngagedProfile=updateEngagedProfile;
		matchingprofiles.saveEngagedProfileResponse = "";
        return matchingprofiles;
		
		function getProfile(ProfileId) {
			var data = {profile_id :ProfileId ,auth_token:""};
			return $http.post('http://www.sagaiwale.com/test_api/public/getrequests/?profile_id='+ProfileId);
		}
		
		function getUserProfileData(ProfileId) {
			if(matchingprofiles.profileData.length == 0) {
				return matchingprofiles.getProfile(ProfileId);
			}
			else {
				function createPromise(willSucceed) {
				  var deferred = $q.defer();
				  $timeout(function() {
					if (willSucceed) {
					  var response = {data: {requests:  matchingprofiles.profileData }}
					  deferred.resolve(response);
					} else {
					  deferred.reject(response);
					}
				  });
				  return deferred.promise;
				}

				return createPromise(true);
			}
		}
		
		function getProfilesList(searchParams,profileType) {
			//var data = {search :ProfileId ,auth_token:""};
			console.log("profileType six:"+profileType);
			if(profileType == 'contacted') {
				var data = {profile_id:searchParams.id};
				return $http.post('http://www.sagaiwale.com/test_api/public/getcontactedprofiles/',data);	
			}
			else {
				return $http.post('http://www.sagaiwale.com/test_api/public/getmatchingprofiles/',searchParams);
			}	
		}
		
		function getMatchingProfiles(searchParams,profileType) {
			if(matchingprofiles.matchingProfileData.length == 0) {
				
				return matchingprofiles.getProfilesList(searchParams,profileType);
				//console.log("matchingprofiles.searchParams");
				//console.log(matchingprofiles.searchParams);
				//listProfileServiceObj.requests = requestListData;
				//$rootScope.$broadcast('gotRequestsList',{requestsList : requestListData}); 
			}
			else {
				function createPromise(willSucceed) {
				  var deferred = $q.defer();
				  $timeout(function() {
					if (willSucceed) {
					  var response = {data: {requests:  matchingprofiles.matchingProfileData }}
					  deferred.resolve(response);
					} else {
					  deferred.reject(response);
					}
				  });
				  return deferred.promise;
				}

				return createPromise(true);
			}
		}

        function getUserProfile(ProfileId){
        	//return $http.post('http://www.sagaiwale.com/api/public/getorders/?supplier_id='+supplierId);
			//var data = {avail_details: JSON.stringify(availDetails),supplier_id :supplierId ,auth_token:""};
			/*
			var data = {user_id :UserId};
			return $http.post('http://www.sagaiwale.com/api/public/getprofile/',data);
			*/
			//alert("UserId:"+UserId);
			var data = {profile_id :ProfileId ,auth_token:""};
			//return $http.post('http://www.sagaiwale.com/api/public/getavailability/',data);
			/*
			$http.post('http://www.sagaiwale.com/api/public/getavailability/',data).then(function(result) {
				console.log("result");
				console.log(result);
			   //return result.data;
			   
			   profile.profileDetails = result;
			});
			*/
			//}
			$http.post('http://www.sagaiwale.com/test_api/public/getrequests/',data).then(function(result) {
				
				//updateRequestsList(result);
				console.log("got profile six");
				console.log(result);
				return result.data.requests[0];
				/*
				$rootScope.$broadcast('refreshRequestsList'); 
				alert("got list of requests seven");
				console.log(result);
				listProfileServiceObj.requests = result.data.requests;
				$rootScope.$broadcast('refreshRequestsList'); 
				*/
			   //return;// result.data;
			   
			   //profile.profileDetails = result;
			});
        } 
		
		function updateEngagedProfile(RequesterProfileId,ContactingProfileId) {
			alert("updateEngagedProfile");    
			if(matchingprofiles.saveEngagedProfileResponse == "") {
				var data = {requesterProfileId : RequesterProfileId,contactingProfileId : ContactingProfileId,engaged : true};
				console.log(data);
				return $http.post('http://www.sagaiwale.com/test_api/public/savecontactedprofile/',data);
			}
			else {
				function createPromise(willSucceed) {
				  var deferred = $q.defer();
				  $timeout(function() {
					if (willSucceed) {
					  var response = {data: matchingprofiles.saveEngagedProfileResponse }
					  deferred.resolve(response);
					} else {
					  deferred.reject(response);
					}
				  });
				  return deferred.promise;
				}

				return createPromise(true);
			}
		}
		//return profile;	
    }
})();

/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.profile').service('commonService', commonService);

    commonService.$inject = ['$rootScope', '$filter', '$http', '$q'];
    function commonService($rootScope, $filter, $http, $q) {
        
		var commonData = this;

		commonData.searchParams = "aaa";
		commonData.getStateObj=getStateObj;
		commonData.getDistrictObj=getDistrictObj;
		commonData.getTehsilObj=getTehsilObj;
		commonData.getTehsilObj=getTehsilObj;
		commonData.updateRadioValue=updateRadioValue;
		/*
		commonData.profileType = "matching";
		commonData.updateEngagedProfile=updateEngagedProfile;
		commonData.saveEngagedProfileResponse = "";
		*/
		commonData.casteList = [{
            "code": "GEN",
            "name": "General"
			},{
				"code": "OBC",
				"name": "OBC"
			},{
				"code": "SC",
				"name": "Scheduled Caste"
			},{
				"code": "ST",
				"name": "Scheduled Tribe"
			}
		];
		
		commonData.subCasteList = [	{"code":"GEN_BRAHMIN","name":"Brahmin","main_caste":{"code":"GEN","name":"General"}},
									{"code":"GEN_BANIYA","name":"Baniya","main_caste":{"code":"GEN","name":"General"}},
									{"code":"GEN_RAJPUT","name":"Rajput","main_caste":{"code":"GEN","name":"General"}},
									
									{"code":"GEN_JAT","name":"Jat","main_caste":{"code":"OBC","name":"OBC"}},
									{"code":"GEN_YADAV","name":"Yadav","main_caste":{"code":"OBC","name":"OBC"}},
									{"code":"GEN_JANGID","name":"Jangid","main_caste":{"code":"OBC","name":"OBC"}},
									{"code":"GEN_JAT","name":"Jat","main_caste":{"code":"OBC","name":"OBC"}},
									{"code":"GEN_YADAV","name":"Yadav","main_caste":{"code":"OBC","name":"OBC"}},
									{"code":"GEN_JANGID","name":"Jangid","main_caste":{"code":"OBC","name":"OBC"}} 
		];
		
		commonData.states = [{
            "code": "RAJ",
            "name": "Rajasthan"
        }];
		
		var profileForList = [
            { "code": "SELF", "name": "Self" },{ "code": "SON", "name": "Son" },{ "code": "DAUGHTER", "name": "Daughter" },
			{ "code": "BROTHER", "name": "Brother" },{ "code": "SISTER", "name": "Sister" },{ "code": "OTHER", "name": "Other" }
			/*,
			{ "code": "FRIEND", "name": "Friend" },
			{ "code": "RELATIVE", "name": "Relative" }
			*/
			];
		
		// districts      
        commonData.districts = [{"code":"D_RAJ_01","name":"Ajmer","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_02","name":"Alwar","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_03","name":"Banswara","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_04","name":"Baran","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_05","name":"Barmer","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_06","name":"Bharatpur","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_07","name":"Bhilwara","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_08","name":"Bikaner","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_09","name":"Bundi","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_10","name":"Chittorgarh","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_11","name":"Churu","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_12","name":"Dausa","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_13","name":"Dholpur","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_14","name":"Dungarpur","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_15","name":"Ganganagar","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_16","name":"Hanumangarh","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_17","name":"Jaipur","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_18","name":"Jaisalmer","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_19","name":"Jalore","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_20","name":"Jhalawar","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_21","name":"Jhunjhunu","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_22","name":"Jodhpur","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_23","name":"Karauli","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_24","name":"Kota","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_25","name":"Nagaur","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_26","name":"Pali","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_27","name":"Pratapgarh","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_28","name":"Rajsamand","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_29","name":"Sawai Madhopur","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_30","name":"Sikar","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_31","name":"Sirohi","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_32","name":"Tonk","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_33","name":"Udaipur","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_208","name":"Udaipur six","state":{"code":"RAJ","name":"Rajasthan"}}
				];

		
		/*
		commonData.tehsils = [{"code": "T_JHU_01","name": "Buhana","district": {"code": "D_RAJ_21","name": "Jhunjhunu"}},{"code": "T_JHU_02","name":"Chirawa","district": {"code": "D_RAJ_21","name": "Jhunjhunu"}},
				{"code": "T_JHU_03","name":"Jhunjhunun","district": {"code": "D_RAJ_21","name": "Jhunjhunu"}},{"code": "T_JHU_04","name":"Khetri","district": {"code": "D_RAJ_21","name": "Jhunjhunu"}},
				{"code": "T_JHU_05","name":"Nawalgarh","district": {"code": "D_RAJ_21","name": "Jhunjhunu"}},{"code": "T_JHU_06","name":"Udaipurwati","district": {"code": "D_RAJ_21","name": "Jhunjhunu"}}
			];
			*/
		commonData.tehsils = [{"code": "T_JHU_01","name": "Buhana six","district": "D_RAJ_21"},{"code": "T_JHU_02","name":"Chirawa","district": "D_RAJ_21"},
				{"code": "T_JHU_03","name":"Jhunjhunun","district": "D_RAJ_21"},{"code": "T_JHU_04","name":"Khetri","district": "D_RAJ_21"},
				{"code": "T_JHU_05","name":"Nawalgarh","district": "D_RAJ_21"},{"code": "T_JHU_06","name":"Udaipurwati","district": "D_RAJ_21"}, 
				{"code": "T_JHU_16","name":"Udaipurwati six","district": "D_RAJ_208"},
				
				{"code": "T_ALW_01","name": "Alwar","district": "D_RAJ_02"},{"code": "T_ALW_02","name":"Bansur","district": "D_RAJ_02"},
				{"code": "T_ALW_03","name":"Behror","district": "D_RAJ_02"},{"code": "T_ALW_04","name":"Kathumar","district": "D_RAJ_02"},
				{"code": "T_ALW_05","name":"Kishangarh Bas","district": "D_RAJ_02"},{"code": "T_ALW_06","name":"Kotkasim","district": "D_RAJ_02"},
				{"code": "T_ALW_06","name": "Alwar","district": "D_RAJ_02"},{"code": "T_ALW_02","name":"Lachhmangarh","district": "D_RAJ_02"},
				{"code": "T_ALW_07","name":"Behror","district": "D_RAJ_02"},{"code": "T_ALW_04","name":"Mandawar","district": "D_RAJ_02"},
				{"code": "T_ALW_08","name":"Kishangarh Bas","district": "D_RAJ_02"},{"code": "T_ALW_06","name":"Rajgarh","district": "D_RAJ_02"},
				{"code": "T_ALW_09","name": "Alwar","district": "D_RAJ_02"},{"code": "T_ALW_02","name":"Ramgarh","district": "D_RAJ_02"},
				{"code": "T_ALW_10","name":"Behror","district": "D_RAJ_02"},{"code": "T_ALW_04","name":"Thanagazi","district": "D_RAJ_02"},
				{"code": "T_ALW_11","name":"Kishangarh Bas","district": "D_RAJ_02"},{"code": "T_ALW_06","name":"Tijara","district": "D_RAJ_02"}		
				
			];	
		
		var countrylist = [
            { "code": "RAJ", "name": "Rajasthan" }
			];
		  
		  var statelist = [{"code":"D_RAJ_01","name":"Ajmer","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_02","name":"Alwar","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_03","name":"Banswara","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_04","name":"Baran","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_05","name":"Barmer","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_06","name":"Bharatpur","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_07","name":"Bhilwara","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_08","name":"Bikaner","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_09","name":"Bundi","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_10","name":"Chittorgarh","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_11","name":"Churu","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_12","name":"Dausa","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_13","name":"Dholpur","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_14","name":"Dungarpur","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_15","name":"Ganganagar","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_16","name":"Hanumangarh","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_17","name":"Jaipur","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_18","name":"Jaisalmer","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_19","name":"Jalore","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_20","name":"Jhalawar","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_21","name":"Jhunjhunu","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_22","name":"Jodhpur","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_23","name":"Karauli","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_24","name":"Kota","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_25","name":"Nagaur","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_26","name":"Pali","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_27","name":"Pratapgarh","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_28","name":"Rajsamand","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_29","name":"Sawai Madhopur","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_30","name":"Sikar","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_31","name":"Sirohi","state":{"code":"RAJ","name":"Rajasthan"}},{"code":"D_RAJ_32","name":"Tonk","state":{"code":"RAJ","name":"Rajasthan"}},
					{"code":"D_RAJ_33","name":"Udaipur","state":{"code":"RAJ","name":"Rajasthan"}}
				];
		  
		  var citylist = [{"code": "T_JHU_01","name": "Buhana","district": "D_RAJ_21"},{"code": "T_JHU_02","name":"Chirawa","district": "D_RAJ_21"},
				{"code": "T_JHU_03","name":"Jhunjhunun","district": "D_RAJ_21"},{"code": "T_JHU_04","name":"Khetri","district": "D_RAJ_21"},
				{"code": "T_JHU_05","name":"Nawalgarh","district": "D_RAJ_21"},{"code": "T_JHU_06","name":"Udaipurwati","district": "D_RAJ_21"}, 
				{"code": "T_JHU_16","name":"Udaipurwati six","district": "D_RAJ_208"},
				
				{"code": "T_ALW_01","name": "Alwar","district": "D_RAJ_02"},{"code": "T_ALW_02","name":"Bansur","district": "D_RAJ_02"},
				{"code": "T_ALW_03","name":"Behror","district": "D_RAJ_02"},{"code": "T_ALW_04","name":"Kathumar","district": "D_RAJ_02"},
				{"code": "T_ALW_05","name":"Kishangarh Bas","district": "D_RAJ_02"},{"code": "T_ALW_06","name":"Kotkasim","district": "D_RAJ_02"},
				{"code": "T_ALW_07","name": "Lachhmangarh","district": "D_RAJ_02"},{"code": "T_ALW_08","name":"Mandawar","district": "D_RAJ_02"},
				{"code": "T_ALW_09","name":"Rajgarh","district": "D_RAJ_02"},{"code": "T_ALW_10","name":"Ramgarh","district": "D_RAJ_02"},
				{"code": "T_ALW_11","name":"Thanagazi","district": "D_RAJ_02"},{"code": "T_ALW_12","name":"Tijara","district": "D_RAJ_02"},

				{"code": "T_AJM_01","name": "Ajmer","district": "D_RAJ_01"},{"code": "T_AJM_02","name":"Beawar","district": "D_RAJ_01"},
				{"code": "T_AJM_03","name":"Bhinay","district": "D_RAJ_01"},{"code": "T_AJM_04","name":"Kekri","district": "D_RAJ_01"},
				{"code": "T_AJM_05","name":"Kishangarh","district": "D_RAJ_01"},{"code": "T_AJM_06","name":"Masuda","district": "D_RAJ_01"},
				{"code": "T_AJM_07","name": "Nasirabad","district": "D_RAJ_01"},{"code": "T_AJM_08","name":"Peesangan","district": "D_RAJ_01"},
				{"code": "T_AJM_09","name":"Sarwar","district": "D_RAJ_01"},

				{"code": "T_BAN_01","name": "Bagidora","district": "D_RAJ_03"},{"code": "T_BAN_02","name":"Banswara","district": "D_RAJ_03"},
				{"code": "T_BAN_03","name":"Garhi","district": "D_RAJ_03"},{"code": "T_BAN_04","name":"Ghatol","district": "D_RAJ_03"},
				{"code": "T_BAN_05","name":"Kushalgarh","district": "D_RAJ_03"},

				{"code": "T_BAR_01","name": "Antah","district": "D_RAJ_04"},{"code": "T_BAR_02","name":"Atru","district": "D_RAJ_04"},
				{"code": "T_BAR_03","name":"Baran","district": "D_RAJ_04"},{"code": "T_BAR_04","name":"Chhabra","district": "D_RAJ_04"},
				{"code": "T_BAR_05","name":"Chhipabarod","district": "D_RAJ_04"},{"code": "T_BAR_06","name":"Kishanganj","district": "D_RAJ_04"},
				{"code": "T_BAR_07","name":"Mangrol","district": "D_RAJ_04"},{"code": "T_BAR_08","name":"Shahbad","district": "D_RAJ_04"},

				{"code": "T_BAM_01","name": "Barmer","district": "D_RAJ_05"},{"code": "T_BAM_02","name":"Baytoo","district": "D_RAJ_05"},
				{"code": "T_BAM_03","name":"Chohtan","district": "D_RAJ_05"},{"code": "T_BAM_04","name":"Gudha Malani","district": "D_RAJ_05"},
				{"code": "T_BAM_05","name":"Pachpadra","district": "D_RAJ_05"},{"code": "T_BAM_06","name":"Ramsar","district": "D_RAJ_05"},
				{"code": "T_BAM_07","name":"Sheo","district": "D_RAJ_05"},{"code": "T_BAM_08","name":"Siwana","district": "D_RAJ_05"},

				{"code": "T_BHA_01","name": "Bayana","district": "D_RAJ_06"},{"code": "T_BHA_02","name":"Bharatpur","district": "D_RAJ_06"},
				{"code": "T_BHA_03","name":"Deeg","district": "D_RAJ_06"},{"code": "T_BHA_04","name":"Kaman","district": "D_RAJ_06"},
				{"code": "T_BHA_05","name":"Kumher","district": "D_RAJ_06"},{"code": "T_BHA_06","name":"Nadbai","district": "D_RAJ_06"},
				{"code": "T_BHA_07","name":"Nagar","district": "D_RAJ_06"},{"code": "T_BHA_08","name":"Pahari","district": "D_RAJ_06"},
				{"code": "T_BHA_07","name":"Rupbas","district": "D_RAJ_06"},{"code": "T_BHA_08","name":"Weir","district": "D_RAJ_06"},

				{"code": "T_BHI_01","name": "Bayana","district": "D_RAJ_07"},{"code": "T_BHI_02","name":"Bharatpur","district": "D_RAJ_07"},
				{"code": "T_BHI_03","name":"Deeg","district": "D_RAJ_07"},{"code": "T_BHI_04","name":"Kaman","district": "D_RAJ_07"},
				{"code": "T_BHI_05","name":"Kumher","district": "D_RAJ_07"},{"code": "T_BHI_06","name":"Nadbai","district": "D_RAJ_07"},
				{"code": "T_BHI_07","name":"Nagar","district": "D_RAJ_07"},{"code": "T_BHI_08","name":"Pahari","district": "D_RAJ_07"},
				{"code": "T_BHI_07","name":"Rupbas","district": "D_RAJ_07"},{"code": "T_BHI_08","name":"Weir","district": "D_RAJ_07"},

				{"code": "T_BIK_01","name": "Bikaner","district": "D_RAJ_08"},{"code": "T_BIK_02","name":"Chhatargarh","district": "D_RAJ_08"},
				{"code": "T_BIK_03","name":"Khajuwala","district": "D_RAJ_08"},{"code": "T_BIK_04","name":"Kolayat","district": "D_RAJ_08"},
				{"code": "T_BIK_05","name":"Lunkaransar","district": "D_RAJ_08"},{"code": "T_BIK_06","name":"Nokha","district": "D_RAJ_08"},
				{"code": "T_BIK_07","name":"Poogal","district": "D_RAJ_08"},{"code": "T_BIK_08","name":"Sridungargarh","district": "D_RAJ_08"},

				{"code": "T_BUN_01","name": "Bundi","district": "D_RAJ_09"},{"code": "T_BUN_02","name":"Hindoli","district": "D_RAJ_09"},
				{"code": "T_BUN_03","name":"Indragarh","district": "D_RAJ_09"},{"code": "T_BUN_04","name":"Keshoraipatan","district": "D_RAJ_09"},
				{"code": "T_BUN_05","name":"Nainwa","district": "D_RAJ_09"},

				{"code": "T_CHI_01","name": "Bari Sadri","district": "D_RAJ_10"},{"code": "T_CHI_02","name":"Begun","district": "D_RAJ_10"},
				{"code": "T_CHI_03","name":"Bhadesar","district": "D_RAJ_10"},{"code": "T_CHI_04","name":"Chittaurgarh","district": "D_RAJ_10"},
				{"code": "T_CHI_05","name":"Dungla","district": "D_RAJ_10"},{"code": "T_CHI_06","name":"Gangrar","district": "D_RAJ_10"},
				{"code": "T_CHI_07","name":"Kapasan","district": "D_RAJ_10"},{"code": "T_CHI_08","name":"Nimbahera","district": "D_RAJ_10"},
				{"code": "T_CHI_09","name":"Rashmi","district": "D_RAJ_10"},{"code": "T_CHI_10","name":"Rawatbhata","district": "D_RAJ_10"},

				{"code": "T_CHU_01","name": "Churu","district": "D_RAJ_11"},{"code": "T_CHU_02","name":"Rajgarh","district": "D_RAJ_11"},
				{"code": "T_CHU_03","name":"Ratangarh","district": "D_RAJ_11"},{"code": "T_CHU_04","name":"Sardarshahar","district": "D_RAJ_11"},
				{"code": "T_CHU_05","name":"Sujangarh","district": "D_RAJ_11"},{"code": "T_CHU_06","name":"Taranagar","district": "D_RAJ_11"},

				{"code": "T_DAU_01","name": "Baswa","district": "D_RAJ_12"},{"code": "T_DAU_02","name":"Dausa","district": "D_RAJ_12"},
				{"code": "T_DAU_03","name":"Lalsot","district": "D_RAJ_12"},{"code": "T_DAU_04","name":"Mahwa","district": "D_RAJ_12"},
				{"code": "T_DAU_05","name":"Sikrai","district": "D_RAJ_12"},

				{"code": "T_DHO_01","name": "Bari","district": "D_RAJ_13"},{"code": "T_DHO_02","name":"Baseri","district": "D_RAJ_13"},
				{"code": "T_DHO_03","name":"Dhaulpur","district": "D_RAJ_13"},{"code": "T_DHO_04","name":"Rajakhera","district": "D_RAJ_13"},
				{"code": "T_DHO_05","name":"Sepau","district": "D_RAJ_13"},

				{"code": "T_DUN_01","name": "Aspur","district": "D_RAJ_14"},{"code": "T_DUN_02","name":"Dungarpur","district": "D_RAJ_14"},
				{"code": "T_DUN_03","name":"Sagwara","district": "D_RAJ_14"},{"code": "T_DUN_04","name":"Simalwara","district": "D_RAJ_14"},

				{"code": "T_GAN_01","name": "Anupgarh","district": "D_RAJ_15"},{"code": "T_GAN_02","name":"Ganganagar","district": "D_RAJ_15"},
				{"code": "T_GAN_03","name":"Gharsana","district": "D_RAJ_15"},{"code": "T_GAN_04","name":"Karanpur","district": "D_RAJ_15"},
				{"code": "T_GAN_05","name":"Padampur","district": "D_RAJ_15"},{"code": "T_GAN_06","name":"Raisinghnagar","district": "D_RAJ_15"},
				{"code": "T_GAN_07","name":"Sadulshahar","district": "D_RAJ_15"},{"code": "T_GAN_08","name":"Suratgarh","district": "D_RAJ_15"},
				{"code": "T_GAN_09","name":"Vijainagar","district": "D_RAJ_15"},

				{"code": "T_HAN_01","name": "Bhadra","district": "D_RAJ_16"},{"code": "T_HAN_02","name":"Hanumangarh","district": "D_RAJ_16"},
				{"code": "T_HAN_03","name":"Nohar","district": "D_RAJ_16"},{"code": "T_HAN_04","name":"Pilibanga","district": "D_RAJ_16"},
				{"code": "T_HAN_05","name":"Rawatsar","district": "D_RAJ_16"},{"code": "T_HAN_06","name":"Sangaria","district": "D_RAJ_16"},
				{"code": "T_HAN_07","name":"Tibi","district": "D_RAJ_16"},

				{"code": "T_JAI_01","name": "Amber","district": "D_RAJ_17"},{"code": "T_JAI_02","name":"Bassi","district": "D_RAJ_17"},
				{"code": "T_JAI_03","name":"Chaksu","district": "D_RAJ_17"},{"code": "T_JAI_04","name":"Chomu","district": "D_RAJ_17"},
				{"code": "T_JAI_05","name":"Jaipur","district": "D_RAJ_17"},{"code": "T_JAI_06","name":"Jamwa Ramgarh","district": "D_RAJ_17"},
				{"code": "T_JAI_07","name":"Kotputli","district": "D_RAJ_17"},{"code": "T_JAI_08","name":"Mauzamabad","district": "D_RAJ_17"},
				{"code": "T_JAI_07","name":"Phagi","district": "D_RAJ_17"},{"code": "T_JAI_08","name":"Phulera","district": "D_RAJ_17"},
				{"code": "T_JAI_07","name":"Sanganer","district": "D_RAJ_17"},{"code": "T_JAI_08","name":"Shahpura","district": "D_RAJ_17"},
				{"code": "T_JAI_08","name":"Viratnagar","district": "D_RAJ_17"},

				{"code": "T_JAS_01","name": "Fatehgarh","district": "D_RAJ_18"},{"code": "T_JAS_02","name":"Jaisalmer","district": "D_RAJ_18"},
				{"code": "T_JAS_03","name":"Pokaran","district": "D_RAJ_18"},

				{"code": "T_JAL_01","name": "Ahore","district": "D_RAJ_19"},{"code": "T_JAL_02","name":"Bagora","district": "D_RAJ_19"},
				{"code": "T_JAL_03","name":"Bhinmal","district": "D_RAJ_19"},{"code": "T_JAL_04","name":"Jalor","district": "D_RAJ_19"},
				{"code": "T_JAL_05","name":"Raniwara","district": "D_RAJ_19"},{"code": "T_JAL_06","name":"Sanchore","district": "D_RAJ_19"},
				{"code": "T_JAL_07","name":"Sayla","district": "D_RAJ_19"},

				{"code": "T_JHA_01","name": "Aklera","district": "D_RAJ_20"},{"code": "T_JHA_02","name":"Gangdhar","district": "D_RAJ_20"},
				{"code": "T_JHA_03","name":"Jhalrapatan","district": "D_RAJ_20"},{"code": "T_JHA_04","name":"Khanpur","district": "D_RAJ_20"},
				{"code": "T_JHA_05","name":"Manohar Thana","district": "D_RAJ_20"},{"code": "T_JHA_06","name":"Pachpahar","district": "D_RAJ_20"},
				{"code": "T_JHA_07","name":"Pirawa","district": "D_RAJ_20"},

				{"code": "T_JOD_01","name": "Bhopalgarh","district": "D_RAJ_22"},{"code": "T_JOD_02","name":"Bilara","district": "D_RAJ_22"},
				{"code": "T_JOD_03","name":"Jodhpur","district": "D_RAJ_22"},{"code": "T_JOD_04","name":"Luni","district": "D_RAJ_22"},
				{"code": "T_JOD_05","name":"Osian","district": "D_RAJ_22"},{"code": "T_JOD_06","name":"Phalodi","district": "D_RAJ_22"},
				{"code": "T_JOD_07","name":"Shergarh","district": "D_RAJ_22"},

				{"code": "T_KAR_01","name": "Hindaun","district": "D_RAJ_23"},{"code": "T_KAR_02","name":"Karauli","district": "D_RAJ_23"},
				{"code": "T_KAR_03","name":"Mandrail","district": "D_RAJ_23"},{"code": "T_KAR_04","name":"Nadoti","district": "D_RAJ_23"},
				{"code": "T_KAR_05","name":"Sapotra","district": "D_RAJ_23"},{"code": "T_KAR_06","name":"Todabhim","district": "D_RAJ_23"},

				{"code": "T_KOT_01","name": "Digod","district": "D_RAJ_24"},{"code": "T_KOT_02","name":"Ladpura","district": "D_RAJ_24"},
				{"code": "T_KOT_03","name":"Pipalda","district": "D_RAJ_24"},{"code": "T_KOT_04","name":"Ramganj Mandi","district": "D_RAJ_24"},
				{"code": "T_KOT_05","name":"Sangod","district": "D_RAJ_24"},

				{"code": "T_NAG_01","name": "Degana","district": "D_RAJ_25"},{"code": "T_NAG_02","name":"Didwana","district": "D_RAJ_25"},
				{"code": "T_NAG_03","name":"Jayal","district": "D_RAJ_25"},{"code": "T_NAG_04","name":"Kheenvsar","district": "D_RAJ_25"},
				{"code": "T_NAG_05","name":"Ladnu","district": "D_RAJ_25"},{"code": "T_NAG_06","name":"Makrana","district": "D_RAJ_25"},
				{"code": "T_NAG_07","name":"Merta","district": "D_RAJ_25"},{"code": "T_NAG_08","name":"Nagaur","district": "D_RAJ_25"},
				{"code": "T_NAG_09","name":"Nawa","district": "D_RAJ_25"},{"code": "T_NAG_10","name":"Parbatsar","district": "D_RAJ_25"},

				{"code": "T_PAL_01","name": "Bali","district": "D_RAJ_26"},{"code": "T_PAL_02","name":"Desuri","district": "D_RAJ_26"},
				{"code": "T_PAL_03","name":"Jaitaran","district": "D_RAJ_26"},{"code": "T_PAL_04","name":"Marwar Junction","district": "D_RAJ_26"},
				{"code": "T_PAL_05","name":"Pali","district": "D_RAJ_26"},{"code": "T_PAL_06","name":"Raipur","district": "D_RAJ_26"},
				{"code": "T_PAL_07","name":"Rohat","district": "D_RAJ_26"},{"code": "T_PAL_08","name":"Sojat","district": "D_RAJ_26"},
				{"code": "T_PAL_09","name":"Sumerpur","district": "D_RAJ_26"},

				{"code": "T_PAR_01","name": "Arnod","district": "D_RAJ_27"},{"code": "T_PAR_02","name":"Chhoti Sadri","district": "D_RAJ_27"},
				{"code": "T_PAR_03","name":"Dhariawad","district": "D_RAJ_27"},{"code": "T_PAR_04","name":"Peepalkhoont","district": "D_RAJ_27"},
				{"code": "T_PAR_05","name":"Pratapgarh","district": "D_RAJ_27"},

				{"code": "T_RAJ_01","name": "Amet","district": "D_RAJ_28"},{"code": "T_RAJ_02","name":"Bhim","district": "D_RAJ_28"},
				{"code": "T_RAJ_03","name":"Deogarh","district": "D_RAJ_28"},{"code": "T_RAJ_04","name":"Kumbhalgarh","district": "D_RAJ_28"},
				{"code": "T_RAJ_05","name":"Nathdwara","district": "D_RAJ_28"},{"code": "T_RAJ_06","name":"Railmagra","district": "D_RAJ_28"},
				{"code": "T_RAJ_07","name":"Rajsamand","district": "D_RAJ_28"},

				{"code": "T_SAW_01","name": "Bamanwas","district": "D_RAJ_29"},{"code": "T_SAW_02","name":"Bonli","district": "D_RAJ_29"},
				{"code": "T_SAW_03","name":"Chauth Ka Barwara","district": "D_RAJ_29"},{"code": "T_SAW_04","name":"Gangapur","district": "D_RAJ_29"},
				{"code": "T_SAW_05","name":"Khandar","district": "D_RAJ_29"},{"code": "T_SAW_06","name":"Malarna Doongar","district": "D_RAJ_29"},
				{"code": "T_SAW_07","name":"Sawai Madhopur","district": "D_RAJ_29"},

				{"code": "T_SIK_01","name": "Danta Ramgarh","district": "D_RAJ_30"},{"code": "T_SIK_02","name":"Fatehpur","district": "D_RAJ_30"},
				{"code": "T_SIK_03","name":"Lachhmangarh","district": "D_RAJ_30"},{"code": "T_SIK_04","name":"Neem-Ka-Thana","district": "D_RAJ_30"},
				{"code": "T_SIK_05","name":"Sikar","district": "D_RAJ_30"},{"code": "T_SIK_06","name":"Sri Madhopur","district": "D_RAJ_30"},

				{"code": "T_SIR_01","name": "Abu Road","district": "D_RAJ_31"},{"code": "T_SIR_02","name":"Pindwara","district": "D_RAJ_31"},
				{"code": "T_SIR_03","name":"Reodar","district": "D_RAJ_31"},{"code": "T_SIR_04","name":"Sheoganj","district": "D_RAJ_31"},
				{"code": "T_SIR_05","name":"Sirohi","district": "D_RAJ_31"},
				
				{"code": "T_TON_01","name": "Deoli","district": "D_RAJ_32"},{"code": "T_TON_02","name":"Malpura","district": "D_RAJ_32"},
				{"code": "T_TON_03","name":"Niwai","district": "D_RAJ_32"},{"code": "T_TON_04","name":"Peeplu","district": "D_RAJ_32"},
				{"code": "T_TON_05","name":"Todaraisingh","district": "D_RAJ_32"},{"code": "T_TON_06","name":"Tonk","district": "D_RAJ_32"},
				{"code": "T_TON_07","name":"Uniara","district": "D_RAJ_32"},

				{"code": "T_UDA_01","name": "Girwa","district": "D_RAJ_33"},{"code": "T_UDA_02","name":"Gogunda","district": "D_RAJ_33"},
				{"code": "T_UDA_03","name":"Jhadol","district": "D_RAJ_33"},{"code": "T_UDA_04","name":"Kherwara","district": "D_RAJ_33"},
				{"code": "T_UDA_05","name":"Kotra","district": "D_RAJ_33"},{"code": "T_UDA_06","name":"Lasadiya","district": "D_RAJ_33"},
				{"code": "T_UDA_07","name":"Mavli","district": "D_RAJ_33"},{"code": "T_UDA_08","name":"Rishabhdeo","district": "D_RAJ_33"},
				{"code": "T_UDA_09","name":"Salumbar","district": "D_RAJ_33"},{"code": "T_UDA_10","name":"Sarada","district": "D_RAJ_33"},
				{"code": "T_UDA_11","name":"Vallabhnagar","district": "D_RAJ_33"}
	
			];	
		  
		  commonData.getCountry = function(){    
			return countrylist;
		  };
		  
		  commonData.getProfileFor = function(){    
			return profileForList;
		  };
		  
		  commonData.getCountryState = function(countryId){
			//alert("countryId:"+countryId);
			var states = [];
			if(countryId) {
				states = ($filter('filter')(statelist, {state:{code: countryId}}));
			}
			return states;
		  };
		  
		  
		  commonData.getStateCity = function(districtId){    
		   
			var items = ($filter('filter')(citylist, {district: districtId}));      
			return items;
		  };	
		
        return commonData; 	
		
		function updateRadioValue(registerInfo,radioName,radioVal) {
			if(radioName == 'disability') {
				if(radioVal == 'N') {
					registerInfo.req_disability = 'N';
				}
				else if(radioVal == 'Y') {
					registerInfo.req_disability = 'E';
				}
			}
			else if(radioName == 'is_widow') {
				if(radioVal == 'N') {
					registerInfo.req_is_widow = 'N';
				}
				else if(radioVal == 'Y') {
					registerInfo.req_is_widow = 'E';
				}
			}
			else if(radioName == 'is_divorcee') {
				if(radioVal == 'N') {
					registerInfo.req_is_divorcee = 'N';
				}
				else if(radioVal == 'Y') {
					registerInfo.req_is_divorcee = 'E';
				}
			}
			else if(radioName == 'religion') {
				registerInfo.req_religion = radioVal;
			}
		}
		
		function getStateObj(CodeVal) {
			var dataLen = commonData.states.length;
			var dataObj = "";
			for(var i=0;i<dataLen;i++) {
				if(commonData.states[i].code == CodeVal) {
					dataObj = commonData.states[i];
				}
			}
			return dataObj;
		}
		
		function getDistrictObj(CodeVal) {
			var districtLen = commonData.districts.length;
			var districtObj = "";
			for(var i=0;i<districtLen;i++) {
				if(commonData.districts[i].code == CodeVal) {
					districtObj = commonData.districts[i];
				}
			}
			return districtObj;
		}
		
		function getTehsilObj(CodeVal) {
			var tehsilsLen = commonData.tehsils.length;
			var tehsilObj = "";
			for(var i=0;i<tehsilsLen;i++) {
				if(commonData.tehsils[i].code == CodeVal) {
					tehsilObj = commonData.tehsils[i];
				}
			}
			return tehsilObj;
		}
	
    }
})();

/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);
	
  ProfilePageCtrl.$inject = ['$scope', 'fileReader', '$filter', '$uibModal','$stateParams', 'profileService', '$location', 'matchingprofilesService', 'commonService', '$http'];	

  /** @ngInject */
  function ProfilePageCtrl($scope, fileReader, $filter, $uibModal, $stateParams, profileService, $location, matchingprofilesService, commonService, $http) {
	  var profile = this;
	  
	// states
	$scope.states = commonService.states; 
	
	// districts      
	$scope.districts = commonService.districts; 

	// tehsils      
	$scope.tehsils = commonService.tehsils; 

	// getStateCities	
	//profile.getStateCities = getStateCities;
	  
    $scope.picture = $filter('profilePicture')('Nasta');
	console.log($stateParams);
	profile.profileId = $stateParams.ID;
	profile.isMatchingProfile = $stateParams.MATCHING_PROFILE;
	$scope.matchingProfileId = $stateParams.ID;
	$scope.requesterProfileId = $stateParams.REQUESTER_PROFILE_ID;
	//alert("$scope.requesterProfileId:"+$scope.requesterProfileId);
	console.log($scope.requesterProfileId);
	// REQUESTER_PROFILE_ID
	
	//alert("profile.profileId:"+profile.profileId+"; profile.isMatchingProfile:"+profile.isMatchingProfile);
	
	//alert('get profile for id nine : '+$stateParams.ID);
	$scope.userName = 'user hi aaa six';
	/*
	profile.profileDetials = profileService.getUserProfile(profile.profileId);
	console.log("before print profile.profileDetials");
	console.log(profile.profileDetials);
	console.log("after print profile.profileDetials");
	*/
	/*
	profileService.getUserProfile(profile.profileId).then(function (response) {
		alert("getUserProfile");
		console.log(response);
		$scope.data.orders = DataHelper.updateAllOrders(response.data);
	});
	*/
	
	profile.getStateCities = function(fieldId, fieldVal){
		/* debugger; */
		//alert("fieldVal:"+fieldVal);
		console.log("fieldId:"+fieldId); 
		if(fieldId.indexOf('req_') > -1) {
			$scope.req_cities = commonService.getStateCity(fieldVal);
		}
		else {
			$scope.cities = commonService.getStateCity(fieldVal);
			console.log("cities");
			console.log($scope.cities);
		}
	}
	// getSubCaste
	profile.getSubCaste = function(casteId,subCasteId){
		//alert("getSubCaste");
		/* debugger; */
		$http.get('http://www.sagaiwale.com/test_api/public/getsubcaste/?caste_id='+casteId).success(function (data) {
			  //alert('got subcaste eight');
			  console.log(data);
			  $scope.sub_caste_list = data.sub_caste_list;
			  $scope.sub_caste = subCasteId;
			  //console.log(data);
			  /*
			  $scope.registration.message = data.msg;
			  $timeout(function () {
				console.log($scope.registration);
				$location.path("/dashboard");
			  });
			  */
		});
		
		//$scope.sub_caste_list = commonService.getSubCaste($scope.registerInfo[fieldId]);
		//alert("$scope.sub_caste_list");
		console.log($scope.sub_caste_list);
	}
	
	$scope.refreshSubCaste = function(fieldId){
		//alert("getSubCaste seven");
		/* debugger; */
		$http.get('http://www.sagaiwale.com/test_api/public/getsubcaste/?caste_id='+$scope.registerInfo[fieldId]).success(function (data) {
			  //alert('got subcaste eight');
			  console.log(data);
			  $scope.sub_caste_list = data.sub_caste_list;
			  //$scope.sub_caste = subCasteId;
			  //console.log(data);
			  /*
			  $scope.registration.message = data.msg;
			  $timeout(function () {
				console.log($scope.registration);
				$location.path("/dashboard");
			  });
			  */
		});
		
		//$scope.sub_caste_list = commonService.getSubCaste($scope.registerInfo[fieldId]);
		//alert("$scope.sub_caste_list");
		console.log($scope.sub_caste_list);
	}
	
	profile.getCountryStates = function(fieldId, fieldVal){
	
		console.log("fieldId.indexOf('req_'):"+fieldId.indexOf('req_'));
		if(fieldId.indexOf('req_') > -1) {
			$scope.req_sates = [];
			console.log("value:"+fieldVal); 
			$scope.req_sates = commonService.getCountryState(fieldVal);
			$scope.req_cities =[];
		}
		else {
			$scope.sates = [];
			console.log("value:"+fieldVal); 
			$scope.sates = commonService.getCountryState(fieldVal);
			$scope.cities =[];
		}
	}
	
	$scope.countries = commonService.getCountry();

	$scope.getCountryStates = function(fieldId){
	
		alert("getCountryStates");
		
		console.log("fieldId.indexOf('req_'):"+fieldId.indexOf('req_'));
		if(fieldId.indexOf('req_') > -1) {
			$scope.req_sates = [];
			console.log("value:"+$scope.registerInfo[fieldId]); 
			$scope.req_sates = commonService.getCountryState($scope.registerInfo[fieldId]);
			$scope.req_cities =[];
		}
		else {
			$scope.sates = [];
			console.log("value:"+$scope.registerInfo[fieldId]); 
			$scope.sates = commonService.getCountryState($scope.registerInfo[fieldId]);
			$scope.cities =[];
		}
	}

	$scope.getStateCities = function(fieldId){
		/* debugger; */
		console.log("value:"+$scope.registerInfo[fieldId]); 
		if(fieldId.indexOf('req_') > -1) {
			$scope.req_cities = commonService.getStateCity($scope.registerInfo[fieldId]);
		}
		else {
			$scope.cities = commonService.getStateCity($scope.registerInfo[fieldId]);
		}
	}
	
	profileService.getUserProfileData(profile.profileId).then(function (response) {
	
		profile.getCountryStates('state', response.data.requests[0].state);
		profile.getStateCities('district', response.data.requests[0].district);
		
		profile.getCountryStates('req_state', response.data.requests[0].req_state);
		profile.getStateCities('req_district', response.data.requests[0].req_district);
		
		profile.getSubCaste(response.data.requests[0].caste,response.data.requests[0].sub_caste);
		
		
		$scope.userName = 'got user profile : '+profile.profileId;
	 	// var profileReqObj = response.data.requests[0];
		$scope.registerInfo = response.data.requests[0];
		$scope.registerInfo.req_age_from = parseInt($scope.registerInfo.req_age_from);
		$scope.registerInfo.req_age_to = parseInt($scope.registerInfo.req_age_to);
		/*
		$scope.registerInfo.state = commonService.getStateObj(response.data.requests[0].state);
		$scope.registerInfo.district = commonService.getDistrictObj(response.data.requests[0].district);
		$scope.registerInfo.tehsil = commonService.getTehsilObj(response.data.requests[0].tehsil);
		
		$scope.registerInfo.req_state = commonService.getStateObj(response.data.requests[0].req_state);
		$scope.registerInfo.req_district = commonService.getDistrictObj(response.data.requests[0].req_district);
		$scope.registerInfo.req_tehsil = commonService.getTehsilObj(response.data.requests[0].req_tehsil);
		*/
		// getCountryStates
		$scope.page = (profile.isMatchingProfile) ? 'matching_profile' : 'profile';
		//$scope.data.orders = profileService.updateRequests(response.data);
		console.log("$scope.registerInfo");
		console.log($scope.registerInfo);
	});

	$scope.getMatchingProfiles = function(ProfileType) {
		//alert("getMatchingProfiles seven");
		console.log($scope.registerInfo);
		console.log("matchingprofilesService.searchParams before");
		console.log(matchingprofilesService.searchParams);
		matchingprofilesService.searchParams = $scope.registerInfo;
		console.log("matchingprofilesService.profileType before");
		console.log(matchingprofilesService.profileType);
		matchingprofilesService.profileType = ProfileType;
		console.log("matchingprofilesService.searchParams after");
		console.log(matchingprofilesService.searchParams);
		console.log("matchingprofilesService.profileType after");
		console.log(matchingprofilesService.profileType);   
		//var earl = '/matchingprofiles'; 
		//alert("redirect to matchingprofiles")
		$location.path('/matchingprofiles');
		//var earl = '/register'; 
		//$location.path(earl);
		return;
	}	
	
    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function (idVal) {
		//alert("uploadPicture idVal:"+idVal);
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };
	
	$scope.getContact = function() {
		//alert("getContact");
	}

    $scope.socialProfiles = [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (requesterProfileId,contactingProfileId) {
		
		profileService.updateContactedProfile(requesterProfileId,contactingProfileId).then(function (response) {
			//$scope.data.orders = DataHelper.updateAllOrders(response.data);
			//alert("getUserProfile");
			//console.log(response);
			/*
			$scope.userName = 'got user profile : '+profile.profileId;
			$scope.registerInfo = response.data.requests[0];
			$scope.page = (profile.isMatchingProfile) ? 'matching_profile' : 'profile';
			//$scope.data.orders = profileService.updateRequests(response.data);
			*/
			alert("Contacted profile saved successfully!");
			window.history.go(-1);
			console.log(response);
			/*
			$uibModal.open({
				animation: false,
				controller: 'ProfileModalCtrl',
				templateUrl: 'app/pages/profile/profileModal.html'
			}).result.then(function (link) {
				  item.href = link;
				});
			*/	
		});	
		
		/*
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
          item.href = link;
        });
		*/
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
          .then(function (result) {
            $scope.picture = result;
          });
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.profile').service('profileService', profileService);

    profileService.$inject = ['$http', '$q'];
    function profileService($http,$q) {
        //var profile = {};
		var profile = this;
		//profile.profileDetails = {};
		/*
        var defer = $q.defer();
		
        //var isPayLater=false;
		//var trip = baseService.getTrip();
        profile.profileInfo = null;
        profile.profileInfo = function(){
        	if(onHoldObj.onHoldObjInfo){
        		return onHoldObj.onHoldObjInfo;
        	}else{
        		return defer.promise;
        	}

        }
		*/
        profile.getUserProfile=getUserProfile;
		profile.getUserProfileData=getUserProfileData;
		profile.updateContactedProfile=updateContactedProfile;
		profile.getProfile=getProfile;
		
		profile.getProfilesList=getProfilesList;
		profile.getMatchingProfiles=getMatchingProfiles;
		profile.profileData = [];
		profile.matchingProfileData = [];
		profile.saveContactedProfileResponse = ""; 
        return profile;
		
		function getProfile(ProfileId) {
			var data = {profile_id :ProfileId ,auth_token:""};
			return $http.post('http://www.sagaiwale.com/test_api/public/getrequests/?profile_id='+ProfileId);
		}
		
		function getUserProfileData(ProfileId) {
			if(profile.profileData.length == 0) {
				return profile.getProfile(ProfileId);
			}
			else {
				function createPromise(willSucceed) {
				  var deferred = $q.defer();
				  $timeout(function() {
					if (willSucceed) {
					  var response = {data: {requests:  profile.profileData }}
					  deferred.resolve(response);
					} else {
					  deferred.reject(response);
					}
				  });
				  return deferred.promise;
				}

				return createPromise(true);
			}
		}
		/*
		function getProfile(ProfileId) {
			var data = {profile_id :ProfileId ,auth_token:""};
			return $http.post('http://www.sagaiwale.com/test_api/public/getrequests/?profile_id='+ProfileId);
		}
		*/
		
		function updateContactedProfile(RequesterProfileId,ContactingProfileId) {
			if(profile.saveContactedProfileResponse == "") {
				var data = {requesterProfileId : RequesterProfileId,contactingProfileId : ContactingProfileId};
				return $http.post('http://www.sagaiwale.com/test_api/public/savecontactedprofile/',data);
			}
			else {
				function createPromise(willSucceed) {
				  var deferred = $q.defer();
				  $timeout(function() {
					if (willSucceed) {
					  var response = {data: profile.saveContactedProfileResponse }
					  deferred.resolve(response);
					} else {
					  deferred.reject(response);
					}
				  });
				  return deferred.promise;
				}

				return createPromise(true);
			}
		}
		
		function getProfilesList(searchParams) {
			//var data = {search :ProfileId ,auth_token:""};
			return $http.post('http://www.sagaiwale.com/test_api/public/getrequests/',searchParams);
		}
		
		function getMatchingProfiles(searchParams) {
			if(profile.matchingProfileData.length == 0) {
				
				/*
				$scope.userName = 'got user profile : '+profile.profileId;
				$scope.registerInfo = response.requests;// .data.requests[0];
				
				listProfileServiceObj.requests = result.data.requests;
				$rootScope.$broadcast('gotRequestsList'); 
				
				alert("$scope.registerInfo");
				console.log($scope.registerInfo);
				$scope.page = 'matching_profiles';
				*/
				/*var earl = '/dashboard'; 
				$location.path(earl);
				*/
			
				var requestListData = profile.getProfilesList(searchParams);
				
				//listProfileServiceObj.requests = requestListData;
				$rootScope.$broadcast('gotRequestsList',{requestsList : requestListData}); 
			}
			else {
				function createPromise(willSucceed) {
				  var deferred = $q.defer();
				  $timeout(function() {
					if (willSucceed) {
					  var response = {data: {requests:  profile.matchingProfileData }}
					  deferred.resolve(response);
					} else {
					  deferred.reject(response);
					}
				  });
				  return deferred.promise;
				}

				return createPromise(true);
			}
		}

        function getUserProfile(ProfileId){
        	//return $http.post('http://www.sagaiwale.com/api/public/getorders/?supplier_id='+supplierId);
			//var data = {avail_details: JSON.stringify(availDetails),supplier_id :supplierId ,auth_token:""};
			/*
			var data = {user_id :UserId};
			return $http.post('http://www.sagaiwale.com/api/public/getprofile/',data);
			*/
			//alert("UserId:"+UserId);
			var data = {profile_id :ProfileId ,auth_token:""};
			//return $http.post('http://www.sagaiwale.com/api/public/getavailability/',data);
			/*
			$http.post('http://www.sagaiwale.com/api/public/getavailability/',data).then(function(result) {
				console.log("result");
				console.log(result);
			   //return result.data;
			   
			   profile.profileDetails = result;
			});
			*/
			//}
			$http.post('http://www.sagaiwale.com/test_api/public/getrequests/',data).then(function(result) {
				
				//updateRequestsList(result);
				//alert("got profile six");
				console.log(result);
				return result.data.requests[0];
				/*
				$rootScope.$broadcast('refreshRequestsList'); 
				alert("got list of requests seven");
				console.log(result);
				listProfileServiceObj.requests = result.data.requests;
				$rootScope.$broadcast('refreshRequestsList'); 
				*/
			   //return;// result.data;
			   
			   //profile.profileDetails = result;
			});
        } 
		//return profile;	
    }
})();

/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.register')
        .controller('RegisterModalCtrl', SearchModalCtrl);

    /** @ngInject */
    function SearchModalCtrl($scope, $uibModalInstance) {
        $scope.link = '';
        $scope.ok = function () {
            $uibModalInstance.close($scope.link);
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.register')
        .controller('RegisterPageCtrl', RegisterPageCtrl);
		
	RegisterPageCtrl.$inject = ['$scope', 'fileReader', '$filter', '$uibModal', '$timeout', '$http', 'commonService', '$location'];		

    /** @ngInject */
    function RegisterPageCtrl($scope, fileReader, $filter, $uibModal, $timeout, $http, commonService, $location) {
        var vm = this;
		var register = this;
		
		//$scope.stateList = [{"id":"1", "name":"Rajasthan"}];
		// states
        $scope.states = commonService.states; 
		
		// districts      
        $scope.districts = commonService.districts; 

		// tehsils      
		$scope.tehsils = commonService.tehsils;
		
		//$scope.selectedDistrict = '{"district": {"code":'+registerInfo.district.code+'}}';

		
		//register.registerInfo = {};
		//alert("RegisterPageCtrl");
		$scope.userName = 'user hi aaa six';
		
		//register.registerUserdetails = registerUserdetails;
		
		//$scope.registerInfo = {};
		$scope.registerInfo ={
			Name:'', 
			state:'', 
			district: '', 
			City: ''
		};
		
		$scope.registerInfo.education = 'BE Six';
		$scope.educationVal = '111'; 
		// guardian_otp_generated
		$scope.registerInfo.guardian_otp_generated = 'no'; 
		$scope.registerInfo.previous_mobile_no = ''; 
		$scope.registerInfo.is_associate = 'no';

        vm.personalInfo = {};
        vm.productInfo = {};
        vm.shipment = {};

        vm.arePersonalInfoPasswordsEqual = function () {
            return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
        };


        $scope.picture = $filter('profilePicture')('Nasta');

        $scope.removePicture = function () {
            $scope.picture = $filter('appImage')('theme/no-photo.png');
            $scope.noPicture = true;
        };
		
		$scope.refreshCaptcha = function() {
			//alert("refreshCaptcha");
			var img = document.images['captchaimg'];
			// img.src = img.src.substring(0,img.src.lastIndexOf("?"))+"?rand="+Math.random()*1000;
			img.src = img.src+"?rand="+Math.random()*1000;
		}

        $scope.uploadPicture = function () {
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();

        };
		
		$scope.radioChanged = function(radioName,radioVal) {
			commonService.updateRadioValue($scope.registerInfo,radioName,radioVal);    
		}
		
		$scope.viewMoreDetails = function(linkObj) {
			//alert("viewMoreDetails six");
			//console.log("display:"+document.getElementById('moreDetails').style.display);
			if(document.getElementById('moreDetails').style.display == 'none') {
				//alert("display is none");
				document.getElementById('moreDetails').style.display = 'block';
				document.getElementById('moreDetailsId').innerHTML = "<a href='javascript:void(0);' style='text-decoration:underline !important;'>- More Details (Optional)</a>";//   <h3>- More Details (Optional)</h3>'; 
			}
			else {
				//alert("display is block");
				document.getElementById('moreDetails').style.display = 'none';
				document.getElementById('moreDetailsId').innerHTML = "<a href='javascript:void(0);' style='text-decoration:underline !important;'>+ More Details (Optional)</a>";//   <h3>+ More Details (Optional)</h3>'; 
			}
		}
		
		$scope.registerUser = function() {
			$scope.registrationSuccess = false; 
			if($scope.registerInfo.is_associate != 'yes') {
				$scope.registerInfo.associate_name = '';
				$scope.registerInfo.associate_no = '';
			}
			//register
			// alert("registerUser seven");
			console.log("$scope.registerInfo");
			
			console.log("$scope.registerInfo");
			console.log($scope.registerInfo);
			
			var validateOtp = (typeof $scope.registerInfo.associate_name != 'undefined' && $scope.registerInfo.associate_name.search("777") > 0) ? false : true;
			
			if($scope.registerInfo.guardian_contact_no != $scope.registerInfo.previous_mobile_no) {
				$scope.registerInfo.previous_mobile_no = $scope.registerInfo.guardian_contact_no;
				$scope.registerInfo.guardian_otp_generated = 'no'
			}
						
			console.log($scope.registerInfo);
			var info = $scope.registerInfo;// $scope.registerDetails;
			var errorMsgList = register.validateUserDetails(info);
			if(validateOtp && info.guardian_otp_generated == 'yes') {
				if(!info.guardian_otp) { 
					errorMsgList.push('Please enter OTP sent to your mobile');
				}
			}
				
			if(errorMsgList.length > 0) {
				$scope.errorMsg = errorMsgList;
				
				$('body,html').animate({
					scrollTop: 0
				}, 3000);
				//alert('Please correct the errors');
			}
			else {
				$scope.errorMsg = []; 
				$http.post('http://www.sagaiwale.com/test_api/public/registeruser/', info).success(function (data) {
					  
					 // alert("errorMsgList");
					  console.log(errorMsgList);
					  
					  if(data.status == 'success') { 
						// alert(data.msg+". Your registration id is : "+data.user_id);
						$scope.registrationSuccess = true; 
						$scope.registrationSuccessMsg = "Congrats! Your registration id is : "+data.user_id+" . We will contact you soon.";
						alert($scope.registrationSuccessMsg);
						$('body,html').animate({
							scrollTop: 0
						}, 3000);
						
						if($scope.registerInfo.is_associate != 'yes') {
							
							$location.path("/aboutus"); 
						}
					  }
					  if(data.status == 'failed') {
						
						//	alert(data.msg);
							$scope.errorMsg.push(data.msg);
						
					  }
					  else if(data.status == '1001') {
						$scope.registerInfo.guardian_otp_generated = 'yes';
						$scope.errorMsg.push(data.msg);
						//alert(data.msg);							
					  }
					  else {
						$scope.errorMsg = '';
					  }
					  /*
					  $scope.registration.message = data.msg;
					  $timeout(function () {
						console.log($scope.registration);
						$location.path("/dashboard");
					  });
					  */
				});
			}	
			
			//alert("$scope.errorMsg six");
			console.log($scope.errorMsg);
        };
		
		register.validateUserDetails = function(userInfo) {
		
			var errorList = [];
			if(!userInfo.profile_for) {
				errorList.push("Please select the value for Looking Sagai For");
			}
			if(!userInfo.gender) {
				errorList.push("Please select value for Gender");
			}
			if(!userInfo.guardian_name) {
				errorList.push("Please enter value for Name");
			}
			if(!userInfo.guardian_contact_no) {
				errorList.push("Please enter value for Contact Number");
			}
			/*
			if(!userInfo.age) {
				errorList.push("Please enter value for age");
			}
			if(!userInfo.education) {
				errorList.push("Please enter value for highest education");
			}
			if(!userInfo.height) {
				errorList.push("Please enter value for height");
			}
						
			if(!userInfo.employed) {
				errorList.push("Please select value for employed");
			}
			if(!userInfo.job_type) {
				errorList.push("Please select value for job_type");
			}
			*/
			
			/*
			if(!userInfo.address_1) {
				errorList.push("Please enter value for Address Line1");
			}
			if(!userInfo.address_2) {
				errorList.push("Please enter value for Address Line2");
			}
			if(!userInfo.state) {
				errorList.push("Please select value for state");
			}
			if(!userInfo.district) {
				errorList.push("Please select value for district");
			}
			if(!userInfo.tehsil) {
				errorList.push("Please select value for tehsil");
			}
			if(!userInfo.town) {
				errorList.push("Please enter value for town");
			}
			
			if(!userInfo.pin_code) {
				errorList.push("Please enter value for pin_code");
			}
			*/
			
			
			
			/*			
			if(!userInfo.religion) {
				errorList.push("Please select value for religion");
			}
			if(!userInfo.caste) {
				errorList.push("Please select value for caste");
			}
			if(!userInfo.sibling_details) {
				errorList.push("Please enter value for sibling details");
			}
			if(!userInfo.req_age_from) {
				errorList.push("Please enter value for requirement age from");
			}
			
			if(!userInfo.req_age_to) {
				errorList.push("Please enter value for requirement age to");
			}
			if(!userInfo.req_employed) {
				errorList.push("Please select value for requirement employed");
			}
			if(!userInfo.req_same_caste) {
				errorList.push("Please select value for requirement caste");
			}
			if(!userInfo.req_state) {
				errorList.push("Please select value for requirement state");
			}
			if(!userInfo.captcha_code) {
				errorList.push("Please enter value for security code");
			}
			*/
			//var errorListMsg = (errorList.length > 0) ? errorList.join('<br/>') : "";
			//alert("errorListMsg");
			//console.log(errorListMsg);
			return errorList;
		}
		
		$scope.getCaptchaImage = function() {
			
            $http.get('http://www.sagaiwale.com/test_api/public/getcaptcha/', {'user':100}).success(function (data) {
				  //alert('got captcha six');
				  //console.log(data);
				  /*
				  $scope.registration.message = data.msg;
				  $timeout(function () {
					console.log($scope.registration);
					$location.path("/dashboard");
				  });
				  */
			});
        };
		
		$scope.countries = {
			'India': {
				'Maharashtra': ['Pune', 'Mumbai', 'Nagpur', 'Akola'],
				'Madhya Pradesh': ['Indore', 'Bhopal', 'Jabalpur'],
				'Rajasthan': ['Jaipur', 'Ajmer', 'Jodhpur']
			},
			'USA': {
				'Alabama': ['Montgomery', 'Birmingham'],
				'California': ['Sacramento', 'Fremont'],
				'Illinois': ['Springfield', 'Chicago']
			},
			'Australia': {
				'New South Wales': ['Sydney'],
				'Victoria': ['Melbourne']
			}
		};
		
		$scope.states_6 = "USA";
		$scope.cities_6 = "California";
		
		$scope.getDistrictTehsils = function() {
			//alert("getDistrictTehsils nine");	
			console.log("district filter:"+'{district: {code: '+$scope.registerInfo.district.code+' }}');
			//$scope.tehsils = ($filter('filter')(commonService.tehsils, {district: {code: $scope.registerInfo.district.code }}));
			console.log("{district: $scope.registerInfo.district.code}:"+$scope.registerInfo.district.code);
			//id_val : '{ ID:'+  $scope.requestsList[i].id + '}'
			$scope.districtFilter =  "{district: '"+$scope.registerInfo.district.code+"'}";
			/*
			console.log("$scope.districtFilter:"+$scope.districtFilter);
			$scope.tehsils =  ($filter('filter')(commonService.tehsils, {district: $scope.registerInfo.district.code}));
			console.log("filtered tehsils eight");
			console.log($scope.tehsils);
			*/
			var tehsilsArr =  ($filter('filter')(commonService.tehsils, {district: $scope.registerInfo.district.code}));
			console.log("tehsilsArr");
			console.log(tehsilsArr);
			//$scope.cities =[];
			return;
		}

		$scope.countries = commonService.getCountry();
		// getProfileFor
		$scope.profileForList = commonService.getProfileFor();
		
		$scope.getCountryStates = function(fieldId){
			
			console.log("fieldId.indexOf('req_'):"+fieldId.indexOf('req_'));
			if(fieldId.indexOf('req_') > -1) {
				$scope.req_sates = [];
				console.log("value:"+$scope.registerInfo[fieldId]); 
				$scope.req_sates = commonService.getCountryState($scope.registerInfo[fieldId]);
				$scope.req_cities =[];
			}
			else {
				$scope.sates = [];
				console.log("value:"+$scope.registerInfo[fieldId]); 
				$scope.sates = commonService.getCountryState($scope.registerInfo[fieldId]);
				$scope.cities =[];
			}
		}
		
		$scope.profileForChanged = function() {
			if($scope.registerInfo.profile_for == 'SON' || $scope.registerInfo.profile_for == 'BROTHER') {
				$scope.registerInfo.gender = 'M';
			}
			else if($scope.registerInfo.profile_for == 'DAUGHTER' || $scope.registerInfo.profile_for == 'SISTER') {
				$scope.registerInfo.gender = 'F';
			}	
			else {
				$scope.registerInfo.gender = '';
			}
		}

		$scope.getStateCities = function(fieldId){
			/* debugger; */
			console.log("value:"+$scope.registerInfo[fieldId]); 
			if(fieldId.indexOf('req_') > -1) {
				
				console.log($scope.registerInfo[fieldId]);
				if($scope.registerInfo[fieldId].length == 1) {
					$scope.req_cities = commonService.getStateCity($scope.registerInfo[fieldId][0]);
				}
				else if($scope.registerInfo[fieldId].length > 1) {
					$scope.req_cities = [];
				}
			}
			else {
				$scope.cities = commonService.getStateCity($scope.registerInfo[fieldId]);
			}
		}
		
		$scope.getSubCaste = function(fieldId){
			/* debugger; */
			$http.get('http://www.sagaiwale.com/test_api/public/getsubcaste/?caste_id='+$scope.registerInfo[fieldId]).success(function (data) {
				  //alert('got getsubcaste seven');
				  console.log(data);
				  $scope.sub_caste_list = data.sub_caste_list;
				  //console.log(data);
				  /*
				  $scope.registration.message = data.msg;
				  $timeout(function () {
					console.log($scope.registration);
					$location.path("/dashboard");
				  });
				  */
			});
			
			//$scope.sub_caste_list = commonService.getSubCaste($scope.registerInfo[fieldId]);
			//alert("$scope.sub_caste_list");
			console.log($scope.sub_caste_list);
		}

        $scope.socialProfiles = [
            {
                name: 'Facebook',
                href: 'https://www.facebook.com/akveo/',
                icon: 'socicon-facebook'
            },
            {
                name: 'Twitter',
                href: 'https://twitter.com/akveo_inc',
                icon: 'socicon-twitter'
            },
            {
                name: 'Google',
                icon: 'socicon-google'
            },
            {
                name: 'LinkedIn',
                href: 'https://www.linkedin.com/company/akveo',
                icon: 'socicon-linkedin'
            },
            {
                name: 'GitHub',
                href: 'https://github.com/akveo',
                icon: 'socicon-github'
            },
            {
                name: 'StackOverflow',
                icon: 'socicon-stackoverflow'
            },
            {
                name: 'Dribbble',
                icon: 'socicon-dribble'
            },
            {
                name: 'Behance',
                icon: 'socicon-behace'
            }
        ];

        $scope.unconnect = function (item) {
            item.href = undefined;
        };

        $scope.showModal = function (item) {
            $uibModal.open({
                animation: false,
                controller: 'RegisterModalCtrl',
                templateUrl: 'app/pages/register/RegisterModal.html'
            }).result.then(function (link) {
                item.href = link;
            });
        };

        $scope.getFile = function () {
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function (result) {
                    $scope.picture = result;
                });
        };

        $scope.switches = [true, true, false, true, true, false];
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables')
      .controller('TablesPageCtrl', TablesPageCtrl);

  /** @ngInject */
  function TablesPageCtrl($scope, $filter, editableOptions, editableThemes) {

    $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);
	  
	BlurFeedCtrl.$inject = ['$scope', '$location', 'listProfileService'];	  

  /** @ngInject */
  function BlurFeedCtrl($scope,$location,listProfileService) {
	var blurFeedCtrl = this;
	//var requestsList = '';// 
	blurFeedCtrl.refreshRequestsList = refreshRequestsList;
	$scope.requests = [];
	/*
	if(typeof($scope.requestsList) != 'undefined') {
		refreshRequestsList();
	}
	*/
	listProfileService.listUserProfiles();
	/*
	$scope.requestsList = [];
	$scope.requestsList = listProfileService.listUserProfiles();	
	// $scope.requests = requestsList.requests;
	console.log("$scope.requestsList");
	console.log($scope.requestsList);
	
	var totalRequests = $scope.requestsList.requests.length;
	//$scope.requests = [];
	for(var i=0;i<totalRequests;i++) {
		$scope.requests.push(
			{
				type: 'text-message',
				author: $scope.requestsList.requests[i].guardian_name, // 'Kostya',
				surname: 'Danovsky',
				header: 'Looking for '+$scope.requestsList.requests[i].looking_for, // 'Posted new message',
				text: $scope.requestsList.requests[i].sibling_details, // 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
				time: $scope.requestsList.requests[i].date_created,// 'Today 11:55 pm',
				ago: '25 minutes ago',
				expanded: false,
			}
		);
	}
	*/
	
	/*
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];
	*/

    $scope.expandMessage = function(message){
      //message.expanded = !message.expanded;
	  ////alert('load profile page six');
		var earl = '/profile?ID=100'; 
		$location.path(earl);
    }
	
	$scope.$on('gotRequestsList', function (event, args) {
		////alert(args.requestsList);
       	blurFeedCtrl.refreshRequestsList();
		////alert("gotRequestsList");
    });
	
	function refreshRequestsList() {
		//alert("listProfileServiceObj.requestsList");
		$scope.requestsList = [];

		$scope.requestsList = listProfileService.requests; // listProfileService.listUserProfiles();	
		// $scope.requests = requestsList.requests;
		console.log("$scope.requestsList");
		console.log($scope.requestsList);
		
		var totalRequests = $scope.requestsList.length;
		//$scope.requests = [];
		for(var i=0;i<totalRequests;i++) {
			$scope.requests.push(
				{
					id_val : '{ ID:'+  $scope.requestsList[i].id + '}' ,
					type: 'text-message',
					author: 'Kostya',
					guardian_name: $scope.requestsList[i].guardian_name, // 'Kostya',
					surname: 'Danovsky',
					header: 'looking for '+($scope.requestsList[i].looking_for == 'M' ? 'Boy' : 'Girl'), // 'Posted new message',
					text: $scope.requestsList[i].sibling_details, // 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
					time: $scope.requestsList[i].date_created,// 'Today 11:55 pm',
					ago: '25 minutes ago',
					expanded: false,
				}
			);
		}
		console.log("$scope.requests in controler");
		console.log($scope.requests);
	}
  }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.profile').service('listProfileService', listProfileService);

    listProfileService.$inject = ['$rootScope','$http', '$q'];
    function listProfileService($rootScope,$http,$q) {
        //var profile = {};
		var listProfileServiceObj = this;
		listProfileServiceObj.requests = [];
		//profile.profileDetails = {};
		/*
        var defer = $q.defer();
		
        //var isPayLater=false;
		//var trip = baseService.getTrip();
        profile.profileInfo = null;
        profile.profileInfo = function(){
        	if(onHoldObj.onHoldObjInfo){
        		return onHoldObj.onHoldObjInfo;
        	}else{
        		return defer.promise;
        	}

        }
		*/
        listProfileServiceObj.listUserProfiles=listUserProfiles;
		//listProfileServiceObj.updateRequestsList=updateRequestsList;
			
		//listUserProfiles();
        return listProfileServiceObj;

        function listUserProfiles(){
        	
			var data = {supplier_id :"" ,auth_token:""};
			//return $http.post('http://www.sagaiwale.com/api/public/getavailability/',data);
			$http.post('http://www.sagaiwale.com/test_api/public/getrequests/',data).then(function(result) {
				
				updateRequestsList(result);
				/*
				$rootScope.$broadcast('refreshRequestsList'); 
				alert("got list of requests seven");
				console.log(result);
				listProfileServiceObj.requests = result.data.requests;
				$rootScope.$broadcast('refreshRequestsList'); 
				*/
			   return;// result.data;
			   
			   //profile.profileDetails = result;
			});
			
			//}
        } 
		
		function updateRequestsList(result) {
			//$rootScope.$broadcast('refreshRequestsList'); 
			console.log($rootScope);
			//alert("got list of requests nine");
			console.log(result);
			listProfileServiceObj.requests = result.data.requests;
			$rootScope.$broadcast('gotRequestsList'); 
		}
		//return profile;	
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    var dashboardColors = baConfig.colors.dashboard;
    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      defaultDate: '2016-03-08',
      selectable: true,
      selectHelper: true,
      select: function (start, end) {
        var title = prompt('Event Title:');
        var eventData;
        if (title) {
          eventData = {
            title: title,
            start: start,
            end: end
          };
          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
        }
        $element.fullCalendar('unselect');
      },
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      events: [
        {
          title: 'All Day Event',
          start: '2016-03-01',
          color: dashboardColors.silverTree
        },
        {
          title: 'Long Event',
          start: '2016-03-07',
          end: '2016-03-10',
          color: dashboardColors.blueStone
        },
        {
          title: 'Dinner',
          start: '2016-03-14T20:00:00',
          color: dashboardColors.surfieGreen
        },
        {
          title: 'Birthday Party',
          start: '2016-04-01T07:00:00',
          color: dashboardColors.gossipDark
        }
      ]
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/pages/dashboard/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'MM YYYY',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'MM YYYY',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var map = AmCharts.makeChart('amChartMap', {
      type: 'map',
      theme: 'blur',
      zoomControl: { zoomControlEnabled: false, panControlEnabled: false },

      dataProvider: {
        map: 'worldLow',
        zoomLevel: 3.5,
        zoomLongitude: 10,
        zoomLatitude: 52,
        areas: [
          { title: 'Austria', id: 'AT', color: layoutColors.primary, customData: '1 244', groupId: '1'},
          { title: 'Ireland', id: 'IE', color: layoutColors.primary, customData: '1 342', groupId: '1'},
          { title: 'Denmark', id: 'DK', color: layoutColors.primary, customData: '1 973', groupId: '1'},
          { title: 'Finland', id: 'FI', color: layoutColors.primary, customData: '1 573', groupId: '1'},
          { title: 'Sweden', id: 'SE', color: layoutColors.primary, customData: '1 084', groupId: '1'},
          { title: 'Great Britain', id: 'GB', color: layoutColors.primary, customData: '1 452', groupId: '1'},
          { title: 'Italy', id: 'IT', color: layoutColors.primary, customData: '1 321', groupId: '1'},
          { title: 'France', id: 'FR', color: layoutColors.primary, customData: '1 112', groupId: '1'},
          { title: 'Spain', id: 'ES', color: layoutColors.primary, customData: '1 865', groupId: '1'},
          { title: 'Greece', id: 'GR', color: layoutColors.primary, customData: '1 453', groupId: '1'},
          { title: 'Germany', id: 'DE', color: layoutColors.primary, customData: '1 957', groupId: '1'},
          { title: 'Belgium', id: 'BE', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Luxembourg', id: 'LU', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Netherlands', id: 'NL', color: layoutColors.primary, customData: '1 213', groupId: '1'},
          { title: 'Portugal', id: 'PT', color: layoutColors.primary, customData: '1 291', groupId: '1'},
          { title: 'Lithuania', id: 'LT', color: layoutColors.successLight, customData: '567', groupId: '2'},
          { title: 'Latvia', id: 'LV', color: layoutColors.successLight, customData: '589', groupId: '2'},
          { title: 'Czech Republic ', id: 'CZ', color: layoutColors.successLight, customData: '785', groupId: '2'},
          { title: 'Slovakia', id: 'SK', color: layoutColors.successLight, customData: '965', groupId: '2'},
          { title: 'Estonia', id: 'EE', color: layoutColors.successLight, customData: '685', groupId: '2'},
          { title: 'Hungary', id: 'HU', color: layoutColors.successLight, customData: '854', groupId: '2'},
          { title: 'Cyprus', id: 'CY', color: layoutColors.successLight, customData: '754', groupId: '2'},
          { title: 'Malta', id: 'MT', color: layoutColors.successLight, customData: '867', groupId: '2'},
          { title: 'Poland', id: 'PL', color: layoutColors.successLight, customData: '759', groupId: '2'},
          { title: 'Romania', id: 'RO', color: layoutColors.success, customData: '302', groupId: '3'},
          { title: 'Bulgaria', id: 'BG', color: layoutColors.success, customData: '102', groupId: '3'},
          { title: 'Slovenia', id: 'SI', color: layoutColors.danger, customData: '23', groupId: '4'},
          { title: 'Croatia', id: 'HR', color: layoutColors.danger, customData: '96', groupId: '4'}
        ]
      },

      areasSettings: {
        rollOverOutlineColor: layoutColors.border,
        rollOverColor: layoutColors.primaryDark,
        alpha: 0.8,
        unlistedAreasAlpha: 0.2,
        unlistedAreasColor: layoutColors.defaultText,
        balloonText: '[[title]]: [[customData]] users'
      },


      legend: {
        width: '100%',
        marginRight: 27,
        marginLeft: 27,
        equalWidths: false,
        backgroundAlpha: 0.3,
        backgroundColor: layoutColors.border,
        borderColor: layoutColors.border,
        borderAlpha: 1,
        top: 362,
        left: 0,
        horizontalGap: 10,
        data: [
          {
            title: 'over 1 000 users',
            color: layoutColors.primary
          },
          {
            title: '500 - 1 000 users',
            color: layoutColors.successLight
          },
          {
            title: '100 - 500 users',
            color: layoutColors.success
          },
          {
            title: '0 - 100 users',
            color: layoutColors.danger
          }
        ]
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

    /** @ngInject */
    function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
        var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
        $scope.charts = [{
            color: pieColor,
            description: 'New Visits',
            stats: '57,820',
            icon: 'person',
        }, {
            color: pieColor,
            description: 'Active',
            stats: '178,391',
            icon: 'face',
        },
            {
                color: pieColor,
                description: 'In Active',
                stats: '32,000',
                icon: 'face',
            }, {
                color: pieColor,
                description: 'Matches',
                stats: '32,592',
                icon: 'refresh',
            }
        ];

        function getRandomArbitrary(min, max) {
            return Math.random() * (max - min) + min;
        }

        function loadPieCharts() {
            $('.chart').each(function () {
                var chart = $(this);
                chart.easyPieChart({
                    easing: 'easeOutBounce',
                    onStep: function (from, to, percent) {
                        $(this.el).find('.percent').text(Math.round(percent));
                    },
                    barColor: chart.attr('rel'),
                    trackColor: 'rgba(0,0,0,0)',
                    size: 84,
                    scaleLength: 0,
                    animation: 2000,
                    lineWidth: 9,
                    lineCap: 'round',
                });
            });

            $('.refresh-data').on('click', function () {
                updatePieCharts();
            });
        }

        function updatePieCharts() {
            $('.pie-charts .chart').each(function (index, chart) {
                $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
            });
        }

        $timeout(function () {
            loadPieCharts();
            updatePieCharts();
        }, 1000);
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/pages/dashboard/dashboardTodo/dashboardTodo.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('popularApp', popularApp);

  /** @ngInject */
  function popularApp() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/dashboard/popularApp/popularApp.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    $scope.doughnutData = [
      {
        value: 2000,
        color: dashboardColors.white,
        highlight: colorHelper.shade(dashboardColors.white, 15),
        label: 'Other',
        percentage: 87,
        order: 1,
      }, {
        value: 1500,
        color: dashboardColors.blueStone,
        highlight: colorHelper.shade(dashboardColors.blueStone, 15),
        label: 'Search engines',
        percentage: 22,
        order: 4,
      }, {
        value: 1000,
        color: dashboardColors.surfieGreen,
        highlight: colorHelper.shade(dashboardColors.surfieGreen, 15),
        label: 'Referral Traffic',
        percentage: 70,
        order: 3,
      }, {
        value: 1200,
        color: dashboardColors.silverTree,
        highlight: colorHelper.shade(dashboardColors.silverTree, 15),
        label: 'Direct Traffic',
        percentage: 38,
        order: 2,
      }, {
        value: 400,
        color: dashboardColors.gossip,
        highlight: colorHelper.shade(dashboardColors.gossip, 15),
        label: 'Ad Campaigns',
        percentage: 17,
        order: 0,
      },
    ];

    var ctx = document.getElementById('chart-area').getContext('2d');
    window.myDoughnut = new Chart(ctx).Doughnut($scope.doughnutData, {
      segmentShowStroke: false,
      percentageInnerCutout : 64,
      responsive: true
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/dashboard/weather/weather.html'
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('WizardCtrl', WizardCtrl);

  /** @ngInject */
  function WizardCtrl($scope) {
   var vm = this;

    vm.personalInfo = {};
    vm.productInfo = {};
    vm.shipment = {};

    vm.arePersonalInfoPasswordsEqual = function () {
      return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
    };
  }

})();


/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons')
      .controller('ButtonPageCtrl', ButtonPageCtrl);

  /** @ngInject */
  function ButtonPageCtrl($scope, $timeout) {
    $scope.progressFunction = function() {
      return $timeout(function() {}, 3000);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons')
      .controller('IconsPageCtrl', IconsPageCtrl);

  /** @ngInject */
  function IconsPageCtrl($scope) {
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Beach',
          img: 'Beach'
        },
        {
          name: 'Bus',
          img: 'Bus'
        },
        {
          name: 'Cheese',
          img: 'Cheese'
        },
        {
          name: 'Desert',
          img: 'Desert'
        },
        {
          name: 'Images',
          img: 'Images'
        },
        {
          name: 'Magician',
          img: 'Magician'
        },
        {
          name: 'Makeup',
          img: 'Makeup'
        },
        {
          name: 'Programming',
          img: 'Programming'
        },
        {
          name: 'Shop',
          img: 'Shop'
        },
        {
          name: 'Surfer',
          img: 'Surfer'
        },
        {
          name: 'Phone Booth',
          img: 'Phone-Booth'
        },
        {
          name: 'Ninja',
          img: 'Ninja'
        },
        {
          name: 'Apartment',
          img: 'Apartment'
        },
        {
          name: 'Batman',
          img: 'Batman'
        },
        {
          name: 'Medal',
          img: 'Medal-2'
        },
        {
          name: 'Money',
          img: 'Money-Increase'
        },
        {
          name: 'Street View',
          img: 'Street-View'
        },
        {
          name: 'Student',
          img: 'Student-3'
        },
        {
          name: 'Bell',
          img: 'Bell'
        },
        {
          name: 'Woman',
          img: 'Boss-5'
        },
        {
          name: 'Euro',
          img: 'Euro-Coin'
        },
        {
          name: 'Chessboard',
          img: 'Chessboard'
        },
        {
          name: 'Burglar',
          img: 'Burglar'
        },
        {
          name: 'Dna',
          img: 'Dna'
        },
        {
          name: 'Clipboard Plan',
          img: 'Clipboard-Plan'
        },
        {
          name: 'Boss',
          img: 'Boss-3'
        },
        {
          name: 'Key',
          img: 'Key'
        },
        {
          name: 'Surgeon',
          img: 'Surgeon'
        },
        {
          name: 'Hacker',
          img: 'Hacker'
        },
        {
          name: 'Santa',
          img: 'Santa'
        }
      ],
      kameleonRoundedIcons: [
        {
          color: 'success',
          img: 'Apartment',
          name: 'Apartment'
        },
        {
          color: 'warning',
          img: 'Bus',
          name: 'Bus'
        },
        {
          color: 'primary',
          img: 'Checklist',
          name: 'Checklist'
        },
        {
          color: 'warning',
          img: 'Desert',
          name: 'Desert'
        },
        {
          color: 'danger',
          img: 'Laptop-Signal',
          name: 'Laptop Signal'
        },
        {
          color: 'info',
          img: 'Love-Letter',
          name: 'Love Letter'
        },
        {
          color: 'success',
          img: 'Makeup',
          name: 'Makeup'
        },
        {
          color: 'primary',
          img: 'Santa',
          name: 'Santa'
        },
        {
          color: 'success',
          img: 'Surfer',
          name: 'Surfer'
        },
        {
          color: 'info',
          img: 'Vector',
          name: 'Vector'
        },
        {
          color: 'warning',
          img: 'Money-Increase',
          name: 'Money Increase'
        },
        {
          color: 'info',
          img: 'Alien',
          name: 'Alien'
        },
        {
          color: 'danger',
          img: 'Online-Shopping',
          name: 'Online Shopping'
        },
        {
          color: 'warning',
          img: 'Euro-Coin',
          name: 'Euro'
        },
        {
          color: 'info',
          img: 'Boss-3',
          name: 'Boss'
        }
      ],
      ionicons: ['ion-ionic', 'ion-arrow-right-b', 'ion-arrow-down-b', 'ion-arrow-left-b', 'ion-arrow-up-c', 'ion-arrow-right-c', 'ion-arrow-down-c', 'ion-arrow-left-c', 'ion-arrow-return-right', 'ion-arrow-return-left', 'ion-arrow-swap', 'ion-arrow-shrink', 'ion-arrow-expand', 'ion-arrow-move', 'ion-arrow-resize', 'ion-chevron-up', 'ion-chevron-right', 'ion-chevron-down', 'ion-chevron-left', 'ion-navicon-round', 'ion-navicon', 'ion-drag', 'ion-log-in', 'ion-log-out', 'ion-checkmark-round', 'ion-checkmark', 'ion-checkmark-circled', 'ion-close-round', 'ion-plus-round', 'ion-minus-round', 'ion-information', 'ion-help', 'ion-backspace-outline', 'ion-help-buoy', 'ion-asterisk', 'ion-alert', 'ion-alert-circled', 'ion-refresh', 'ion-loop', 'ion-shuffle', 'ion-home', 'ion-search', 'ion-flag', 'ion-star', 'ion-heart', 'ion-heart-broken', 'ion-gear-a', 'ion-gear-b', 'ion-toggle-filled', 'ion-toggle', 'ion-settings', 'ion-wrench', 'ion-hammer', 'ion-edit', 'ion-trash-a', 'ion-trash-b', 'ion-document', 'ion-document-text', 'ion-clipboard', 'ion-scissors', 'ion-funnel', 'ion-bookmark', 'ion-email', 'ion-email-unread', 'ion-folder', 'ion-filing', 'ion-archive', 'ion-reply', 'ion-reply-all', 'ion-forward'],
      fontAwesomeIcons: ['fa fa-adjust', 'fa fa-anchor', 'fa fa-archive', 'fa fa-area-chart', 'fa fa-arrows', 'fa fa-arrows-h', 'fa fa-arrows-v', 'fa fa-asterisk', 'fa fa-at', 'fa fa-automobile', 'fa fa-ban', 'fa fa-bank', 'fa fa-bar-chart', 'fa fa-bar-chart-o', 'fa fa-barcode', 'fa fa-bars', 'fa fa-bed', 'fa fa-beer', 'fa fa-bell', 'fa fa-bell-o', 'fa fa-bell-slash', 'fa fa-bell-slash-o', 'fa fa-bicycle', 'fa fa-binoculars', 'fa fa-birthday-cake', 'fa fa-bolt', 'fa fa-bomb', 'fa fa-book', 'fa fa-bookmark', 'fa fa-bookmark-o', 'fa fa-briefcase', 'fa fa-bug', 'fa fa-building', 'fa fa-building-o', 'fa fa-bullhorn'],
      socicon: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ',', ';', ':', '+', '@', '=', '-', '^', '?', '$', '*', '&', '(', '#', '.', '_', ']', ')', '\'', '"', '}', '{']
    }
  }

})();

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal) {
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, toastr, toastrConfig) {
    var defaultConfig = angular.copy(toastrConfig);
    $scope.types = ['success', 'error', 'info', 'warning'];

    $scope.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Looking for bootstrap?',
        message: 'Try ui-bootstrap out!'
      },
      {
        title: 'Wants a better router?',
        message: 'We have you covered with ui-router'
      },
      {
        title: 'Angular 2',
        message: 'Is gonna rock the world'
      },
      {
        title: null,
        message: 'Titles are not always needed'
      },
      {
        title: null,
        message: 'Toastr rock!'
      },
      {
        title: 'What about nice html?',
        message: '<strong>Sure you <em>can!</em></strong>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Ionic is <em>cool</em>',
        message: 'Best mobile framework ever',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    $scope.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      type: 'info',
      timeOut: '5000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: false,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      title: "Some title here",
      msg: "Type your message here"
    };


    $scope.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    $scope.clearToasts = function () {
      toastr.clear();
    };

    $scope.openRandomToast = function () {
      var type = Math.floor(Math.random() * $scope.types.length);
      var quote = Math.floor(Math.random() * $scope.quotes.length);
      var toastType = $scope.types[type];
      var toastQuote = $scope.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      $scope.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    $scope.openToast = function () {
      angular.extend(toastrConfig, $scope.options);
      openedToasts.push(toastr[$scope.options.type]($scope.options.msg, $scope.options.title));
      var strOptions = {};
      for (var o in  $scope.options) if (o != 'msg' && o != 'title')strOptions[o] = $scope.options[o];
      $scope.optionsStr = "toastr." + $scope.options.type + "(\'" + $scope.options.msg + "\', \'" + $scope.options.title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
      angular.extend(toastrConfig, defaultConfig);
    })
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
/**
 * @author v.lugovsky
 * created on 22.04.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('SelectpickerPanelCtrl', SelectpickerPanelCtrl);

  /** @ngInject */
  function SelectpickerPanelCtrl() {
    var vm = this;

    vm.standardSelectItems = [
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
      { label: 'Option 4', value: 4 },
    ];

    vm.selectWithSearchItems = [
      { label: 'Hot Dog, Fries and a Soda', value: 1 },
      { label: 'Burger, Shake and a Smile', value: 2 },
      { label: 'Sugar, Spice and all things nice', value: 3 },
      { label: 'Baby Back Ribs', value: 4 },
    ];

    vm.groupedSelectItems = [
      { label: 'Group 1 - Option 1', value: 1, group: 'Group 1' },
      { label: 'Group 2 - Option 2', value: 2, group: 'Group 2' },
      { label: 'Group 1 - Option 3', value: 3, group: 'Group 1' },
      { label: 'Group 2 - Option 4', value: 4, group: 'Group 2' },
    ];

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
/**
 * @author v.lugovsky
 * created on 07.06.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('SwitchPanelCtrl', SwitchPanelCtrl);

  /** @ngInject */
  function SwitchPanelCtrl() {
    var vm = this;

    vm.switcherValues = {
      primary: true,
      warning: true,
      danger: true,
      info: true,
      success: true
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        $timeout(function(){
          var input = $(elem).find('input');
          input.bootstrapSwitch({
            size: 'small',
            onColor: attr.color
          });
          input.on('switchChange.bootstrapSwitch', function(event, state) {
            scope.ngModel = state;
            scope.$apply();
          });

        });
      }
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      link: function( $scope, elem, attr) {
        $(elem).tagsinput({
          tagClass:  'label label-' + attr.tagInput
        });
      }
    };
  }
})();
angular.module("BlurAdmin").run(["$templateCache", function($templateCache) {$templateCache.put("app/pages/aboutus/aboutus.html","<div ba-panel=\"\" ba-panel-class=\"search-page\"><div class=\"panel-content\"><div class=\"row\"><div class=\"col-md-6\" style=\"line-height:2.5em;font-size: 16px;\">SagaiWale.com &#2319;&#2325; &#2309;&#2344;&#2369;&#2349;&#2357;&#2368; &#2357; &#2346;&#2381;&#2352;&#2358;&#2367;&#2325;&#2381;&#2359;&#2367;&#2340; &#2354;&#2379;&#2327;&#2379;&#2306; &#2325;&#2368; &#2335;&#2368;&#2350; &#2361;&#2376;. &#2351;&#2361; &#2357;&#2375;&#2348;&#2360;&#2366;&#2311;&#2335; &#2360;&#2367;&#2352;&#2381;&#2347;&#2364; &#2352;&#2366;&#2332;&#2360;&#2381;&#2341;&#2366;&#2344; &#2325;&#2375; &#2354;&#2367;&#2319; &#2360;&#2350;&#2352;&#2381;&#2346;&#2367;&#2340; &#2361;&#2376;. &#2361;&#2350;&#2366;&#2352;&#2366; &#2360;&#2367;&#2352;&#2381;&#2347;&#2364; &#2319;&#2325; &#2361;&#2368; &#2354;&#2325;&#2381;&#2359;&#2381;&#2351; &#2361;&#2376; \"&#2352;&#2366;&#2332;&#2360;&#2381;&#2341;&#2366;&#2344; &#2325;&#2375; &#2361;&#2352; &#2309;&#2349;&#2367;&#2349;&#2366;&#2357;&#2325; &#2325;&#2375; &#2348;&#2330;&#2381;&#2330;&#2379;&#2306; &#2325;&#2375; &#2354;&#2367;&#2319; &#2309;&#2330;&#2381;&#2331;&#2375; &#2360;&#2375; &#2309;&#2330;&#2381;&#2331;&#2366; &#2352;&#2367;&#2358;&#2381;&#2340;&#2366; &#2338;&#2370;&#2305;&#2338;&#2344;&#2366;\". &#2310;&#2346;&#2325;&#2368; &#2332;&#2366;&#2344;&#2325;&#2366;&#2352;&#2368; &#2361;&#2350;&#2375;&#2358;&#2366; &#2327;&#2379;&#2346;&#2344;&#2368;&#2351; &#2352;&#2326;&#2368; &#2332;&#2366;&#2319;&#2327;&#2368;. &#2309;&#2327;&#2352; &#2310;&#2346; &#2325;&#2379;&#2312; &#2352;&#2367;&#2358;&#2381;&#2340;&#2366; &#2346;&#2360;&#2306;&#2342; &#2325;&#2352;&#2340;&#2375; &#2361;&#2376;&#2306; &#2360;&#2367;&#2352;&#2381;&#2347;&#2364; &#2340;&#2348; &#2310;&#2346;&#2325;&#2366; &#2346;&#2340;&#2366; &#2357; &#2347;&#2379;&#2344; &#2344;&#2306;&#2348;&#2352; &#2352;&#2367;&#2358;&#2381;&#2340;&#2375;&#2357;&#2366;&#2354;&#2379; &#2325;&#2379; &#2349;&#2375;&#2332;&#2366; &#2332;&#2366;&#2319;&#2327;&#2366;. &#2361;&#2350;&#2366;&#2352;&#2375; &#2346;&#2366;&#2360; &#2361;&#2332;&#2364;&#2366;&#2352;&#2379;&#2306; &#2309;&#2349;&#2367;&#2349;&#2366;&#2357;&#2325; &#2352;&#2367;&#2332;&#2367;&#2360;&#2381;&#2335;&#2352;&#2381;&#2337; &#2361;&#2376;&#2306; &#2332;&#2379; &#2309;&#2346;&#2344;&#2375; &#2348;&#2330;&#2381;&#2330;&#2379;&#2306; &#2325;&#2375; &#2354;&#2367;&#2319; &#2358;&#2381;&#2352;&#2375;&#2359;&#2381;&#2336; &#2352;&#2367;&#2358;&#2381;&#2340;&#2366; &#2338;&#2370;&#2305;&#2338;&#2344;&#2366; &#2330;&#2366;&#2361;&#2340;&#2375; &#2361;&#2376;&#2306;, &#2332;&#2376;&#2360;&#2375; &#2325;&#2368; &#2360;&#2352;&#2325;&#2366;&#2352;&#2368; &#2344;&#2380;&#2325;&#2352;&#2368; &#2357;&#2366;&#2354;&#2375;, &#2346;&#2381;&#2352;&#2366;&#2311;&#2357;&#2375;&#2335; &#2344;&#2380;&#2325;&#2352;&#2368; &#2357;&#2366;&#2354;&#2375;, &#2348;&#2367;&#2332;&#2364;&#2381;&#2344;&#2375;&#2360;&#2381;&#2350;&#2375;&#2344; &#2310;&#2342;&#2367;. &#2361;&#2350;&#2366;&#2352;&#2368; &#2335;&#2368;&#2350; &#2310;&#2346;&#2325;&#2368; &#2310;&#2357;&#2358;&#2381;&#2351;&#2325;&#2340;&#2366; &#2325;&#2375; &#2309;&#2344;&#2369;&#2360;&#2366;&#2352; &#2311;&#2344; &#2352;&#2367;&#2332;&#2367;&#2360;&#2381;&#2335;&#2352;&#2381;&#2337; &#2352;&#2367;&#2358;&#2381;&#2340;&#2379;&#2306; &#2350;&#2375;&#2306; &#2360;&#2375; &#2358;&#2381;&#2352;&#2375;&#2359;&#2381;&#2336; &#2352;&#2367;&#2358;&#2381;&#2340;&#2366; &#2338;&#2370;&#2305;&#2338;&#2325;&#2352; &#2310;&#2346;&#2325;&#2379; &#2347;&#2379;&#2344; &#2325;&#2352;&#2325;&#2375; &#2348;&#2340;&#2366;&#2319;&#2327;&#2368;. &#2361;&#2350; &#2310;&#2346;&#2360;&#2375; &#2325;&#2369;&#2331; &#2344;&#2361;&#2368;&#2306; &#2331;&#2369;&#2346;&#2366;&#2319;&#2305;&#2327;&#2375;, &#2309;&#2327;&#2352; &#2310;&#2346;&#2325;&#2379; &#2352;&#2367;&#2358;&#2381;&#2340;&#2366; &#2346;&#2360;&#2306;&#2342; &#2361;&#2376; &#2340;&#2379; &#2313;&#2360;&#2325;&#2366; &#2346;&#2340;&#2366; &#2357; &#2347;&#2379;&#2344; &#2344;&#2306;&#2348;&#2352; &#2310;&#2346;&#2325;&#2379; &#2349;&#2375;&#2332; &#2342;&#2367;&#2351;&#2366; &#2332;&#2366;&#2319;&#2327;&#2366;, &#2310;&#2346; &#2328;&#2352; &#2332;&#2366;&#2325;&#2352; &#2310;&#2350;&#2344;&#2375; &#2360;&#2366;&#2350;&#2344;&#2375; &#2348;&#2376;&#2336;&#2325;&#2352; &#2348;&#2366;&#2340; &#2325;&#2352;&#2375;&#2306; &#2357; &#2340;&#2351; &#2325;&#2352;&#2375;&#2306;. &#2309;&#2327;&#2352; &#2310;&#2346;&#2325;&#2379; &#2352;&#2367;&#2358;&#2381;&#2340;&#2366; &#2346;&#2360;&#2306;&#2342; &#2344;&#2366; &#2310;&#2319; &#2340;&#2379; &#2361;&#2350; &#2310;&#2346;&#2325;&#2379; &#2324;&#2352; &#2352;&#2367;&#2358;&#2381;&#2340;&#2375; &#2348;&#2340;&#2366;&#2319;&#2305;&#2327;&#2375; &#2332;&#2348; &#2340;&#2325; &#2325;&#2367; &#2310;&#2346; &#2347;&#2366;&#2311;&#2344;&#2354; &#2344;&#2361;&#2368;&#2306; &#2325;&#2352; &#2354;&#2375;&#2340;&#2375;.<br><br>\"&#2309;&#2348; &#2310;&#2346; SagaiWale.com &#2346;&#2352; &#2352;&#2375;&#2332;&#2367;&#2360;&#2381;&#2335;&#2352; &#2325;&#2368;&#2332;&#2367;&#2319;, &#2360;&#2327;&#2366;&#2312; &#2357;&#2366;&#2354;&#2375; &#2326;&#2369;&#2342; &#2310;&#2346;&#2325;&#2375; &#2328;&#2352; &#2310;&#2319;&#2305;&#2327;&#2375;\"<br><br>&#2349;&#2357;&#2342;&#2368;&#2351; : SagaiWale.com &#2335;&#2368;&#2350;</div></div></div></div>");
$templateCache.put("app/pages/contacted/contacted.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><div class=\"progress-info\">List of profiles you have already met</div><div class=\"progress\"><div class=\"progress-bar progress-bar-primary progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"70\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 70%\"></div></div><h3 class=\"with-line\">General Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">Picture</label><div class=\"col-sm-9\"><div class=\"userpic\"><div class=\"userpic-wrapper\"><img ng-src=\"{{ picture }}\" ng-click=\"uploadPicture()\"></div><i class=\"ion-ios-close-outline\" ng-click=\"removePicture()\" ng-if=\"!noPicture\"></i> <a href=\"\" class=\"change-userpic\" ng-click=\"uploadPicture()\">Change Profile Picture</a> <input type=\"file\" ng-show=\"false\" id=\"uploadFile\" ng-file-select=\"onFileSelect($files)\"></div></div></div></div><div class=\"col-md-6\"></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">First Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputFirstName\" placeholder=\"\" value=\"Anastasiya\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputLastName\" class=\"col-sm-3 control-label\">Last Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputLastName\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Department</label><div class=\"col-sm-9\"><select class=\"form-control\" selectpicker=\"\"><option>Govt</option><option>Private</option></select></div></div><div class=\"form-group row clearfix\"><label for=\"inputOccupation\" class=\"col-sm-3 control-label\">Occupation</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputOccupation\" placeholder=\"\" value=\"Front End Web Developer\"></div></div></div></div><h3 class=\"with-line\">Change Password</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\">Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputPassword\" placeholder=\"\" value=\"12345678\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputConfirmPassword\" class=\"col-sm-3 control-label\">Confirm Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputConfirmPassword\" placeholder=\"\"></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputEmail3\" class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" id=\"inputEmail3\" placeholder=\"\" value=\"contact@akveo.com\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputPhone\" class=\"col-sm-3 control-label\">Phone</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPhone\" placeholder=\"\" value=\"+1 (23) 456 7890\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Office Location</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label for=\"inputRoom\" class=\"col-sm-3 control-label\">Room <a class=\"sn-link\" href=\"\" ng-click=\"showModal()\">Open Modal</a></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputRoom\" placeholder=\"\" value=\"303\"></div></div></div></div><h3 class=\"with-line\">Send Email Notifications</h3><div class=\"notification row clearfix\"><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When I receive a message</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[0]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When Someone sends me an invitation</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[1]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When profile information changes</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[2]\"></switch></div></div></div><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When anyone logs into your account from a new device or browser</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[3]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Weekly Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[4]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Daily Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[5]\"></switch></div></div></div></div><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Update Profile</button></div></div>");
$templateCache.put("app/pages/contacted/profileModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Add Account</h4></div><form name=\"linkForm\"><div class=\"modal-body\"><p>Paste a link to your profile into the box below</p><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Link to Profile\" ng-model=\"link\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok(link)\">Save changes</button></div></form></div>");
$templateCache.put("app/pages/contactus/contactus.html","<div ba-panel=\"\" ba-panel-class=\"search-page\"><div class=\"panel-content\"><div class=\"row\"><div class=\"col-md-6\" style=\"font-size:16px;\">Please contact us at :<br><br>Head Office :<br>SagaiWale.com 101,<br>Akash Nagar, Bangalore - 560 016<br><br>Email : <a href=\"mailto:sagaiwale@gmail.com\">sagaiwale@gmail.com</a><br>Phone no. : +91 9742593316</div></div></div></div>");
$templateCache.put("app/pages/contactus/registerModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Add Account</h4></div><form name=\"linkForm\"><div class=\"modal-body\"><p>Paste a link to your profile into the box below</p><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Link to Search\" ng-model=\"link\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok(link)\">Save changes</button></div></form></div>");
$templateCache.put("app/pages/dashboard/dashboard.html","<dashboard-pie-chart></dashboard-pie-chart><div class=\"row\"><div class=\"col-lg-12 col-md-6 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Requests\" ba-panel-class=\"large-panel with-scroll feed-panel\"><blur-feed></blur-feed></div></div>");
$templateCache.put("app/pages/engaged/EngagedModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Add Account</h4></div><form name=\"linkForm\"><div class=\"modal-body\"><p>Paste a link to your profile into the box below</p><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Link to Profile\" ng-model=\"link\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok(link)\">Save changes</button></div></form></div>");
$templateCache.put("app/pages/engaged/engaged.html","<div class=\"feed-messages-container\" track-width=\"smallContainerWidth\" min-width=\"360\"><button ng-if=\"profile_type == \'contacted\' && !isEngaged\" type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"saveEngagedProfile()\"><i class=\"ion-android-checkmark-circle\"></i>Save Engaged Profile</button><div class=\"feed-message\" ng-repeat=\"message in requests\"><div class=\"message-icon\" ng-if=\"profile_type == \'contacted\' && !isEngaged\"><input type=\"radio\" name=\"profile_contacted\" ng-model=\"profile_engaged.name\" ng-value=\"message.id_val\"></div><div style=\"width:48%;float:left;border-right:1px solid #666666;\"><div class=\"message-icon\" ng-if=\"message.requester_details.type == \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{::( message.requester_details.author | profilePicture )}}\"></div><div class=\"message-icon\" ng-if=\"message.requester_details.type != \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{::( message.requester_details.author | profilePicture )}}\"> <span class=\"sub-photo-icon\" ng-class=\"::message.requester_details.type\"></span></div><div class=\"text-block text-message\" ui-sref=\"profile({{ ::message.requester_details.id_val }})\"><div class=\"message-header\"><span class=\"author\">{{ ::message.requester_details.guardian_name }} {{ ::message.requester_details.surname}}</span></div><div class=\"message-content line-clamp\" ng-class=\"{\'line-clamp-2\' : !message.requester_details.expanded}\"><span ng-if=\"message.requester_details.preview\">{{message.requester_details.header}}</span>{{::message.requester_details.text}}</div><div class=\"preview\" ng-show=\"message.requester_details.expanded\" ng-if=\"message.requester_details.preview\"><a href=\"{{::message.requester_details.link}}\" target=\"_blank\"><img ng-src=\"{{ ::( message.requester_details.preview | appImage )}}\"></a></div><div ng-show=\"message.requester_details.expanded\" class=\"message-time\"><div class=\"post-time\">{{::message.requester_details.time}}</div><div class=\"ago-time\">{{::message.requester_details.ago}}</div></div></div></div><div style=\"width:48%;float:left;border-left:1px solid #666666;\"><div class=\"message-icon\" ng-if=\"message.engaged_details.type == \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{::( message.engaged_details.author | profilePicture )}}\"></div><div class=\"message-icon\" ng-if=\"message.engaged_details.type != \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{::( message.engaged_details.author | profilePicture )}}\"> <span class=\"sub-photo-icon\" ng-class=\"::message.engaged_details.type\"></span></div><div class=\"text-block text-message\" ui-sref=\"profile({{ ::message.engaged_details.id_val }})\"><div class=\"message-header\"><span class=\"author\">{{ ::message.engaged_details.guardian_name }} {{ ::message.engaged_details.surname}}</span></div><div class=\"message-content line-clamp\" ng-class=\"{\'line-clamp-2\' : !message.engaged_details.expanded}\"><span ng-if=\"message.engaged_details.preview\">{{message.engaged_details.header}}</span>{{::message.engaged_details.text}}</div><div class=\"preview\" ng-show=\"message.engaged_details.expanded\" ng-if=\"message.engaged_details.preview\"><a href=\"{{::message.engaged_details.link}}\" target=\"_blank\"><img ng-src=\"{{ ::( message.engaged_details.preview | appImage )}}\"></a></div><div ng-show=\"message.engaged_details.expanded\" class=\"message-time\"><div class=\"post-time\">{{::message.engaged_details.time}}</div><div class=\"ago-time\">{{::message.engaged_details.ago}}</div></div></div></div><div style=\"clear:both;\"></div></div></div>");
$templateCache.put("app/pages/engaged/matchingprofiles_backUp.html","<div ba-panel=\"\" ba-panel-class=\"search-page\"><div class=\"panel-content\"><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"searchMatchingProfiles()\"><i class=\"ion-android-checkmark-circle\"></i>Search matching profiles</button> <a href=\"#/contacted\"><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"getContact()\"><i class=\"ion-android-checkmark-circle\"></i>My contacted profiles</button></a><h3 class=\"with-line\">General Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">Picture</label><div class=\"col-sm-9\"><div class=\"userpic\"><div class=\"userpic-wrapper\"><img ng-src=\"{{ picture }}\" ng-click=\"uploadPicture()\"></div><i class=\"ion-ios-close-outline\" ng-click=\"removePicture()\" ng-if=\"!noPicture\"></i> <a href=\"\" class=\"change-userpic\" ng-click=\"uploadPicture()\">Change Profile Picture</a> <input type=\"file\" ng-show=\"false\" id=\"uploadFile\" ng-file-select=\"onFileSelect($files)\"></div></div></div></div><div class=\"col-md-6\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking For :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"looking_for\" id=\"male\" value=\"M\" ng-model=\"registerInfo.looking_for\"> <span>Boy</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"looking_for\" id=\"female\" value=\"F\" ng-model=\"registerInfo.looking_for\"> <span>Girl</span></label></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" value=\"father\" ng-model=\"registerInfo.guardian\"> <span>Father</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"mother\" value=\"mother\" ng-model=\"registerInfo.guardian\"> <span>Mother</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"other\" value=\"other\" ng-model=\"registerInfo.guardian\"> <span>Other</span></label></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Guardian Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_name\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian\'s Contact Number</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_contact_no\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Guardian Occupation</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_occupation\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian Land</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_land\"></div></div></div></div><h3 class=\"with-line\">Details of your {{registerInfo.looking_for == \'female\' ? \'boy\' : \'girl\'}}</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"age\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.age\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Highest Education</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.education\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gender</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"profilegender\" id=\"gendermale\" value=\"male\" ng-checked=\"registerInfo.looking_for == \'F\'\" ng-model=\"registerInfo.gender\" ng-disabled=\"true\"> <span>Male</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"profilegender\" id=\"gendermale\" value=\"female\" ng-checked=\"registerInfo.looking_for == \'M\'\" ng-model=\"registerInfo.gender\" ng-disabled=\"true\"> <span>Female</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"emp\" value=\"Y\" ng-checked=\"registerInfo.employed == \'Y\'\" ng-model=\"registerInfo.employed\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"unemp\" value=\"N\" ng-checked=\"registerInfo.employed != \'Y\'\" ng-model=\"registerInfo.employed\"> <span>No</span></label></div></div></div></div><div class=\"row\" ng-show=\"registerInfo.employed==\'Y\'\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Job Category :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"job_type\" id=\"cat1\" value=\"Govt\" ng-model=\"registerInfo.job_type\"> <span>Govt</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"job_type\" id=\"cat2\" value=\"Private\" ng-model=\"registerInfo.job_type\"> <span>Private</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"registerInfo.job_type==\'Govt\'\"><select name=\"job\" ng-model=\"registerInfo.job_title_govt\" class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>Agri</option><option>Civil</option><option>Water Supply</option><option>Bescom</option></select></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"registerInfo.job_type==\'Private\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.job_title_pvt\" class=\"form-control\"></div></div></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" placeholder=\"\" value=\"contact@akveo.com\" ng-model=\"registerInfo.email\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line1</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.address_1\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Phone</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"+1 (23) 456 7890\" ng-model=\"registerInfo.phone\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line2</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.address_2\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">State</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.state\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.tehsil\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.district\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Pin Code</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.pin_code\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Village</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.town\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Or Enter</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.town_entered\"></div></div></div></div><h3 class=\"with-line\">Caste Information:</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Caste</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.caste\"><option>Hindu</option><option>Lingayat</option><option>Brahmin</option><option>Jain</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra :</label></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Self</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_self\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Naani</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_naani\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Daadi</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_daadi\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Mother</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_mother\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sub Caste</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.sub_caste\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sibling Details</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.sibling_details\"></textarea></div></div></div></div><h3 class=\"with-line\">Your Requirement</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">From</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.from_age\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqemp\" value=\"yes\" ng-model=\"registerInfo.req_employed\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"requnemp\" value=\"no\" ng-model=\"registerInfo.req_employed\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqnot\" value=\"notmatter\" ng-model=\"registerInfo.req_employed\"> <span>Not Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">To</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.age_to\"></div></div></div><div class=\"col-md-6\"><div class=\"col-md-6\" ng-show=\"reqemployed==\'yes\'\"><div class=\"form-group clearfix\"><label class=\"col-sm-6 control-label\">Job Category :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"jobcat\" id=\"reqcat1\" value=\"yes\" ng-model=\"registerInfo.req_job_type\"> <span>Govt</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqjobcat\" id=\"reqcat2\" value=\"no\" ng-model=\"registerInfo.req_job_type\"> <span>Private</span></label></div></div></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"reqjobcat==\'yes\'\"><select name=\"reqjob\" class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_job_title\"><option>Agri</option><option>Civil</option><option>Water Supply</option><option>Bescom</option></select></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"reqjobcat==\'no\'\"><input type=\"text\" name=\"job\" class=\"form-control\" ng-model=\"registerInfo.req_job_title\"></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Should Be Same Caste :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"yes\" ng-model=\"registerInfo.req_same_caste\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"no\" ng-model=\"registerInfo.req_same_caste\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"not\" ng-model=\"registerInfo.req_same_caste\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra Match :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"yes\" ng-model=\"registerInfo.req_gotra_match\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"no\" ng-model=\"registerInfo.req_gotra_match\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"not\" ng-model=\"registerInfo.req_gotra_match\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District :</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_district\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_town\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_tehsil\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Village</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_village\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Villages should not be in</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_town_not_list\"></textarea></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Should Have Own House :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"yes\" ng-model=\"registerInfo.req_own_house\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"no\" ng-model=\"registerInfo.req_own_house\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"not\" ng-model=\"registerInfo.req_own_house\"> <span>Doesn\'t Matter</span></label></div></div></div></div><button ng-if=\"registerInfo.page != \'profile\'\" type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"registerUser()\"><i class=\"ion-android-checkmark-circle\"></i>Register registerInfo.page : {{registerInfo.page}}</button></div>");
$templateCache.put("app/pages/engaged/profile_backUp (2).html","<div ba-panel=\"\" ba-panel-class=\"search-page\"><div class=\"panel-content\"><a href=\"#/contacted\"><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"getContact()\"><i class=\"ion-android-checkmark-circle\"></i>My contacted profiles</button></a> <button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"getContact()\"><i class=\"ion-android-checkmark-circle\"></i>My contacted profiles update</button><div class=\"progress-info\">Your profile is 70% Complete 123 : {{userName}} profileData : {{profileData}}</div><div class=\"progress\"><div class=\"progress-bar progress-bar-primary progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"70\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 70%\"></div></div><h3 class=\"with-line\">General Information</h3><div class=\"row\"><label class=\"col-sm-3 control-label\">Looking For :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"gender\" id=\"male\" value=\"male\" ng-model=\"gender\"> <span>Male</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"gender\" id=\"female\" value=\"female\" ng-model=\"gender\"> <span>Female</span></label></div></div><div class=\"row\"><label class=\"col-sm-3 control-label\">Guardian :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" value=\"father\" ng-model=\"guardian\"> <span>Father</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"mother\" value=\"mother\" ng-model=\"guardian\"> <span>Mother</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"other\" value=\"other\" ng-model=\"guardian\"> <span>Other</span></label></div><div class=\"col-md-2\" ng-show=\"guardian==\'other\'\"><input type=\"text\" class=\"form-control\" name=\"otherdtls\" id=\"otherdtls\" value=\"\"></div><div class=\"col-md-9\" ng-show=\"guardian==\'other\'\"><div class=\"form-group row clearfix\"><label for=\"guardianmdn\" class=\"col-sm-3 control-label\">Guardian\'s Contact Number :</label><div class=\"col-sm-3\"><input type=\"tel\" class=\"form-control\" id=\"guardianmdn\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label for=\"guardianoccupation\" class=\"col-sm-3 control-label\">Guardian Occupation :</label><div class=\"col-sm-3\"><input type=\"text\" class=\"form-control\" id=\"guardianoccupation\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label for=\"guardianland\" class=\"col-sm-3 control-label\">Guardian Land :</label><div class=\"col-sm-3\"><input type=\"text\" class=\"form-control\" id=\"guardianland\" placeholder=\"\" value=\"\"></div></div></div></div><h3 class=\"with-line\">Details of your boy/girl</h3><div class=\"row\"><label class=\"col-sm-3 control-label\">Gender :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"gendermale\" id=\"gendermale\" value=\"male\" ng-model=\"gender\" ng-disabled=\"true\"> <span>Male</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"genderfemale\" id=\"genderfemale\" value=\"female\" ng-model=\"gender\" ng-disabled=\"true\"> <span>Female</span></label></div></div><h3 class=\"with-line\">Personal Information:</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"qualification\" class=\"col-sm-6 control-label\">Highest Education</label><div class=\"col-sm-3\"><input type=\"text\" class=\"form-control\" id=\"qualification\" placeholder=\"\" value=\"\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-6 control-label\">Employed :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"emp\" value=\"yes\" ng-model=\"employed\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"unemp\" value=\"no\" ng-model=\"employed\"> <span>No</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\" ng-show=\"employed==\'yes\'\"><div class=\"form-group row clearfix\"><label class=\"col-sm-6 control-label\">Job Category :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"jobcat\" id=\"cat1\" value=\"yes\" ng-model=\"jobcat\"> <span>Govt</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"jobcat\" id=\"cat2\" value=\"no\" ng-model=\"jobcat\"> <span>Private</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"jobcat==\'yes\'\"><select name=\"job\" ng-model=\"job\" class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>Agri</option><option>Civil</option><option>Water Supply</option><option>Bescom</option></select></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"jobcat==\'no\'\"><input type=\"text\" name=\"job\" ng-model=\"no\" class=\"form-control\"></div></div></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" placeholder=\"\" value=\"contact@akveo.com\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line1</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Phone</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"+1 (23) 456 7890\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line2</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Vilage</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Pin Code</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Country</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div></div><h3 class=\"with-line\">Caste Information:</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Caste</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>Hindu</option><option>Lingayat</option><option>Brahmin</option><option>Jain</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra :</label></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Self</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Nani</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Dadi</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Mother</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sub Caste</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div></div><div class=\"row\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Siblings Details :</label></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Education</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Occupation</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div></div><h3 class=\"with-line\">Your Requirement</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">From</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqemp\" value=\"yes\" ng-model=\"reqemployed\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"requnemp\" value=\"no\" ng-model=\"reqemployed\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqnot\" value=\"notmatter\" ng-model=\"reqemployed\"> <span>Not Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">To</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"col-md-6\" ng-show=\"reqemployed==\'yes\'\"><div class=\"form-group clearfix\"><label class=\"col-sm-6 control-label\">Job Category :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"jobcat\" id=\"reqcat1\" value=\"yes\" ng-model=\"reqjobcat\"> <span>Govt</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqjobcat\" id=\"reqcat2\" value=\"no\" ng-model=\"reqjobcat\"> <span>Private</span></label></div></div></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"reqjobcat==\'yes\'\"><select name=\"reqjob\" ng-model=\"reqjob\" class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>Agri</option><option>Civil</option><option>Water Supply</option><option>Bescom</option></select></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"reqjobcat==\'no\'\"><input type=\"text\" name=\"job\" ng-model=\"no\" class=\"form-control\"></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label class=\"col-sm-6 control-label\">Should Be Same Caste :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"yes\" ng-model=\"reqcaste\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"no\" ng-model=\"reqcaste\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"not\" ng-model=\"reqcaste\"> <span>Doesn\'t Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label class=\"col-sm-6 control-label\">Gotra Match :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"yes\" ng-model=\"reqgot\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"no\" ng-model=\"reqgot\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"not\" ng-model=\"reqgot\"> <span>Doesn\'t Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Vilage should be in :</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Country</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label class=\"col-sm-6 control-label\">Should Have Own House :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"yes\" ng-model=\"reqprop\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"no\" ng-model=\"reqprop\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"not\" ng-model=\"reqprop\"> <span>Doesn\'t Matter</span></label></div></div></div></div><h3 class=\"with-line\">Send Email Notifications</h3><div class=\"notification row clearfix\"><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When I receive a message</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[0]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When Someone sends me an invitation</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[1]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When profile information changes</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[2]\"></switch></div></div></div><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When anyone logs into your account from a new device or browser</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[3]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Weekly Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[4]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Daily Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[5]\"></switch></div></div></div></div><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Search</button></div>");
$templateCache.put("app/pages/engaged/profile_backUp.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><div class=\"progress-info\">Your profile is 70% Complete six 100</div><div class=\"progress\"><div class=\"progress-bar progress-bar-primary progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"70\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 70%\"></div></div><h3 class=\"with-line\">General Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">Picture</label><div class=\"col-sm-9\"><div class=\"userpic\"><div class=\"userpic-wrapper\"><img ng-src=\"{{ picture }}\" ng-click=\"uploadPicture()\"></div><i class=\"ion-ios-close-outline\" ng-click=\"removePicture()\" ng-if=\"!noPicture\"></i> <a href=\"\" class=\"change-userpic\" ng-click=\"uploadPicture()\">Change Profile Picture</a> <input type=\"file\" ng-show=\"false\" id=\"uploadFile\" ng-file-select=\"onFileSelect($files)\"></div></div></div></div><div class=\"col-md-6\"></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">First Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputFirstName\" placeholder=\"\" value=\"Anastasiya\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputLastName\" class=\"col-sm-3 control-label\">Last Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputLastName\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Department</label><div class=\"col-sm-9\"><select class=\"form-control\" selectpicker=\"\"><option>Govt</option><option>Private</option></select></div></div><div class=\"form-group row clearfix\"><label for=\"inputOccupation\" class=\"col-sm-3 control-label\">Occupation</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputOccupation\" placeholder=\"\" value=\"Front End Web Developer\"></div></div></div></div><h3 class=\"with-line\">Change Password</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\">Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputPassword\" placeholder=\"\" value=\"12345678\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputConfirmPassword\" class=\"col-sm-3 control-label\">Confirm Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputConfirmPassword\" placeholder=\"\"></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputEmail3\" class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" id=\"inputEmail3\" placeholder=\"\" value=\"contact@akveo.com\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputPhone\" class=\"col-sm-3 control-label\">Phone</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPhone\" placeholder=\"\" value=\"+1 (23) 456 7890\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Office Location</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label for=\"inputRoom\" class=\"col-sm-3 control-label\">Room</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputRoom\" placeholder=\"\" value=\"303\"></div></div></div></div><h3 class=\"with-line\">Social Profiles</h3><div class=\"social-profiles row clearfix\"><div class=\"col-md-3 col-sm-4\" ng-repeat=\"item in socialProfiles\"><a class=\"sn-link\" href=\"\" ng-click=\"showModal(item)\" ng-if=\"!item.href\"><i class=\"socicon {{ item.icon }}\"></i> <span>{{ item.name }}</span></a> <a class=\"sn-link connected\" href=\"{{ item.href }}\" target=\"_blank\" ng-if=\"item.href\"><i class=\"socicon {{ item.icon }}\"></i> <span>{{ item.name }}</span> <em class=\"ion-ios-close-empty sn-link-close\" ng-mousedown=\"unconnect(item)\"></em></a></div></div><h3 class=\"with-line\">Send Email Notifications</h3><div class=\"notification row clearfix\"><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When I receive a message</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[0]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When Someone sends me an invitation</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[1]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When profile information changes</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[2]\"></switch></div></div></div><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When anyone logs into your account from a new device or browser</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[3]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Weekly Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[4]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Daily Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[5]\"></switch></div></div></div></div><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Update Profile</button></div></div>");
$templateCache.put("app/pages/enroll/enroll.html","<script src=\"/app/pages/profile/CommonService.js\"></script><div ba-panel=\"\" ba-panel-class=\"search-page\"><div class=\"panel-content\"><h3 class=\"with-line\">General Information</h3><div class=\"row\"><div ng-if=\"errorMsg.length > 0\" class=\"col-md-8\" style=\"color:red;border:1px solid gray;margin-bottom:20px;\"><p style=\"margin-bottom:3px;\" ng-repeat=\"eachErrorMsg in errorMsg\" track=\"\" by=\"\" $index=\"\">{{eachErrorMsg}}</p></div><br></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking For</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"looking_for\" id=\"male\" value=\"M\" ng-model=\"registerInfo.looking_for\"> <span>Boy</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"looking_for\" id=\"female\" value=\"F\" ng-model=\"registerInfo.looking_for\"> <span>Girl</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" value=\"father\" ng-model=\"registerInfo.guardian\"> <span>Father</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"mother\" value=\"mother\" ng-model=\"registerInfo.guardian\"> <span>Mother</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"other\" value=\"other\" ng-model=\"registerInfo.guardian\"> <span>Other</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Guardian Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_name\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Guardian Occupation</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" name=\"guardian_occupation\" id=\"guardian_occupation\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_occupation\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian Land</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_land\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian\'s Contact Number</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_contact_no\"></div></div></div></div><div class=\"row\" ng-if=\"registerInfo.guardian_otp_generated == \'yes\'\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Enter OTP</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" id=\"guardian_otp\" ng-model=\"registerInfo.guardian_otp\"></div></div></div></div><h3 class=\"with-line\">Details of your {{registerInfo.looking_for == \'F\' ? \'boy\' : \'girl\'}}</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"age\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.age\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Highest Education</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.education\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Height</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"height\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.height\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gender</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"profilegender\" id=\"gendermale\" value=\"M\" ng-checked=\"registerInfo.looking_for == \'F\'\" ng-model=\"registerInfo.gender\" ng-disabled=\"true\"> <span>Male</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"profilegender\" id=\"gendermale\" value=\"F\" ng-checked=\"registerInfo.looking_for == \'M\'\" ng-model=\"registerInfo.gender\" ng-disabled=\"true\"> <span>Female</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"emp\" value=\"Y\" ng-model=\"registerInfo.employed\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"unemp\" value=\"N\" ng-model=\"registerInfo.employed\"> <span>No</span></label></div></div></div></div><div class=\"row\" ng-show=\"registerInfo.employed==\'Y\'\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Job Category</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"job_type\" id=\"cat1\" value=\"GOVT\" ng-model=\"registerInfo.job_type\"> <span>Govt</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"job_type\" id=\"cat2\" value=\"PVT\" ng-model=\"registerInfo.job_type\"> <span>Private</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"registerInfo.job_type==\'GOVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.job_title\" class=\"form-control\" style=\"text-transform:uppercase\"></div><div class=\"col-sm-6\" ng-show=\"registerInfo.job_type==\'PVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.job_title\" class=\"form-control\" style=\"text-transform:uppercase\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Have Own House</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"Y\" ng-model=\"registerInfo.own_house\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"N\" ng-model=\"registerInfo.own_house\"> <span>No</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Are you a Person with Disability</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"disability\" id=\"disability_y\" ng-change=\"radioChanged(\'disability\', registerInfo.disability)\" value=\"Y\" ng-model=\"registerInfo.disability\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"disability\" id=\"disability_n\" ng-change=\"radioChanged(\'disability\', registerInfo.disability)\" value=\"N\" ng-model=\"registerInfo.disability\"> <span>No</span></label></div></div></div><div class=\"col-md-6\" ng-if=\"registerInfo.disability == \'Y\'\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Type of Disability</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.disability_type\"><option value=\"HI\">HI</option><option value=\"VI\">VI</option><option value=\"OC\">OC</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Are you a widow/widower</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_widow\" id=\"is_widow_y\" ng-change=\"radioChanged(\'is_widow\', registerInfo.is_widow)\" value=\"Y\" ng-model=\"registerInfo.is_widow\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_widow\" id=\"is_widow_n\" ng-change=\"radioChanged(\'is_widow\', registerInfo.is_widow)\" value=\"N\" ng-model=\"registerInfo.is_widow\"> <span>No</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Are you a divorcee</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_divorcee\" id=\"is_divorcee_y\" ng-change=\"radioChanged(\'is_divorcee\', registerInfo.is_divorcee)\" value=\"Y\" ng-model=\"registerInfo.is_divorcee\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_divorcee\" id=\"is_divorcee_n\" ng-change=\"radioChanged(\'is_divorcee\', registerInfo.is_divorcee)\" value=\"N\" ng-model=\"registerInfo.is_divorcee\"> <span>No</span></label></div></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" placeholder=\"\" value=\"contact@akveo.com\" ng-model=\"registerInfo.email\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line1</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.address_1\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Phone</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"+1 (23) 456 7890\" ng-model=\"registerInfo.phone\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line2</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.address_2\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">State</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.state\" ng-options=\"obj.code as obj.name for obj in countries\" ng-change=\"getCountryStates(\'state\')\" class=\"form-control\" ng-required=\"true\" id=\"state\"><option value=\"\">-- Select --</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.tehsil\" ng-options=\"x.code as x.name for x in cities\" class=\"form-control\" ng-required=\"true\" id=\"city\"><option value=\"\">-- Select --</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.district\" ng-options=\"x.code as x.name for x in sates\" ng-change=\"getStateCities(\'district\')\" class=\"form-control\" ng-required=\"true\" id=\"district\"><option value=\"\">-- Select --</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Village</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"town\" placeholder=\"\" ng-model=\"registerInfo.town\" style=\"text-transform:uppercase\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Pin Code</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.pin_code\"></div></div></div></div><h3 class=\"with-line\">Caste Information:</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Religion</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.religion\"><option>Buddhist</option><option>Christian</option><option>Hindu</option><option>Jain</option><option>Muslim</option><option>Sikh</option><option>Zoroastrian</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Caste</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.caste\"><option>General</option><option>OBC</option><option>SC</option><option>ST</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra :</label></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Self</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_self\" style=\"text-transform:uppercase\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Naani</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_naani\" style=\"text-transform:uppercase\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Daadi</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_daadi\" style=\"text-transform:uppercase\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Mother</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_mother\" style=\"text-transform:uppercase\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sub Caste</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.sub_caste\" style=\"text-transform:uppercase\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sibling Details</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.sibling_details\"></textarea></div></div></div></div><h3 class=\"with-line\">Your Requirement</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">From</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_age_from\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">To</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_age_to\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqemp\" value=\"Y\" ng-model=\"registerInfo.req_employed\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"requnemp\" value=\"N\" ng-model=\"registerInfo.req_employed\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqnot\" value=\"E\" ng-model=\"registerInfo.req_employed\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\" ng-show=\"registerInfo.req_employed==\'Y\'\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Job Category</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_job_type\" id=\"cat1\" value=\"GOVT\" ng-model=\"registerInfo.req_job_type\"> <span>Govt</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_job_type\" id=\"cat2\" value=\"PVT\" ng-model=\"registerInfo.req_job_type\"> <span>Private</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_job_type\" id=\"cat2\" value=\"OTHER\" ng-model=\"registerInfo.req_job_type\"> <span>Doesn\'t Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"registerInfo.req_job_type==\'GOVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.req_job_title\" class=\"form-control\"></div><div class=\"col-sm-6\" ng-show=\"registerInfo.req_job_type==\'PVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.req_job_title\" class=\"form-control\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Height</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"req_height\" placeholder=\"\" ng-model=\"registerInfo.req_height\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Religion</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_religion\"><option>Buddhist</option><option>Christian</option><option>Hindu</option><option>Jain</option><option>Muslim</option><option>Sikh</option><option>Zoroastrian</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Should Be Same Caste</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"Y\" ng-model=\"registerInfo.req_same_caste\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"N\" ng-model=\"registerInfo.req_same_caste\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"E\" ng-model=\"registerInfo.req_same_caste\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"N\" ng-model=\"registerInfo.req_gotra_match\"> <span>Should Not<br>Be Same</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"Y\" ng-model=\"registerInfo.req_gotra_match\"> <span>Should Be<br>Same</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"\" ng-model=\"registerInfo.req_gotra_match\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">State</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.req_state\" ng-options=\"obj.code as obj.name for obj in countries\" ng-change=\"getCountryStates(\'req_state\')\" class=\"form-control\" ng-required=\"true\" id=\"req_state\"><option value=\"\">-- Select --</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.req_tehsil\" ng-options=\"x.code as x.name for x in req_cities\" class=\"form-control\" ng-required=\"true\" id=\"city\"><option value=\"\">-- Select --</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.req_district\" ng-options=\"x.code as x.name for x in req_sates\" ng-change=\"getStateCities(\'req_district\')\" class=\"form-control\" ng-required=\"true\" id=\"req_district\"><option value=\"\">-- Select --</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Village</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"req_town\" placeholder=\"\" ng-model=\"registerInfo.req_town\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Villages should not be among</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_town_not_list\"></textarea></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Should Have Own House</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"Y\" ng-model=\"registerInfo.req_own_house\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"N\" ng-model=\"registerInfo.req_own_house\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"\" ng-model=\"registerInfo.req_own_house\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking for a person with disability</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_disability\" id=\"req_disability_y\" value=\"Y\" ng-model=\"registerInfo.req_disability\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_disability\" id=\"req_disability_n\" value=\"N\" ng-model=\"registerInfo.req_disability\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_disability\" id=\"req_disability_e\" value=\"E\" ng-model=\"registerInfo.req_disability\"> <span>Doesn\'t Matter</span></label></div></div></div><div class=\"col-md-6\" ng-if=\"registerInfo.req_disability == \'Y\'\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Type of Disability</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_disability_type\"><option value=\"HI\">HI</option><option value=\"VI\">VI</option><option value=\"OC\">OC</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking for widow/widower</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_widow\" id=\"req_is_widow_y\" value=\"Y\" ng-model=\"registerInfo.req_is_widow\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_widow\" id=\"req_is_widow_n\" value=\"N\" ng-model=\"registerInfo.req_is_widow\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_widow\" id=\"req_is_widow_e\" value=\"E\" ng-model=\"registerInfo.req_is_widow\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking for divorcee</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_divorcee\" id=\"req_is_divorcee_y\" value=\"Y\" ng-model=\"registerInfo.req_is_divorcee\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_divorcee\" id=\"req_is_divorcee_n\" value=\"N\" ng-model=\"registerInfo.req_is_divorcee\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_divorcee\" id=\"req_is_divorcee_e\" value=\"E\" ng-model=\"registerInfo.req_is_divorcee\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><p><img src=\"http://www.sagaiwale.com/test_api/public/getcaptcha/\" id=\"captchaimg\"><br><label for=\"message\">Enter the code above here :</label><br><br><input type=\"text\" class=\"form-control\" id=\"captcha_code\" placeholder=\"\" ng-model=\"registerInfo.captcha_code\"> <small>Can\'t read the image? click <a href=\"javascript:void(0);\" ng-click=\"refreshCaptcha()\">here</a> to refresh</small></p></div></div><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"registerUser()\"><i class=\"ion-android-checkmark-circle\"></i>Register</button></div>");
$templateCache.put("app/pages/enroll/registerModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Add Account</h4></div><form name=\"linkForm\"><div class=\"modal-body\"><p>Paste a link to your profile into the box below</p><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Link to Search\" ng-model=\"link\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok(link)\">Save changes</button></div></form></div>");
$templateCache.put("app/pages/home/home.html","<style>\r\n.hindiFont {\r\n	font-size:16px;\r\n	padding: 10px 0;\r\n	/* font-weight : bold; */\r\n	line-height: 25px;\r\n}\r\n</style><div ba-panel=\"\" ba-panel-class=\"search-page\"><div class=\"panel-content\"><div class=\"row\"><div class=\"col-md-6\" style=\"background:url(\'assets/img/home_page_.jpg\') repeat;padding-top:1%;\"><div style=\"color:#209e91;padding-left:3%;font-size:20px;font-weight:bold;margin-bottom:20px\">&#2309;&#2348; &#2360;&#2327;&#2366;&#2312; &#2325;&#2352;&#2344;&#2366; &#2361;&#2369;&#2310; &#2310;&#2360;&#2366;&#2344;</div><ul><li class=\"hindiFont\"><span class=\"stepTitle\">&#2309;&#2346;&#2344;&#2368; &#2346;&#2360;&#2306;&#2342; &#2348;&#2340;&#2366;&#2319;&#2305;</span> : &#2310;&#2346; &#2309;&#2346;&#2344;&#2368; &#2346;&#2360;&#2306;&#2342; &#2325;&#2375; &#2348;&#2366;&#2352;&#2375; &#2350;&#2375; &#2337;&#2368;&#2335;&#2375;&#2354;&#2381;&#2360; sagaiwale.com &#2346;&#2352; &#2337;&#2366;&#2354;&#2367;&#2319;.</li><li class=\"hindiFont\"><span class=\"stepTitle\">&#2358;&#2381;&#2352;&#2375;&#2359;&#2381;&#2336; &#2352;&#2367;&#2358;&#2381;&#2340;&#2366; &#2330;&#2369;&#2344;&#2375;&#2306;</span> : &#2361;&#2350;&#2366;&#2352;&#2368; &#2309;&#2344;&#2369;&#2349;&#2357;&#2368; &#2335;&#2368;&#2350; &#2310;&#2346;&#2325;&#2379; &#2347;&#2379;&#2344; &#2325;&#2352;&#2325;&#2375; &#2325;&#2312; &#2352;&#2367;&#2358;&#2381;&#2340;&#2375; &#2348;&#2340;&#2366;&#2319;&#2327;&#2368;. &#2310;&#2346; &#2313;&#2344;&#2350;&#2375;&#2306; &#2360;&#2375; &#2358;&#2381;&#2352;&#2375;&#2359;&#2381;&#2336; &#2352;&#2367;&#2358;&#2381;&#2340;&#2375; &#2325;&#2366; &#2330;&#2351;&#2344; &#2325;&#2352; &#2360;&#2325;&#2340;&#2375; &#2361;&#2376;&#2306;. &#2310;&#2346;&#2325;&#2375; &#2342;&#2381;&#2357;&#2366;&#2352;&#2366; &#2346;&#2360;&#2306;&#2342; &#2325;&#2367;&#2319; &#2327;&#2351;&#2375; &#2352;&#2367;&#2358;&#2381;&#2340;&#2375; &#2325;&#2366; &#2346;&#2340;&#2366; &#2357; &#2360;&#2306;&#2346;&#2352;&#2381;&#2325; &#2344;&#2306;&#2348;&#2352; &#2310;&#2346;&#2325;&#2379; &#2349;&#2375;&#2332; &#2342;&#2367;&#2351;&#2366; &#2332;&#2366;&#2319;&#2327;&#2366;.</li><li class=\"hindiFont\"><span class=\"stepTitle\">&#2328;&#2352; &#2332;&#2366;&#2325;&#2352; &#2350;&#2367;&#2354;&#2375;&#2306;</span> : &#2310;&#2346; &#2346;&#2360;&#2306;&#2342; &#2325;&#2367;&#2319; &#2327;&#2351;&#2375; &#2352;&#2367;&#2358;&#2381;&#2340;&#2375; &#2357;&#2366;&#2354;&#2379;&#2306; &#2325;&#2375; &#2328;&#2352; &#2332;&#2366;&#2325;&#2352; &#2310;&#2350;&#2344;&#2375; &#2360;&#2366;&#2350;&#2344;&#2375; &#2348;&#2376;&#2336;&#2325;&#2352; &#2348;&#2366;&#2340; &#2325;&#2352;&#2375;&#2306;. &#2309;&#2327;&#2352; &#2310;&#2346;&#2325;&#2379; &#2352;&#2367;&#2358;&#2381;&#2340;&#2366; &#2346;&#2360;&#2306;&#2342; &#2361;&#2379; &#2340;&#2379; &#2360;&#2327;&#2366;&#2312; &#2325;&#2352; &#2360;&#2325;&#2340;&#2375; &#2361;&#2376;&#2306;. &#2309;&#2327;&#2352; &#2352;&#2367;&#2358;&#2381;&#2340;&#2366; &#2346;&#2360;&#2306;&#2342; &#2344;&#2366; &#2310;&#2319; &#2340;&#2379; &#2361;&#2350;&#2366;&#2352;&#2368; &#2335;&#2368;&#2350; &#2310;&#2346;&#2325;&#2379; &#2324;&#2352; &#2352;&#2367;&#2358;&#2381;&#2340;&#2375; &#2348;&#2340;&#2366;&#2319;&#2327;&#2368; &#2332;&#2348; &#2340;&#2325; &#2325;&#2367; &#2310;&#2346; &#2360;&#2327;&#2366;&#2312; &#2344;&#2361;&#2368;&#2306; &#2325;&#2352; &#2354;&#2375;&#2340;&#2375;.</li><li class=\"hindiFont\"><span class=\"stepTitle\">&#2327;&#2379;&#2346;&#2344;&#2368;&#2351;&#2340;&#2366;</span> : &#2310;&#2346;&#2325;&#2368; &#2332;&#2366;&#2344;&#2325;&#2366;&#2352;&#2368; &#2327;&#2379;&#2346;&#2344;&#2368;&#2351; &#2352;&#2326;&#2368; &#2332;&#2366;&#2319;&#2327;&#2368;.&#2354;&#2337;&#2364;&#2325;&#2368; &#2325;&#2368; &#2347;&#2379;&#2335;&#2379; &#2357; &#2347;&#2379;&#2344; &#2344;&#2306;&#2348;&#2352; &#2309;&#2344;&#2367;&#2357;&#2366;&#2352;&#2381;&#2351; &#2344;&#2361;&#2368;&#2306; &#2361;&#2376;&#2306;. &#2309;&#2349;&#2367;&#2349;&#2366;&#2357;&#2325; &#2309;&#2346;&#2344;&#2366; &#2347;&#2379;&#2344; &#2344;&#2306;&#2348;&#2352; &#2342;&#2375; &#2360;&#2325;&#2340;&#2375; &#2361;&#2376;&#2306;.</li></ul><div class=\"registerBtn\" style=\"padding-left:3%;margin-top: 3%;\"><input type=\"button\" ng-click=\"displayRegister();\" value=\"&#2309;&#2346;&#2344;&#2368; &#2337;&#2368;&#2335;&#2375;&#2354;&#2381;&#2360; &#2337;&#2366;&#2354;&#2367;&#2319;\" style=\"padding:10px;background:#209e91;font-weight:bold;color:white;\"></div><div class=\"registerBtn\" style=\"padding-bottom:5%;\">&nbsp;</div></div><div class=\"col-md-6\" style=\"background:url(\'assets/img/home_page_8.jpg\') repeat;padding-top:8%;height:400px;\"></div></div></div></div>");
$templateCache.put("app/pages/matchingprofiles/matchingprofiles.html","<h1>{{profile_type == \'contacted\' ? \'Contacted\' : \'Matching\'}} Profiles</h1><br><div class=\"feed-messages-container\" track-width=\"smallContainerWidth\" min-width=\"360\"><button ng-if=\"profile_type == \'contacted\' && !isEngaged\" type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"saveEngagedProfile()\"><i class=\"ion-android-checkmark-circle\"></i>Save Engaged Profile</button><div class=\"feed-message\" ng-repeat=\"message in requests\"><div class=\"message-icon\" ng-if=\"profile_type == \'contacted\' && !isEngaged\"><input type=\"radio\" name=\"profile_contacted\" ng-model=\"profile_engaged.name\" ng-value=\"message.id_val\"></div><div class=\"\" ng-if=\"message.status == \'E\'\" style=\"margin-bottom:10px;\"><span style=\"background:green;color:white;padding:0px 10px;\">Engaged<span></span></span></div><div class=\"message-icon\" ng-if=\"message.type == \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{::( message.author | profilePicture )}}\"></div><div class=\"message-icon\" ng-if=\"message.type != \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{::( message.author | profilePicture )}}\"> <span class=\"sub-photo-icon\" ng-class=\"::message.type\"></span></div><div class=\"text-block text-message\" ui-sref=\"profile({{ ::message.id_val }})\"><div class=\"message-header\"><span class=\"author\">{{ ::message.guardian_name }} {{ ::message.surname}}</span></div><div class=\"message-content line-clamp\" ng-class=\"{\'line-clamp-2\' : !message.expanded}\"><span ng-if=\"message.preview\">{{message.header}}</span>{{::message.text}}</div><div class=\"preview\" ng-show=\"message.expanded\" ng-if=\"message.preview\"><a href=\"{{::message.link}}\" target=\"_blank\"><img ng-src=\"{{ ::( message.preview | appImage )}}\"></a></div><div ng-show=\"message.expanded\" class=\"message-time\"><div class=\"post-time\">{{::message.time}}</div><div class=\"ago-time\">{{::message.ago}}</div></div></div></div></div>");
$templateCache.put("app/pages/matchingprofiles/matchingprofiles_backUp.html","<div ba-panel=\"\" ba-panel-class=\"search-page\"><div class=\"panel-content\"><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"searchMatchingProfiles()\"><i class=\"ion-android-checkmark-circle\"></i>Search matching profiles</button> <a href=\"#/contacted\"><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"getContact()\"><i class=\"ion-android-checkmark-circle\"></i>My contacted profiles</button></a><h3 class=\"with-line\">General Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">Picture</label><div class=\"col-sm-9\"><div class=\"userpic\"><div class=\"userpic-wrapper\"><img ng-src=\"{{ picture }}\" ng-click=\"uploadPicture()\"></div><i class=\"ion-ios-close-outline\" ng-click=\"removePicture()\" ng-if=\"!noPicture\"></i> <a href=\"\" class=\"change-userpic\" ng-click=\"uploadPicture()\">Change Profile Picture</a> <input type=\"file\" ng-show=\"false\" id=\"uploadFile\" ng-file-select=\"onFileSelect($files)\"></div></div></div></div><div class=\"col-md-6\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking For :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"looking_for\" id=\"male\" value=\"M\" ng-model=\"registerInfo.looking_for\"> <span>Boy</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"looking_for\" id=\"female\" value=\"F\" ng-model=\"registerInfo.looking_for\"> <span>Girl</span></label></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" value=\"father\" ng-model=\"registerInfo.guardian\"> <span>Father</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"mother\" value=\"mother\" ng-model=\"registerInfo.guardian\"> <span>Mother</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"other\" value=\"other\" ng-model=\"registerInfo.guardian\"> <span>Other</span></label></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Guardian Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_name\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian\'s Contact Number</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_contact_no\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Guardian Occupation</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_occupation\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian Land</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_land\"></div></div></div></div><h3 class=\"with-line\">Details of your {{registerInfo.looking_for == \'female\' ? \'boy\' : \'girl\'}}</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"age\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.age\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Highest Education</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.education\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gender</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"profilegender\" id=\"gendermale\" value=\"male\" ng-checked=\"registerInfo.looking_for == \'F\'\" ng-model=\"registerInfo.gender\" ng-disabled=\"true\"> <span>Male</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"profilegender\" id=\"gendermale\" value=\"female\" ng-checked=\"registerInfo.looking_for == \'M\'\" ng-model=\"registerInfo.gender\" ng-disabled=\"true\"> <span>Female</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"emp\" value=\"Y\" ng-checked=\"registerInfo.employed == \'Y\'\" ng-model=\"registerInfo.employed\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"unemp\" value=\"N\" ng-checked=\"registerInfo.employed != \'Y\'\" ng-model=\"registerInfo.employed\"> <span>No</span></label></div></div></div></div><div class=\"row\" ng-show=\"registerInfo.employed==\'Y\'\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Job Category :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"job_type\" id=\"cat1\" value=\"Govt\" ng-model=\"registerInfo.job_type\"> <span>Govt</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"job_type\" id=\"cat2\" value=\"Private\" ng-model=\"registerInfo.job_type\"> <span>Private</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"registerInfo.job_type==\'Govt\'\"><select name=\"job\" ng-model=\"registerInfo.job_title_govt\" class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>Agri</option><option>Civil</option><option>Water Supply</option><option>Bescom</option></select></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"registerInfo.job_type==\'Private\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.job_title_pvt\" class=\"form-control\"></div></div></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" placeholder=\"\" value=\"contact@akveo.com\" ng-model=\"registerInfo.email\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line1</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.address_1\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Phone</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"+1 (23) 456 7890\" ng-model=\"registerInfo.phone\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line2</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.address_2\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">State</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.state\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.tehsil\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.district\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Pin Code</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.pin_code\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Village</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.town\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Or Enter</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.town_entered\"></div></div></div></div><h3 class=\"with-line\">Caste Information:</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Caste</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.caste\"><option>Hindu</option><option>Lingayat</option><option>Brahmin</option><option>Jain</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra :</label></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Self</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_self\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Naani</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_naani\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Daadi</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_daadi\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Mother</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_mother\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sub Caste</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.sub_caste\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sibling Details</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.sibling_details\"></textarea></div></div></div></div><h3 class=\"with-line\">Your Requirement</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">From</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.from_age\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqemp\" value=\"yes\" ng-model=\"registerInfo.req_employed\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"requnemp\" value=\"no\" ng-model=\"registerInfo.req_employed\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqnot\" value=\"notmatter\" ng-model=\"registerInfo.req_employed\"> <span>Not Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">To</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.age_to\"></div></div></div><div class=\"col-md-6\"><div class=\"col-md-6\" ng-show=\"reqemployed==\'yes\'\"><div class=\"form-group clearfix\"><label class=\"col-sm-6 control-label\">Job Category :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"jobcat\" id=\"reqcat1\" value=\"yes\" ng-model=\"registerInfo.req_job_type\"> <span>Govt</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqjobcat\" id=\"reqcat2\" value=\"no\" ng-model=\"registerInfo.req_job_type\"> <span>Private</span></label></div></div></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"reqjobcat==\'yes\'\"><select name=\"reqjob\" class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_job_title\"><option>Agri</option><option>Civil</option><option>Water Supply</option><option>Bescom</option></select></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"reqjobcat==\'no\'\"><input type=\"text\" name=\"job\" class=\"form-control\" ng-model=\"registerInfo.req_job_title\"></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Should Be Same Caste :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"yes\" ng-model=\"registerInfo.req_same_caste\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"no\" ng-model=\"registerInfo.req_same_caste\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"not\" ng-model=\"registerInfo.req_same_caste\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra Match :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"yes\" ng-model=\"registerInfo.req_gotra_match\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"no\" ng-model=\"registerInfo.req_gotra_match\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"not\" ng-model=\"registerInfo.req_gotra_match\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District :</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_district\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_town\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_tehsil\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Village</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_village\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Villages should not be in</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_town_not_list\"></textarea></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Should Have Own House :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"yes\" ng-model=\"registerInfo.req_own_house\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"no\" ng-model=\"registerInfo.req_own_house\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"not\" ng-model=\"registerInfo.req_own_house\"> <span>Doesn\'t Matter</span></label></div></div></div></div><button ng-if=\"registerInfo.page != \'profile\'\" type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"registerUser()\"><i class=\"ion-android-checkmark-circle\"></i>Register registerInfo.page : {{registerInfo.page}}</button></div>");
$templateCache.put("app/pages/matchingprofiles/profileModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Add Account</h4></div><form name=\"linkForm\"><div class=\"modal-body\"><p>Paste a link to your profile into the box below</p><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Link to Profile\" ng-model=\"link\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok(link)\">Save changes</button></div></form></div>");
$templateCache.put("app/pages/matchingprofiles/profile_backUp (2).html","<div ba-panel=\"\" ba-panel-class=\"search-page\"><div class=\"panel-content\"><a href=\"#/contacted\"><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"getContact()\"><i class=\"ion-android-checkmark-circle\"></i>My contacted profiles</button></a> <button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"getContact()\"><i class=\"ion-android-checkmark-circle\"></i>My contacted profiles update</button><div class=\"progress-info\">Your profile is 70% Complete 123 : {{userName}} profileData : {{profileData}}</div><div class=\"progress\"><div class=\"progress-bar progress-bar-primary progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"70\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 70%\"></div></div><h3 class=\"with-line\">General Information</h3><div class=\"row\"><label class=\"col-sm-3 control-label\">Looking For :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"gender\" id=\"male\" value=\"male\" ng-model=\"gender\"> <span>Male</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"gender\" id=\"female\" value=\"female\" ng-model=\"gender\"> <span>Female</span></label></div></div><div class=\"row\"><label class=\"col-sm-3 control-label\">Guardian :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" value=\"father\" ng-model=\"guardian\"> <span>Father</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"mother\" value=\"mother\" ng-model=\"guardian\"> <span>Mother</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"other\" value=\"other\" ng-model=\"guardian\"> <span>Other</span></label></div><div class=\"col-md-2\" ng-show=\"guardian==\'other\'\"><input type=\"text\" class=\"form-control\" name=\"otherdtls\" id=\"otherdtls\" value=\"\"></div><div class=\"col-md-9\" ng-show=\"guardian==\'other\'\"><div class=\"form-group row clearfix\"><label for=\"guardianmdn\" class=\"col-sm-3 control-label\">Guardian\'s Contact Number :</label><div class=\"col-sm-3\"><input type=\"tel\" class=\"form-control\" id=\"guardianmdn\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label for=\"guardianoccupation\" class=\"col-sm-3 control-label\">Guardian Occupation :</label><div class=\"col-sm-3\"><input type=\"text\" class=\"form-control\" id=\"guardianoccupation\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label for=\"guardianland\" class=\"col-sm-3 control-label\">Guardian Land :</label><div class=\"col-sm-3\"><input type=\"text\" class=\"form-control\" id=\"guardianland\" placeholder=\"\" value=\"\"></div></div></div></div><h3 class=\"with-line\">Details of your boy/girl</h3><div class=\"row\"><label class=\"col-sm-3 control-label\">Gender :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"gendermale\" id=\"gendermale\" value=\"male\" ng-model=\"gender\" ng-disabled=\"true\"> <span>Male</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"genderfemale\" id=\"genderfemale\" value=\"female\" ng-model=\"gender\" ng-disabled=\"true\"> <span>Female</span></label></div></div><h3 class=\"with-line\">Personal Information:</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"qualification\" class=\"col-sm-6 control-label\">Highest Education</label><div class=\"col-sm-3\"><input type=\"text\" class=\"form-control\" id=\"qualification\" placeholder=\"\" value=\"\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-6 control-label\">Employed :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"emp\" value=\"yes\" ng-model=\"employed\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"unemp\" value=\"no\" ng-model=\"employed\"> <span>No</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\" ng-show=\"employed==\'yes\'\"><div class=\"form-group row clearfix\"><label class=\"col-sm-6 control-label\">Job Category :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"jobcat\" id=\"cat1\" value=\"yes\" ng-model=\"jobcat\"> <span>Govt</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"jobcat\" id=\"cat2\" value=\"no\" ng-model=\"jobcat\"> <span>Private</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"jobcat==\'yes\'\"><select name=\"job\" ng-model=\"job\" class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>Agri</option><option>Civil</option><option>Water Supply</option><option>Bescom</option></select></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"jobcat==\'no\'\"><input type=\"text\" name=\"job\" ng-model=\"no\" class=\"form-control\"></div></div></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" placeholder=\"\" value=\"contact@akveo.com\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line1</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Phone</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"+1 (23) 456 7890\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line2</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Vilage</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Pin Code</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Country</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div></div><h3 class=\"with-line\">Caste Information:</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Caste</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>Hindu</option><option>Lingayat</option><option>Brahmin</option><option>Jain</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra :</label></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Self</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Nani</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Dadi</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Mother</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sub Caste</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div></div><div class=\"row\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Siblings Details :</label></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Education</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Occupation</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div></div><h3 class=\"with-line\">Your Requirement</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">From</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqemp\" value=\"yes\" ng-model=\"reqemployed\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"requnemp\" value=\"no\" ng-model=\"reqemployed\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqnot\" value=\"notmatter\" ng-model=\"reqemployed\"> <span>Not Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">To</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"col-md-6\" ng-show=\"reqemployed==\'yes\'\"><div class=\"form-group clearfix\"><label class=\"col-sm-6 control-label\">Job Category :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"jobcat\" id=\"reqcat1\" value=\"yes\" ng-model=\"reqjobcat\"> <span>Govt</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqjobcat\" id=\"reqcat2\" value=\"no\" ng-model=\"reqjobcat\"> <span>Private</span></label></div></div></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"reqjobcat==\'yes\'\"><select name=\"reqjob\" ng-model=\"reqjob\" class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>Agri</option><option>Civil</option><option>Water Supply</option><option>Bescom</option></select></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"reqjobcat==\'no\'\"><input type=\"text\" name=\"job\" ng-model=\"no\" class=\"form-control\"></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label class=\"col-sm-6 control-label\">Should Be Same Caste :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"yes\" ng-model=\"reqcaste\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"no\" ng-model=\"reqcaste\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"not\" ng-model=\"reqcaste\"> <span>Doesn\'t Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label class=\"col-sm-6 control-label\">Gotra Match :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"yes\" ng-model=\"reqgot\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"no\" ng-model=\"reqgot\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"not\" ng-model=\"reqgot\"> <span>Doesn\'t Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Vilage should be in :</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Country</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label class=\"col-sm-6 control-label\">Should Have Own House :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"yes\" ng-model=\"reqprop\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"no\" ng-model=\"reqprop\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"not\" ng-model=\"reqprop\"> <span>Doesn\'t Matter</span></label></div></div></div></div><h3 class=\"with-line\">Send Email Notifications</h3><div class=\"notification row clearfix\"><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When I receive a message</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[0]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When Someone sends me an invitation</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[1]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When profile information changes</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[2]\"></switch></div></div></div><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When anyone logs into your account from a new device or browser</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[3]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Weekly Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[4]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Daily Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[5]\"></switch></div></div></div></div><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Search</button></div>");
$templateCache.put("app/pages/matchingprofiles/profile_backUp.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><div class=\"progress-info\">Your profile is 70% Complete six 100</div><div class=\"progress\"><div class=\"progress-bar progress-bar-primary progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"70\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 70%\"></div></div><h3 class=\"with-line\">General Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">Picture</label><div class=\"col-sm-9\"><div class=\"userpic\"><div class=\"userpic-wrapper\"><img ng-src=\"{{ picture }}\" ng-click=\"uploadPicture()\"></div><i class=\"ion-ios-close-outline\" ng-click=\"removePicture()\" ng-if=\"!noPicture\"></i> <a href=\"\" class=\"change-userpic\" ng-click=\"uploadPicture()\">Change Profile Picture</a> <input type=\"file\" ng-show=\"false\" id=\"uploadFile\" ng-file-select=\"onFileSelect($files)\"></div></div></div></div><div class=\"col-md-6\"></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">First Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputFirstName\" placeholder=\"\" value=\"Anastasiya\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputLastName\" class=\"col-sm-3 control-label\">Last Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputLastName\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Department</label><div class=\"col-sm-9\"><select class=\"form-control\" selectpicker=\"\"><option>Govt</option><option>Private</option></select></div></div><div class=\"form-group row clearfix\"><label for=\"inputOccupation\" class=\"col-sm-3 control-label\">Occupation</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputOccupation\" placeholder=\"\" value=\"Front End Web Developer\"></div></div></div></div><h3 class=\"with-line\">Change Password</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\">Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputPassword\" placeholder=\"\" value=\"12345678\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputConfirmPassword\" class=\"col-sm-3 control-label\">Confirm Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputConfirmPassword\" placeholder=\"\"></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputEmail3\" class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" id=\"inputEmail3\" placeholder=\"\" value=\"contact@akveo.com\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputPhone\" class=\"col-sm-3 control-label\">Phone</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPhone\" placeholder=\"\" value=\"+1 (23) 456 7890\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Office Location</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label for=\"inputRoom\" class=\"col-sm-3 control-label\">Room</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputRoom\" placeholder=\"\" value=\"303\"></div></div></div></div><h3 class=\"with-line\">Social Profiles</h3><div class=\"social-profiles row clearfix\"><div class=\"col-md-3 col-sm-4\" ng-repeat=\"item in socialProfiles\"><a class=\"sn-link\" href=\"\" ng-click=\"showModal(item)\" ng-if=\"!item.href\"><i class=\"socicon {{ item.icon }}\"></i> <span>{{ item.name }}</span></a> <a class=\"sn-link connected\" href=\"{{ item.href }}\" target=\"_blank\" ng-if=\"item.href\"><i class=\"socicon {{ item.icon }}\"></i> <span>{{ item.name }}</span> <em class=\"ion-ios-close-empty sn-link-close\" ng-mousedown=\"unconnect(item)\"></em></a></div></div><h3 class=\"with-line\">Send Email Notifications</h3><div class=\"notification row clearfix\"><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When I receive a message</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[0]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When Someone sends me an invitation</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[1]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When profile information changes</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[2]\"></switch></div></div></div><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When anyone logs into your account from a new device or browser</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[3]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Weekly Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[4]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Daily Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[5]\"></switch></div></div></div></div><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Update Profile</button></div></div>");
$templateCache.put("app/pages/profile/profile - Copy.html","<script src=\"/app/pages/matchingprofiles/MatchingprofilesPageService.js\"></script><script src=\"/app/pages/profile/CommonService.js\"></script><div ba-panel=\"\" ba-panel-class=\"search-page\"><div class=\"panel-content\"><button ng-if=\"page == \'matching_profile\'\" type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"showModal({{requesterProfileId}},{{matchingProfileId}})\"><i class=\"ion-android-checkmark-circle\"></i>Shortlist This Profile</button> <button ng-if=\"page != \'matching_profile\'\" type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"getMatchingProfiles(\'matching\')\"><i class=\"ion-android-checkmark-circle\"></i>Search Matching Profiles</button><button type=\"button\" ng-if=\"page != \'matching_profile\'\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"getMatchingProfiles(\'contacted\')\"><i class=\"ion-android-checkmark-circle\"></i>My Contacted Profiles</button><h3 class=\"with-line\">General Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking For</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"looking_for\" id=\"male\" value=\"M\" ng-model=\"registerInfo.looking_for\"> <span>Boy</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"looking_for\" id=\"female\" value=\"F\" ng-model=\"registerInfo.looking_for\"> <span>Girl</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" value=\"father\" ng-model=\"registerInfo.guardian\"> <span>Father</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"mother\" value=\"mother\" ng-model=\"registerInfo.guardian\"> <span>Mother</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"other\" value=\"other\" ng-model=\"registerInfo.guardian\"> <span>Other</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Guardian Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_name\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian\'s Contact Number</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_contact_no\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Guardian Occupation</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" name=\"guardian_occupation\" id=\"guardian_occupation\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_occupation\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian Land</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_land\"></div></div></div></div><h3 class=\"with-line\">Details of your {{registerInfo.looking_for == \'F\' ? \'boy\' : \'girl\'}}</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"age\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.age\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Highest Education</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.education\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Height</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"height\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.height\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gender</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"profilegender\" id=\"gendermale\" value=\"M\" ng-checked=\"registerInfo.looking_for == \'F\'\" ng-model=\"registerInfo.gender\" ng-disabled=\"true\"> <span>Male</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"profilegender\" id=\"gendermale\" value=\"F\" ng-checked=\"registerInfo.looking_for == \'M\'\" ng-model=\"registerInfo.gender\" ng-disabled=\"true\"> <span>Female</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"emp\" value=\"Y\" ng-model=\"registerInfo.employed\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"unemp\" value=\"N\" ng-model=\"registerInfo.employed\"> <span>No</span></label></div></div></div></div><div class=\"row\" ng-show=\"registerInfo.employed==\'Y\'\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Job Category</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"job_type\" id=\"cat1\" value=\"GOVT\" ng-model=\"registerInfo.job_type\"> <span>Govt</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"job_type\" id=\"cat2\" value=\"PVT\" ng-model=\"registerInfo.job_type\"> <span>Private</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"registerInfo.job_type==\'GOVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.job_title\" class=\"form-control\" style=\"text-transform:uppercase\"></div><div class=\"col-sm-6\" ng-show=\"registerInfo.job_type==\'PVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.job_title\" class=\"form-control\" style=\"text-transform:uppercase\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Have Own House</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"Y\" ng-model=\"registerInfo.own_house\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"N\" ng-model=\"registerInfo.own_house\"> <span>No</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Are you a Person with Disability</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"disability\" id=\"disability_y\" ng-change=\"radioChanged(\'disability\', registerInfo.disability)\" value=\"Y\" ng-model=\"registerInfo.disability\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"disability\" id=\"disability_n\" ng-change=\"radioChanged(\'disability\', registerInfo.disability)\" value=\"N\" ng-model=\"registerInfo.disability\"> <span>No</span></label></div></div></div><div class=\"col-md-6\" ng-if=\"registerInfo.disability == \'Y\'\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Type of Disability</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.disability_type\"><option value=\"HI\">HI</option><option value=\"VI\">VI</option><option value=\"OC\">OC</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Are you a widow/widower</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_widow\" id=\"is_widow_y\" ng-change=\"radioChanged(\'is_widow\', registerInfo.is_widow)\" value=\"Y\" ng-model=\"registerInfo.is_widow\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_widow\" id=\"is_widow_n\" ng-change=\"radioChanged(\'is_widow\', registerInfo.is_widow)\" value=\"N\" ng-model=\"registerInfo.is_widow\"> <span>No</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Are you a divorcee</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_divorcee\" id=\"is_divorcee_y\" ng-change=\"radioChanged(\'is_divorcee\', registerInfo.is_divorcee)\" value=\"Y\" ng-model=\"registerInfo.is_divorcee\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_divorcee\" id=\"is_divorcee_n\" ng-change=\"radioChanged(\'is_divorcee\', registerInfo.is_divorcee)\" value=\"N\" ng-model=\"registerInfo.is_divorcee\"> <span>No</span></label></div></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" placeholder=\"\" value=\"contact@akveo.com\" ng-model=\"registerInfo.email\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line1</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.address_1\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Phone</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"+1 (23) 456 7890\" ng-model=\"registerInfo.phone\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line2</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.address_2\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">State</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.state\" ng-options=\"obj.code as obj.name for obj in countries\" ng-change=\"getCountryStates(\'state\')\" class=\"form-control\" ng-required=\"true\" id=\"state\"><option value=\"\">-- Select --</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.tehsil\" ng-options=\"x.code as x.name for x in cities\" class=\"form-control\" ng-required=\"true\" id=\"city\"><option value=\"\">-- Select --</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.district\" ng-options=\"x.code as x.name for x in sates\" ng-change=\"getStateCities(\'district\')\" class=\"form-control\" ng-required=\"true\" id=\"district\"><option value=\"\">-- Select --</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Village</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"town\" placeholder=\"\" ng-model=\"registerInfo.town\" style=\"text-transform:uppercase\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Pin Code</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.pin_code\"></div></div></div></div><h3 class=\"with-line\">Caste Information:</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Religion</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.religion\"><option>Buddhist</option><option>Christian</option><option>Hindu</option><option>Jain</option><option>Muslim</option><option>Sikh</option><option>Zoroastrian</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Caste</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.caste\"><option>General</option><option>OBC</option><option>SC</option><option>ST</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra :</label></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Self</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_self\" style=\"text-transform:uppercase\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Naani</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_naani\" style=\"text-transform:uppercase\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Daadi</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_daadi\" style=\"text-transform:uppercase\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Mother</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_mother\" style=\"text-transform:uppercase\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sub Caste</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.sub_caste\" style=\"text-transform:uppercase\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sibling Details</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.sibling_details\"></textarea></div></div></div></div><h3 class=\"with-line\">Your Requirement</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">From</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_age_from\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">To</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_age_to\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqemp\" value=\"Y\" ng-model=\"registerInfo.req_employed\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"requnemp\" value=\"N\" ng-model=\"registerInfo.req_employed\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqnot\" value=\"E\" ng-model=\"registerInfo.req_employed\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\" ng-show=\"registerInfo.req_employed==\'Y\'\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Job Category</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_job_type\" id=\"cat1\" value=\"GOVT\" ng-model=\"registerInfo.req_job_type\"> <span>Govt</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_job_type\" id=\"cat2\" value=\"PVT\" ng-model=\"registerInfo.req_job_type\"> <span>Private</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_job_type\" id=\"cat2\" value=\"OTHER\" ng-model=\"registerInfo.req_job_type\"> <span>Doesn\'t Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"registerInfo.req_job_type==\'GOVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.req_job_title\" class=\"form-control\"></div><div class=\"col-sm-6\" ng-show=\"registerInfo.req_job_type==\'PVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.req_job_title\" class=\"form-control\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Height</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"req_height\" placeholder=\"\" ng-model=\"registerInfo.req_height\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Religion</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_religion\"><option>Buddhist</option><option>Christian</option><option>Hindu</option><option>Jain</option><option>Muslim</option><option>Sikh</option><option>Zoroastrian</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Should Be Same Caste</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"Y\" ng-model=\"registerInfo.req_same_caste\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"N\" ng-model=\"registerInfo.req_same_caste\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"\" ng-model=\"registerInfo.req_same_caste\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"N\" ng-model=\"registerInfo.req_gotra_match\"> <span>Should Not<br>Be Same</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"Y\" ng-model=\"registerInfo.req_gotra_match\"> <span>Should Be<br>Same</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"\" ng-model=\"registerInfo.req_gotra_match\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">State</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.req_state\" ng-options=\"obj.code as obj.name for obj in countries\" ng-change=\"getCountryStates(\'req_state\')\" class=\"form-control\" ng-required=\"true\" id=\"req_state\"><option value=\"\">-- Select --</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.req_tehsil\" ng-options=\"x.code as x.name for x in req_cities\" class=\"form-control\" ng-required=\"true\" id=\"city\"><option value=\"\">-- Select --</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.req_district\" ng-options=\"x.code as x.name for x in req_sates\" ng-change=\"getStateCities(\'req_district\')\" class=\"form-control\" ng-required=\"true\" id=\"req_district\"><option value=\"\">-- Select --</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Village</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"req_town\" placeholder=\"\" ng-model=\"registerInfo.req_town\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Villages should not be among</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_town_not_list\"></textarea></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Should Have Own House</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"Y\" ng-model=\"registerInfo.req_own_house\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"N\" ng-model=\"registerInfo.req_own_house\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"E\" ng-model=\"registerInfo.req_own_house\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking for a person with disability</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_disability\" id=\"req_disability_y\" value=\"Y\" ng-model=\"registerInfo.req_disability\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_disability\" id=\"req_disability_n\" value=\"N\" ng-model=\"registerInfo.req_disability\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_disability\" id=\"req_disability_e\" value=\"E\" ng-model=\"registerInfo.req_disability\"> <span>Doesn\'t Matter</span></label></div></div></div><div class=\"col-md-6\" ng-if=\"registerInfo.req_disability == \'Y\'\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Type of Disability</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_disability_type\"><option value=\"HI\">HI</option><option value=\"VI\">VI</option><option value=\"OC\">OC</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking for widow/widower</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_widow\" id=\"req_is_widow_y\" value=\"Y\" ng-model=\"registerInfo.req_is_widow\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_widow\" id=\"req_is_widow_n\" value=\"N\" ng-model=\"registerInfo.req_is_widow\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_widow\" id=\"req_is_widow_e\" value=\"E\" ng-model=\"registerInfo.req_is_widow\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking for divorcee</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_divorcee\" id=\"req_is_divorcee_y\" value=\"Y\" ng-model=\"registerInfo.req_is_divorcee\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_divorcee\" id=\"req_is_divorcee_n\" value=\"N\" ng-model=\"registerInfo.req_is_divorcee\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_divorcee\" id=\"req_is_divorcee_e\" value=\"E\" ng-model=\"registerInfo.req_is_divorcee\"> <span>Doesn\'t Matter</span></label></div></div></div></div></div>");
$templateCache.put("app/pages/profile/profile.html","<script src=\"/app/pages/matchingprofiles/MatchingprofilesPageService.js\"></script><script src=\"/app/pages/profile/CommonService.js\"></script><div ba-panel=\"\" ba-panel-class=\"search-page\"><div class=\"panel-content\"><button ng-if=\"page == \'matching_profile\'\" type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"showModal({{requesterProfileId}},{{matchingProfileId}})\"><i class=\"ion-android-checkmark-circle\"></i>Shortlist This Profile</button> <button ng-if=\"page != \'matching_profile\'\" type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"getMatchingProfiles(\'matching\')\"><i class=\"ion-android-checkmark-circle\"></i>Search Matching Profiles</button><button type=\"button\" ng-if=\"page != \'matching_profile\'\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"getMatchingProfiles(\'contacted\')\"><i class=\"ion-android-checkmark-circle\"></i>My Contacted Profiles</button><h3 class=\"with-line\">General Information</h3><div ng-if=\"errorMsg.length > 0\" class=\"col-md-8\" style=\"color:red;border:1px solid gray;margin-bottom:20px;\"><p style=\"margin-bottom:3px;\" ng-repeat=\"eachErrorMsg in errorMsg\" track=\"\" by=\"\" $index=\"\">{{eachErrorMsg}}</p></div><br></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" value=\"father\" ng-model=\"registerInfo.guardian\"> <span>Father</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"mother\" value=\"mother\" ng-model=\"registerInfo.guardian\"> <span>Mother</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"other\" value=\"other\" ng-model=\"registerInfo.guardian\"> <span>Other</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking For Your</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"looking_for\" id=\"female\" value=\"F\" ng-model=\"registerInfo.looking_for\"> <span>Son</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"looking_for\" id=\"male\" value=\"M\" ng-model=\"registerInfo.looking_for\"> <span>Daughter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Guardian Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_name\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Guardian Occupation</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" name=\"guardian_occupation\" id=\"guardian_occupation\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_occupation\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian Land</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_land\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian\'s Contact Number</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_contact_no\"></div></div></div></div><div class=\"row\" ng-if=\"registerInfo.guardian_otp_generated == \'yes\'\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Enter OTP</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" id=\"guardian_otp\" ng-model=\"registerInfo.guardian_otp\"></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" placeholder=\"\" value=\"contact@akveo.com\" ng-model=\"registerInfo.email\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line1</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.address_1\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Phone</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"+1 (23) 456 7890\" ng-model=\"registerInfo.phone\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line2</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.address_2\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">State</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.state\" ng-options=\"obj.code as obj.name for obj in countries\" ng-change=\"getCountryStates(\'state\')\" class=\"form-control\" ng-required=\"true\" id=\"state\"><option value=\"\">-- Select --</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.tehsil\" ng-options=\"x.code as x.name for x in cities\" class=\"form-control\" ng-required=\"true\" id=\"city\"><option value=\"\">-- Select --</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.district\" ng-options=\"x.code as x.name for x in sates\" ng-change=\"getStateCities(\'district\')\" class=\"form-control\" ng-required=\"true\" id=\"district\"><option value=\"\">-- Select --</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Village</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"town\" placeholder=\"\" ng-model=\"registerInfo.town\" style=\"text-transform:uppercase\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Pin Code</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.pin_code\"></div></div></div></div><h3 class=\"with-line\">Details of your {{registerInfo.looking_for == \'F\' ? \'boy\' : \'girl\'}}</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"age\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.age\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Highest Education</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.education\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Height</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"height\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.height\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"emp\" value=\"Y\" ng-model=\"registerInfo.employed\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"unemp\" value=\"N\" ng-model=\"registerInfo.employed\"> <span>No</span></label></div></div></div></div><div class=\"row\" ng-show=\"registerInfo.employed==\'Y\'\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Job Category</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"job_type\" id=\"cat1\" value=\"GOVT\" ng-model=\"registerInfo.job_type\"> <span>Govt</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"job_type\" id=\"cat2\" value=\"PVT\" ng-model=\"registerInfo.job_type\"> <span>Private</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"registerInfo.job_type==\'GOVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.job_title\" class=\"form-control\" style=\"text-transform:uppercase\"></div><div class=\"col-sm-6\" ng-show=\"registerInfo.job_type==\'PVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.job_title\" class=\"form-control\" style=\"text-transform:uppercase\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Have Own House</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"Y\" ng-model=\"registerInfo.own_house\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"N\" ng-model=\"registerInfo.own_house\"> <span>No</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Are you a Person with Disability</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"disability\" id=\"disability_y\" ng-change=\"radioChanged(\'disability\', registerInfo.disability)\" value=\"Y\" ng-model=\"registerInfo.disability\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"disability\" id=\"disability_n\" ng-change=\"radioChanged(\'disability\', registerInfo.disability)\" value=\"N\" ng-model=\"registerInfo.disability\"> <span>No</span></label></div></div></div><div class=\"col-md-6\" ng-if=\"registerInfo.disability == \'Y\'\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Type of Disability</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.disability_type\"><option value=\"HI\">HI</option><option value=\"VI\">VI</option><option value=\"OC\">OC</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Are you a widow/widower</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_widow\" id=\"is_widow_y\" ng-change=\"radioChanged(\'is_widow\', registerInfo.is_widow)\" value=\"Y\" ng-model=\"registerInfo.is_widow\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_widow\" id=\"is_widow_n\" ng-change=\"radioChanged(\'is_widow\', registerInfo.is_widow)\" value=\"N\" ng-model=\"registerInfo.is_widow\"> <span>No</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Are you a divorcee</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_divorcee\" id=\"is_divorcee_y\" ng-change=\"radioChanged(\'is_divorcee\', registerInfo.is_divorcee)\" value=\"Y\" ng-model=\"registerInfo.is_divorcee\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_divorcee\" id=\"is_divorcee_n\" ng-change=\"radioChanged(\'is_divorcee\', registerInfo.is_divorcee)\" value=\"N\" ng-model=\"registerInfo.is_divorcee\"> <span>No</span></label></div></div></div></div><h3 class=\"with-line\">Caste Information:</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Religion</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.religion\"><option>Buddhist</option><option>Christian</option><option>Hindu</option><option>Jain</option><option>Muslim</option><option>Sikh</option><option>Zoroastrian</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Caste</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" ng-change=\"refreshSubCaste(\'caste\')\" selectpicker=\"\" ng-model=\"registerInfo.caste\"><option>General</option><option>OBC</option><option>SC</option><option>ST</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra</label></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Self</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_self\" style=\"text-transform:uppercase\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Naani</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_naani\" style=\"text-transform:uppercase\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Daadi</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_daadi\" style=\"text-transform:uppercase\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Mother</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_mother\" style=\"text-transform:uppercase\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sub Caste</label><div class=\"col-sm-9\"><div class=\"col-sm-6\"><select ng-model=\"registerInfo.sub_caste\" ng-options=\"obj.sub_caste as obj.sub_caste for obj in sub_caste_list\" class=\"form-control\" ng-required=\"true\" id=\"sub_caste\"><option value=\"\">-- Select --</option></select></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sibling Details</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.sibling_details\"></textarea></div></div></div></div><h3 class=\"with-line\">Your Requirement</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">From</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_age_from\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">To</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_age_to\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqemp\" value=\"Y\" ng-model=\"registerInfo.req_employed\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"requnemp\" value=\"N\" ng-model=\"registerInfo.req_employed\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqnot\" value=\"E\" ng-model=\"registerInfo.req_employed\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\" ng-show=\"registerInfo.req_employed==\'Y\'\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Job Category</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_job_type\" id=\"cat1\" value=\"GOVT\" ng-model=\"registerInfo.req_job_type\"> <span>Govt</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_job_type\" id=\"cat2\" value=\"PVT\" ng-model=\"registerInfo.req_job_type\"> <span>Private</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_job_type\" id=\"cat2\" value=\"OTHER\" ng-model=\"registerInfo.req_job_type\"> <span>Doesn\'t Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"registerInfo.req_job_type==\'GOVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.req_job_title\" class=\"form-control\"></div><div class=\"col-sm-6\" ng-show=\"registerInfo.req_job_type==\'PVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.req_job_title\" class=\"form-control\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Height</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"req_height\" placeholder=\"\" ng-model=\"registerInfo.req_height\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Religion</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_religion\"><option>Buddhist</option><option>Christian</option><option>Hindu</option><option>Jain</option><option>Muslim</option><option>Sikh</option><option>Zoroastrian</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Should Be Same Caste</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"Y\" ng-model=\"registerInfo.req_same_caste\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"N\" ng-model=\"registerInfo.req_same_caste\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"E\" ng-model=\"registerInfo.req_same_caste\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"N\" ng-model=\"registerInfo.req_gotra_match\"> <span>Should Not<br>Be Same</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"Y\" ng-model=\"registerInfo.req_gotra_match\"> <span>Should Be<br>Same</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"E\" ng-model=\"registerInfo.req_gotra_match\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">State</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.req_state\" ng-options=\"obj.code as obj.name for obj in countries\" ng-change=\"getCountryStates(\'req_state\')\" class=\"form-control\" ng-required=\"true\" id=\"req_state\"><option value=\"\">-- Select --</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.req_tehsil\" ng-options=\"x.code as x.name for x in req_cities\" class=\"form-control\" ng-required=\"true\" id=\"city\"><option value=\"\">-- Select --</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.req_district\" ng-options=\"x.code as x.name for x in req_sates\" ng-change=\"getStateCities(\'req_district\')\" class=\"form-control\" ng-required=\"true\" id=\"req_district\"><option value=\"\">-- Select --</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Village</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"req_town\" placeholder=\"\" ng-model=\"registerInfo.req_town\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Villages should not be among</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_town_not_list\"></textarea></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Should Have Own House</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"Y\" ng-model=\"registerInfo.req_own_house\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"N\" ng-model=\"registerInfo.req_own_house\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"E\" ng-model=\"registerInfo.req_own_house\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking for a person with disability</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_disability\" id=\"req_disability_y\" value=\"Y\" ng-model=\"registerInfo.req_disability\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_disability\" id=\"req_disability_n\" value=\"N\" ng-model=\"registerInfo.req_disability\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_disability\" id=\"req_disability_e\" value=\"E\" ng-model=\"registerInfo.req_disability\"> <span>Doesn\'t Matter</span></label></div></div></div><div class=\"col-md-6\" ng-if=\"registerInfo.req_disability == \'Y\'\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Type of Disability</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_disability_type\"><option value=\"HI\">HI</option><option value=\"VI\">VI</option><option value=\"OC\">OC</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking for widow/widower</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_widow\" id=\"req_is_widow_y\" value=\"Y\" ng-model=\"registerInfo.req_is_widow\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_widow\" id=\"req_is_widow_n\" value=\"N\" ng-model=\"registerInfo.req_is_widow\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_widow\" id=\"req_is_widow_e\" value=\"E\" ng-model=\"registerInfo.req_is_widow\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking for divorcee</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_divorcee\" id=\"req_is_divorcee_y\" value=\"Y\" ng-model=\"registerInfo.req_is_divorcee\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_divorcee\" id=\"req_is_divorcee_n\" value=\"N\" ng-model=\"registerInfo.req_is_divorcee\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_divorcee\" id=\"req_is_divorcee_e\" value=\"E\" ng-model=\"registerInfo.req_is_divorcee\"> <span>Doesn\'t Matter</span></label></div></div></div></div></div>");
$templateCache.put("app/pages/profile/profileModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Add Account</h4></div><form name=\"linkForm\"><div class=\"modal-body\"><p>Paste a link to your profile into the box below</p><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Link to Profile\" ng-model=\"link\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok(link)\">Save changes</button></div></form></div>");
$templateCache.put("app/pages/profile/profile_backUp (2).html","<div ba-panel=\"\" ba-panel-class=\"search-page\"><div class=\"panel-content\"><a href=\"#/contacted\"><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"getContact()\"><i class=\"ion-android-checkmark-circle\"></i>My contacted profiles</button></a> <button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"getContact()\"><i class=\"ion-android-checkmark-circle\"></i>My contacted profiles update</button><div class=\"progress-info\">Your profile is 70% Complete 123 : {{userName}} profileData : {{profileData}}</div><div class=\"progress\"><div class=\"progress-bar progress-bar-primary progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"70\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 70%\"></div></div><h3 class=\"with-line\">General Information</h3><div class=\"row\"><label class=\"col-sm-3 control-label\">Looking For :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"gender\" id=\"male\" value=\"male\" ng-model=\"gender\"> <span>Male</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"gender\" id=\"female\" value=\"female\" ng-model=\"gender\"> <span>Female</span></label></div></div><div class=\"row\"><label class=\"col-sm-3 control-label\">Guardian :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" value=\"father\" ng-model=\"guardian\"> <span>Father</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"mother\" value=\"mother\" ng-model=\"guardian\"> <span>Mother</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"other\" value=\"other\" ng-model=\"guardian\"> <span>Other</span></label></div><div class=\"col-md-2\" ng-show=\"guardian==\'other\'\"><input type=\"text\" class=\"form-control\" name=\"otherdtls\" id=\"otherdtls\" value=\"\"></div><div class=\"col-md-9\" ng-show=\"guardian==\'other\'\"><div class=\"form-group row clearfix\"><label for=\"guardianmdn\" class=\"col-sm-3 control-label\">Guardian\'s Contact Number :</label><div class=\"col-sm-3\"><input type=\"tel\" class=\"form-control\" id=\"guardianmdn\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label for=\"guardianoccupation\" class=\"col-sm-3 control-label\">Guardian Occupation :</label><div class=\"col-sm-3\"><input type=\"text\" class=\"form-control\" id=\"guardianoccupation\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label for=\"guardianland\" class=\"col-sm-3 control-label\">Guardian Land :</label><div class=\"col-sm-3\"><input type=\"text\" class=\"form-control\" id=\"guardianland\" placeholder=\"\" value=\"\"></div></div></div></div><h3 class=\"with-line\">Details of your boy/girl</h3><div class=\"row\"><label class=\"col-sm-3 control-label\">Gender :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"gendermale\" id=\"gendermale\" value=\"male\" ng-model=\"gender\" ng-disabled=\"true\"> <span>Male</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"genderfemale\" id=\"genderfemale\" value=\"female\" ng-model=\"gender\" ng-disabled=\"true\"> <span>Female</span></label></div></div><h3 class=\"with-line\">Personal Information:</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"qualification\" class=\"col-sm-6 control-label\">Highest Education</label><div class=\"col-sm-3\"><input type=\"text\" class=\"form-control\" id=\"qualification\" placeholder=\"\" value=\"\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-6 control-label\">Employed :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"emp\" value=\"yes\" ng-model=\"employed\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"unemp\" value=\"no\" ng-model=\"employed\"> <span>No</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\" ng-show=\"employed==\'yes\'\"><div class=\"form-group row clearfix\"><label class=\"col-sm-6 control-label\">Job Category :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"jobcat\" id=\"cat1\" value=\"yes\" ng-model=\"jobcat\"> <span>Govt</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"jobcat\" id=\"cat2\" value=\"no\" ng-model=\"jobcat\"> <span>Private</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"jobcat==\'yes\'\"><select name=\"job\" ng-model=\"job\" class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>Agri</option><option>Civil</option><option>Water Supply</option><option>Bescom</option></select></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"jobcat==\'no\'\"><input type=\"text\" name=\"job\" ng-model=\"no\" class=\"form-control\"></div></div></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" placeholder=\"\" value=\"contact@akveo.com\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line1</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Phone</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"+1 (23) 456 7890\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line2</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Vilage</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Pin Code</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Country</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div></div><h3 class=\"with-line\">Caste Information:</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Caste</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>Hindu</option><option>Lingayat</option><option>Brahmin</option><option>Jain</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra :</label></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Self</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Nani</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Dadi</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Mother</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sub Caste</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div></div><div class=\"row\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Siblings Details :</label></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Education</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Occupation</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div></div><h3 class=\"with-line\">Your Requirement</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">From</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqemp\" value=\"yes\" ng-model=\"reqemployed\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"requnemp\" value=\"no\" ng-model=\"reqemployed\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqnot\" value=\"notmatter\" ng-model=\"reqemployed\"> <span>Not Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">To</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"col-md-6\" ng-show=\"reqemployed==\'yes\'\"><div class=\"form-group clearfix\"><label class=\"col-sm-6 control-label\">Job Category :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"jobcat\" id=\"reqcat1\" value=\"yes\" ng-model=\"reqjobcat\"> <span>Govt</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqjobcat\" id=\"reqcat2\" value=\"no\" ng-model=\"reqjobcat\"> <span>Private</span></label></div></div></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"reqjobcat==\'yes\'\"><select name=\"reqjob\" ng-model=\"reqjob\" class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>Agri</option><option>Civil</option><option>Water Supply</option><option>Bescom</option></select></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"reqjobcat==\'no\'\"><input type=\"text\" name=\"job\" ng-model=\"no\" class=\"form-control\"></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label class=\"col-sm-6 control-label\">Should Be Same Caste :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"yes\" ng-model=\"reqcaste\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"no\" ng-model=\"reqcaste\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"not\" ng-model=\"reqcaste\"> <span>Doesn\'t Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label class=\"col-sm-6 control-label\">Gotra Match :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"yes\" ng-model=\"reqgot\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"no\" ng-model=\"reqgot\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"not\" ng-model=\"reqgot\"> <span>Doesn\'t Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Vilage should be in :</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Country</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label class=\"col-sm-6 control-label\">Should Have Own House :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"yes\" ng-model=\"reqprop\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"no\" ng-model=\"reqprop\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"not\" ng-model=\"reqprop\"> <span>Doesn\'t Matter</span></label></div></div></div></div><h3 class=\"with-line\">Send Email Notifications</h3><div class=\"notification row clearfix\"><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When I receive a message</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[0]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When Someone sends me an invitation</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[1]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When profile information changes</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[2]\"></switch></div></div></div><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When anyone logs into your account from a new device or browser</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[3]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Weekly Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[4]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Daily Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[5]\"></switch></div></div></div></div><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Search</button></div>");
$templateCache.put("app/pages/profile/profile_backUp.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><div class=\"progress-info\">Your profile is 70% Complete six 100</div><div class=\"progress\"><div class=\"progress-bar progress-bar-primary progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"70\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 70%\"></div></div><h3 class=\"with-line\">General Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">Picture</label><div class=\"col-sm-9\"><div class=\"userpic\"><div class=\"userpic-wrapper\"><img ng-src=\"{{ picture }}\" ng-click=\"uploadPicture()\"></div><i class=\"ion-ios-close-outline\" ng-click=\"removePicture()\" ng-if=\"!noPicture\"></i> <a href=\"\" class=\"change-userpic\" ng-click=\"uploadPicture()\">Change Profile Picture</a> <input type=\"file\" ng-show=\"false\" id=\"uploadFile\" ng-file-select=\"onFileSelect($files)\"></div></div></div></div><div class=\"col-md-6\"></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">First Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputFirstName\" placeholder=\"\" value=\"Anastasiya\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputLastName\" class=\"col-sm-3 control-label\">Last Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputLastName\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Department</label><div class=\"col-sm-9\"><select class=\"form-control\" selectpicker=\"\"><option>Govt</option><option>Private</option></select></div></div><div class=\"form-group row clearfix\"><label for=\"inputOccupation\" class=\"col-sm-3 control-label\">Occupation</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputOccupation\" placeholder=\"\" value=\"Front End Web Developer\"></div></div></div></div><h3 class=\"with-line\">Change Password</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\">Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputPassword\" placeholder=\"\" value=\"12345678\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputConfirmPassword\" class=\"col-sm-3 control-label\">Confirm Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputConfirmPassword\" placeholder=\"\"></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputEmail3\" class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" id=\"inputEmail3\" placeholder=\"\" value=\"contact@akveo.com\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputPhone\" class=\"col-sm-3 control-label\">Phone</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPhone\" placeholder=\"\" value=\"+1 (23) 456 7890\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Office Location</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label for=\"inputRoom\" class=\"col-sm-3 control-label\">Room</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputRoom\" placeholder=\"\" value=\"303\"></div></div></div></div><h3 class=\"with-line\">Social Profiles</h3><div class=\"social-profiles row clearfix\"><div class=\"col-md-3 col-sm-4\" ng-repeat=\"item in socialProfiles\"><a class=\"sn-link\" href=\"\" ng-click=\"showModal(item)\" ng-if=\"!item.href\"><i class=\"socicon {{ item.icon }}\"></i> <span>{{ item.name }}</span></a> <a class=\"sn-link connected\" href=\"{{ item.href }}\" target=\"_blank\" ng-if=\"item.href\"><i class=\"socicon {{ item.icon }}\"></i> <span>{{ item.name }}</span> <em class=\"ion-ios-close-empty sn-link-close\" ng-mousedown=\"unconnect(item)\"></em></a></div></div><h3 class=\"with-line\">Send Email Notifications</h3><div class=\"notification row clearfix\"><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When I receive a message</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[0]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When Someone sends me an invitation</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[1]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When profile information changes</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[2]\"></switch></div></div></div><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When anyone logs into your account from a new device or browser</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[3]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Weekly Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[4]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Daily Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[5]\"></switch></div></div></div></div><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Update Profile</button></div></div>");
$templateCache.put("app/pages/profile/profile_backup_20_Aug_2016 - Copy.html","<script src=\"/app/pages/matchingprofiles/MatchingprofilesPageService.js\"></script><script src=\"/app/pages/profile/CommonService.js\"></script><div ba-panel=\"\" ba-panel-class=\"search-page\"><div class=\"panel-content\"><button ng-if=\"page == \'matching_profile\'\" type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"showModal({{requesterProfileId}},{{matchingProfileId}})\"><i class=\"ion-android-checkmark-circle\"></i>Shortlist This Profile</button> <button ng-if=\"page != \'matching_profile\'\" type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"getMatchingProfiles(\'matching\')\"><i class=\"ion-android-checkmark-circle\"></i>Search Matching Profiles</button><button type=\"button\" ng-if=\"page != \'matching_profile\'\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"getMatchingProfiles(\'contacted\')\"><i class=\"ion-android-checkmark-circle\"></i>My Contacted Profiles</button><h3 class=\"with-line\">General Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">Picture</label><div class=\"col-sm-9\"><div class=\"userpic\"><div class=\"userpic-wrapper\"><img ng-src=\"{{ picture }}\" ng-click=\"uploadPicture()\"></div><i class=\"ion-ios-close-outline\" ng-click=\"removePicture()\" ng-if=\"!noPicture\"></i> <a href=\"\" class=\"change-userpic\" ng-click=\"uploadPicture()\">Change Profile Picture</a> <input type=\"file\" ng-show=\"false\" id=\"uploadFile\" ng-file-select=\"onFileSelect($files)\"></div></div></div></div><div class=\"col-md-6\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking For :</label> registerInfo.looking_for : {{registerInfo.looking_for}}<div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"looking_for\" id=\"male\" ng-checked=\"registerInfo.looking_for == \'M\'\" value=\"M\" ng-model=\"registerInfo.looking_for\"> <span>Boy</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"looking_for\" id=\"female\" ng-checked=\"registerInfo.looking_for == \'F\'\" value=\"F\" ng-model=\"registerInfo.looking_for\"> <span>Girl</span></label></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" value=\"father\" ng-model=\"registerInfo.guardian\"> <span>Father</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"mother\" value=\"mother\" ng-model=\"registerInfo.guardian\"> <span>Mother</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"other\" value=\"other\" ng-model=\"registerInfo.guardian\"> <span>Other</span></label></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Guardian Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_name\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian\'s Contact Number</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_contact_no\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Guardian Occupation</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" name=\"guardian_occupation\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_occupation\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian Land</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_land\"></div></div></div></div><h3 class=\"with-line\">Details of your {{registerInfo.looking_for == \'female\' ? \'boy\' : \'girl\'}}</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"age\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.age\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Highest Education</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.education\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gender</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"profilegender\" id=\"gendermale\" value=\"male\" ng-checked=\"registerInfo.looking_for == \'F\'\" ng-model=\"registerInfo.gender\" ng-disabled=\"true\"> <span>Male</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"profilegender\" id=\"gendermale\" value=\"female\" ng-checked=\"registerInfo.looking_for == \'M\'\" ng-model=\"registerInfo.gender\" ng-disabled=\"true\"> <span>Female</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"emp\" value=\"Y\" ng-checked=\"registerInfo.employed == \'Y\'\" ng-model=\"registerInfo.employed\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"unemp\" value=\"N\" ng-checked=\"registerInfo.employed != \'Y\'\" ng-model=\"registerInfo.employed\"> <span>No</span></label></div></div></div></div><div class=\"row\" ng-show=\"registerInfo.employed==\'Y\'\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Job Category :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"job_type\" id=\"cat1\" value=\"GOVT\" ng-model=\"registerInfo.job_type\"> <span>Govt</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"job_type\" id=\"cat2\" value=\"PVT\" ng-model=\"registerInfo.job_type\"> <span>Private</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"registerInfo.job_type==\'GOVT\'\"><select name=\"job\" ng-model=\"registerInfo.job_title\" class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>Agri</option><option>Civil</option><option>Water Supply</option><option>Bescom</option></select></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"registerInfo.job_type==\'PVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.job_title\" class=\"form-control\"></div></div></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" placeholder=\"\" value=\"contact@akveo.com\" ng-model=\"registerInfo.email\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line1</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.address_1\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Phone</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"+1 (23) 456 7890\" ng-model=\"registerInfo.phone\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line2</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.address_2\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">State</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.state\" ng-options=\"state.name for state in states track by state.name\"></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.tehsil\" ng-options=\"tehsil.name for tehsil in ( tehsils | filter: {district: { code: registerInfo.district.code }}) track by tehsil.name\"></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.district\" ng-options=\"district.name for district in ( districts | filter: {state: { code: registerInfo.state.code }}) track by district.name\"></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Pin Code</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.pin_code\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Village</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.town\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Or Enter</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.town_entered\"></div></div></div></div><h3 class=\"with-line\">Caste Information:</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Caste</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.caste\"><option>Hindu</option><option>Lingayat</option><option>Brahmin</option><option>Jain</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra :</label></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Self</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_self\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Naani</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_naani\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Daadi</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_daadi\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Mother</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_mother\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sub Caste</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.sub_caste\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sibling Details</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.sibling_details\"></textarea></div></div></div></div><h3 class=\"with-line\">Your Requirement</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">From</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_age_from\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqemp\" value=\"Y\" ng-model=\"registerInfo.req_employed\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"requnemp\" value=\"N\" ng-model=\"registerInfo.req_employed\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqnot\" value=\"\" ng-model=\"registerInfo.req_employed\"> <span>Not Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">To</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_age_to\"></div></div></div><div class=\"col-md-6\"><div class=\"col-md-6\" ng-show=\"reqemployed==\'yes\'\"><div class=\"form-group clearfix\"><label class=\"col-sm-6 control-label\">Job Category :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"jobcat\" id=\"reqcat1\" value=\"Y\" ng-model=\"registerInfo.req_job_type\"> <span>Govt</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqjobcat\" id=\"reqcat2\" value=\"N\" ng-model=\"registerInfo.req_job_type\"> <span>Private</span></label></div></div></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"reqjobcat==\'Y\'\"><select name=\"reqjob\" class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_job_title\"><option>Agri</option><option>Civil</option><option>Water Supply</option><option>Bescom</option></select></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"reqjobcat==\'N\'\"><input type=\"text\" name=\"job\" class=\"form-control\" ng-model=\"registerInfo.req_job_title\"></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Should Be Same Caste :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"Y\" ng-model=\"registerInfo.req_same_caste\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"N\" ng-model=\"registerInfo.req_same_caste\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"\" ng-model=\"registerInfo.req_same_caste\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"N\" ng-model=\"registerInfo.req_gotra_match\"> <span>Should Not Be Same</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"Y\" ng-model=\"registerInfo.req_gotra_match\"> <span>Should Be Same</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"\" ng-model=\"registerInfo.req_gotra_match\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">State</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_state\" ng-options=\"state.name for state in states track by state.name\"></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_tehsil\" ng-options=\"tehsil.name for tehsil in ( tehsils | filter: {district: { code: registerInfo.req_district.code }}) track by tehsil.name\"></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_district\" ng-options=\"district.name for district in ( districts | filter: {state: { code: registerInfo.req_state.code }}) track by district.name\"></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Village</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_village\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Villages should not be in</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_town_not_list\"></textarea></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Should Have Own House :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"Y\" ng-model=\"registerInfo.req_own_house\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"N\" ng-model=\"registerInfo.req_own_house\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"\" ng-model=\"registerInfo.req_own_house\"> <span>Doesn\'t Matter</span></label></div></div></div></div></div>");
$templateCache.put("app/pages/profile/profile_backup_20_Aug_2016.html","<script src=\"/app/pages/matchingprofiles/MatchingprofilesPageService.js\"></script><script src=\"/app/pages/profile/CommonService.js\"></script><div ba-panel=\"\" ba-panel-class=\"search-page\"><div class=\"panel-content\"><button ng-if=\"page == \'matching_profile\'\" type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"showModal({{requesterProfileId}},{{matchingProfileId}})\"><i class=\"ion-android-checkmark-circle\"></i>Shortlist This Profile</button> <button ng-if=\"page != \'matching_profile\'\" type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"getMatchingProfiles(\'matching\')\"><i class=\"ion-android-checkmark-circle\"></i>Search Matching Profiles</button><button type=\"button\" ng-if=\"page != \'matching_profile\'\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"getMatchingProfiles(\'contacted\')\"><i class=\"ion-android-checkmark-circle\"></i>My Contacted Profiles</button><h3 class=\"with-line\">General Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">Picture</label><div class=\"col-sm-9\"><div class=\"userpic\"><div class=\"userpic-wrapper\"><img ng-src=\"{{ picture }}\" ng-click=\"uploadPicture()\"></div><i class=\"ion-ios-close-outline\" ng-click=\"removePicture()\" ng-if=\"!noPicture\"></i> <a href=\"\" class=\"change-userpic\" ng-click=\"uploadPicture()\">Change Profile Picture</a> <input type=\"file\" ng-show=\"false\" id=\"uploadFile\" ng-file-select=\"onFileSelect($files)\"></div></div></div></div><div class=\"col-md-6\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking For :</label> registerInfo.looking_for : {{registerInfo.looking_for}}<div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"looking_for\" id=\"male\" ng-checked=\"registerInfo.looking_for == \'M\'\" value=\"M\" ng-model=\"registerInfo.looking_for\"> <span>Boy</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"looking_for\" id=\"female\" ng-checked=\"registerInfo.looking_for == \'F\'\" value=\"F\" ng-model=\"registerInfo.looking_for\"> <span>Girl</span></label></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" value=\"father\" ng-model=\"registerInfo.guardian\"> <span>Father</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"mother\" value=\"mother\" ng-model=\"registerInfo.guardian\"> <span>Mother</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"guardian\" id=\"other\" value=\"other\" ng-model=\"registerInfo.guardian\"> <span>Other</span></label></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Guardian Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_name\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian\'s Contact Number</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_contact_no\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Guardian Occupation</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" name=\"guardian_occupation\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_occupation\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian Land</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_land\"></div></div></div></div><h3 class=\"with-line\">Details of your {{registerInfo.looking_for == \'female\' ? \'boy\' : \'girl\'}}</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"age\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.age\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Highest Education</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.education\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gender</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"profilegender\" id=\"gendermale\" value=\"male\" ng-checked=\"registerInfo.looking_for == \'F\'\" ng-model=\"registerInfo.gender\" ng-disabled=\"true\"> <span>Male</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"profilegender\" id=\"gendermale\" value=\"female\" ng-checked=\"registerInfo.looking_for == \'M\'\" ng-model=\"registerInfo.gender\" ng-disabled=\"true\"> <span>Female</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"emp\" value=\"Y\" ng-checked=\"registerInfo.employed == \'Y\'\" ng-model=\"registerInfo.employed\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"unemp\" value=\"N\" ng-checked=\"registerInfo.employed != \'Y\'\" ng-model=\"registerInfo.employed\"> <span>No</span></label></div></div></div></div><div class=\"row\" ng-show=\"registerInfo.employed==\'Y\'\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Job Category :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"job_type\" id=\"cat1\" value=\"GOVT\" ng-model=\"registerInfo.job_type\"> <span>Govt</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"job_type\" id=\"cat2\" value=\"PVT\" ng-model=\"registerInfo.job_type\"> <span>Private</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"registerInfo.job_type==\'GOVT\'\"><select name=\"job\" ng-model=\"registerInfo.job_title\" class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>Agri</option><option>Civil</option><option>Water Supply</option><option>Bescom</option></select></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"registerInfo.job_type==\'PVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.job_title\" class=\"form-control\"></div></div></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" placeholder=\"\" value=\"contact@akveo.com\" ng-model=\"registerInfo.email\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line1</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.address_1\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Phone</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"+1 (23) 456 7890\" ng-model=\"registerInfo.phone\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line2</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.address_2\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">State</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.state\" ng-options=\"state.name for state in states track by state.name\"></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.tehsil\" ng-options=\"tehsil.name for tehsil in ( tehsils | filter: {district: { code: registerInfo.district.code }}) track by tehsil.name\"></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.district\" ng-options=\"district.name for district in ( districts | filter: {state: { code: registerInfo.state.code }}) track by district.name\"></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Pin Code</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.pin_code\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Village</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.town\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Or Enter</label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.town_entered\"></div></div></div></div><h3 class=\"with-line\">Caste Information:</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Caste</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.caste\"><option>Hindu</option><option>Lingayat</option><option>Brahmin</option><option>Jain</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra :</label></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Self</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_self\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Naani</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_naani\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Daadi</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_daadi\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Mother</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_mother\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sub Caste</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.sub_caste\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sibling Details</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.sibling_details\"></textarea></div></div></div></div><h3 class=\"with-line\">Your Requirement</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">From</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_age_from\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqemp\" value=\"Y\" ng-model=\"registerInfo.req_employed\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"requnemp\" value=\"N\" ng-model=\"registerInfo.req_employed\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqnot\" value=\"\" ng-model=\"registerInfo.req_employed\"> <span>Not Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">To</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_age_to\"></div></div></div><div class=\"col-md-6\"><div class=\"col-md-6\" ng-show=\"reqemployed==\'yes\'\"><div class=\"form-group clearfix\"><label class=\"col-sm-6 control-label\">Job Category :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"jobcat\" id=\"reqcat1\" value=\"Y\" ng-model=\"registerInfo.req_job_type\"> <span>Govt</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqjobcat\" id=\"reqcat2\" value=\"N\" ng-model=\"registerInfo.req_job_type\"> <span>Private</span></label></div></div></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"reqjobcat==\'Y\'\"><select name=\"reqjob\" class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_job_title\"><option>Agri</option><option>Civil</option><option>Water Supply</option><option>Bescom</option></select></div><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"reqjobcat==\'N\'\"><input type=\"text\" name=\"job\" class=\"form-control\" ng-model=\"registerInfo.req_job_title\"></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Should Be Same Caste :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"Y\" ng-model=\"registerInfo.req_same_caste\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"N\" ng-model=\"registerInfo.req_same_caste\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"\" ng-model=\"registerInfo.req_same_caste\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"N\" ng-model=\"registerInfo.req_gotra_match\"> <span>Should Not Be Same</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"Y\" ng-model=\"registerInfo.req_gotra_match\"> <span>Should Be Same</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"\" ng-model=\"registerInfo.req_gotra_match\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">State</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_state\" ng-options=\"state.name for state in states track by state.name\"></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_tehsil\" ng-options=\"tehsil.name for tehsil in ( tehsils | filter: {district: { code: registerInfo.req_district.code }}) track by tehsil.name\"></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_district\" ng-options=\"district.name for district in ( districts | filter: {state: { code: registerInfo.req_state.code }}) track by district.name\"></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Village</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_village\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Villages should not be in</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_town_not_list\"></textarea></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Should Have Own House :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"Y\" ng-model=\"registerInfo.req_own_house\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"N\" ng-model=\"registerInfo.req_own_house\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"\" ng-model=\"registerInfo.req_own_house\"> <span>Doesn\'t Matter</span></label></div></div></div></div></div>");
$templateCache.put("app/pages/register/register.html","<script src=\"/app/pages/profile/CommonService.js\"></script><style>\n.mandatory {\n	color:red;\n	font-weight:bold;\n	padding-left:3px;\n}\n@media only screen and (max-width: 600px) {\n	.radio-input-div {\n		margin-bottom: 3px;\n	}\n}\n</style><div ba-panel=\"\" ba-panel-class=\"search-page\"><div class=\"panel-content\" style=\"padding-top: 1px;\"><h3 class=\"with-line\" style=\"padding-top:0px;\">General Information</h3>(All fields which are marked with <span class=\"mandatory\">*</span> are mandatory)<div class=\"row\" style=\"margin:10px 0px 0px 0px;\"><div ng-if=\"errorMsg.length > 0\" class=\"col-md-6\" style=\"color:red;border:1px solid gray;margin-bottom:20px;border-radius: 3px; padding-top: 5px;\"><p style=\"margin-bottom:3px;\" ng-repeat=\"eachErrorMsg in errorMsg\" track=\"\" by=\"\" $index=\"\">{{eachErrorMsg}}</p></div><div ng-if=\"registrationSuccess\" class=\"col-md-6\" style=\"color:green;border:1px solid gray;margin-bottom:20px;border-radius: 3px; padding-top: 5px;\">{{registrationSuccessMsg}}</div><br></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking Sagai For <span class=\"mandatory\">*</span></label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.profile_for\" ng-options=\"obj.code as obj.name for obj in profileForList\" class=\"form-control\" ng-required=\"true\" id=\"profile_for\" ng-change=\"profileForChanged();\"><option value=\"\">-- Select --</option></select></div></div></div></div><div class=\"row\" ng-if=\"registerInfo.profile_for\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gender <span class=\"mandatory\">*</span></label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"profilegender\" id=\"gendermale\" value=\"M\" ng-checked=\"registerInfo.looking_for == \'F\'\" ng-model=\"registerInfo.gender\"> <span>Male</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"profilegender\" id=\"gendermale\" value=\"F\" ng-checked=\"registerInfo.looking_for == \'M\'\" ng-model=\"registerInfo.gender\"> <span>Female</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"guardian_name\" class=\"col-sm-3 control-label\">Name<span class=\"mandatory\">*</span></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"guardian_name\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_name\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"guardian_contact_no\" class=\"col-sm-3 control-label\">Contact Number<span class=\"mandatory\">*</span></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_contact_no\"></div></div></div></div><div class=\"row\" ng-if=\"registerInfo.guardian_otp_generated == \'yes\'\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Enter OTP<span class=\"mandatory\">*</span></label><div class=\"col-sm-9\"><input style=\"background:#a2f3f0;\" type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" id=\"guardian_otp\" ng-model=\"registerInfo.guardian_otp\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"is_associate\" class=\"col-sm-3 control-label\">Are you an associate ?</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_associate\" id=\"is_associate_yes\" value=\"yes\" ng-model=\"registerInfo.is_associate\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" checked=\"true\" name=\"is_associate\" id=\"is_associate_no\" value=\"no\" ng-model=\"registerInfo.is_associate\"> <span>No</span></label></div></div></div></div><div ng-show=\"registerInfo.is_associate == \'yes\'\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"associate_name\" class=\"col-sm-3 control-label\">Associate Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"associate_name\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.associate_name\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"associate_no\" class=\"col-sm-3 control-label\">Associate\'s Mobile Number</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.associate_no\"></div></div></div></div></div><h3 id=\"moreDetailsId\" ng-click=\"viewMoreDetails(this);\"><a href=\"javascript:void(0);\" style=\"text-decoration:underline !important;cursor:pointer;\">+ More Details (Optional)</a></h3><div id=\"moreDetails\" style=\"display:none;\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian Occupation</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" name=\"guardian_occupation\" id=\"guardian_occupation\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_occupation\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Guardian Land</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.guardian_land\"></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" placeholder=\"\" value=\"contact@akveo.com\" ng-model=\"registerInfo.email\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line1<span class=\"mandatory\">*</span></label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.address_1\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Phone</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"+1 (23) 456 7890\" ng-model=\"registerInfo.phone\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Address Line2<span class=\"mandatory\">*</span></label><div class=\"col-sm-9\"><input type=\"textarea\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.address_2\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">State<span class=\"mandatory\">*</span></label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.state\" ng-options=\"obj.code as obj.name for obj in countries\" ng-change=\"getCountryStates(\'state\')\" class=\"form-control\" ng-required=\"true\" id=\"state\"><option value=\"\">-- Select --</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk<span class=\"mandatory\">*</span></label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.tehsil\" ng-options=\"x.code as x.name for x in cities\" class=\"form-control\" ng-required=\"true\" id=\"city\"><option value=\"\">-- Select --</option></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District<span class=\"mandatory\">*</span></label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.district\" ng-options=\"x.code as x.name for x in sates\" ng-change=\"getStateCities(\'district\')\" class=\"form-control\" ng-required=\"true\" id=\"district\"><option value=\"\">-- Select --</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Village<span class=\"mandatory\">*</span></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"town\" placeholder=\"\" ng-model=\"registerInfo.town\" style=\"text-transform:uppercase\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Pin Code<span class=\"mandatory\">*</span></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.pin_code\"></div></div></div></div><h3 class=\"with-line\">Profile Details</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"age\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.age\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"education\" class=\"col-sm-3 control-label\">Highest Education</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"education\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.education\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Height</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"height\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.height\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"emp\" value=\"Y\" ng-model=\"registerInfo.employed\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"employed\" id=\"unemp\" value=\"N\" ng-model=\"registerInfo.employed\"> <span>No</span></label></div><div class=\"col-md-5\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Business</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"business\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.business\"></div></div></div></div></div></div><div class=\"row\" ng-show=\"registerInfo.employed==\'Y\'\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Job Category</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"job_type\" id=\"cat1\" value=\"GOVT\" ng-model=\"registerInfo.job_type\"> <span>Govt</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"job_type\" id=\"cat2\" value=\"PVT\" ng-model=\"registerInfo.job_type\"> <span>Private</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"registerInfo.job_type==\'GOVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.job_title\" class=\"form-control\" style=\"text-transform:uppercase\"></div><div class=\"col-sm-6\" ng-show=\"registerInfo.job_type==\'PVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.job_title\" class=\"form-control\" style=\"text-transform:uppercase\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Have Own House</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"Y\" ng-model=\"registerInfo.own_house\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"N\" ng-model=\"registerInfo.own_house\"> <span>No</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Are you a Person with Disability</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"disability\" id=\"disability_y\" ng-change=\"radioChanged(\'disability\', registerInfo.disability)\" value=\"Y\" ng-model=\"registerInfo.disability\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"disability\" id=\"disability_n\" ng-change=\"radioChanged(\'disability\', registerInfo.disability)\" value=\"N\" ng-model=\"registerInfo.disability\"> <span>No</span></label></div></div></div><div class=\"col-md-6\" ng-if=\"registerInfo.disability == \'Y\'\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Type of Disability</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.disability_type\"><option value=\"HI\">HI</option><option value=\"VI\">VI</option><option value=\"OC\">OC</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Are you a widow/widower</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_widow\" id=\"is_widow_y\" ng-change=\"radioChanged(\'is_widow\', registerInfo.is_widow)\" value=\"Y\" ng-model=\"registerInfo.is_widow\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_widow\" id=\"is_widow_n\" ng-change=\"radioChanged(\'is_widow\', registerInfo.is_widow)\" value=\"N\" ng-model=\"registerInfo.is_widow\"> <span>No</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Are you a divorcee</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_divorcee\" id=\"is_divorcee_y\" ng-change=\"radioChanged(\'is_divorcee\', registerInfo.is_divorcee)\" value=\"Y\" ng-model=\"registerInfo.is_divorcee\"> <span>Yes</span></label></div><div class=\"col-md-7\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"is_divorcee\" id=\"is_divorcee_n\" ng-change=\"radioChanged(\'is_divorcee\', registerInfo.is_divorcee)\" value=\"N\" ng-model=\"registerInfo.is_divorcee\"> <span>No</span></label></div></div></div></div><h3 class=\"with-line\">Caste Information:</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Religion</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" ng-change=\"radioChanged(\'religion\', registerInfo.religion)\" selectpicker=\"\" ng-model=\"registerInfo.religion\"><option>Buddhist</option><option>Christian</option><option>Hindu</option><option>Jain</option><option>Muslim</option><option>Sikh</option><option>Zoroastrian</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Caste</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" ng-change=\"getSubCaste(\'caste\')\" selectpicker=\"\" ng-model=\"registerInfo.caste\"><option>General</option><option>OBC</option><option>SC</option><option>ST</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra</label></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Self</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_self\" style=\"text-transform:uppercase\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Naani</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_naani\" style=\"text-transform:uppercase\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Daadi</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_daadi\" style=\"text-transform:uppercase\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Mother</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\"></label> <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.gotra_mother\" style=\"text-transform:uppercase\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sub Caste</label><div class=\"col-sm-9\"><div class=\"col-sm-6\"><select ng-model=\"registerInfo.sub_caste\" ng-options=\"obj.sub_caste as obj.sub_caste for obj in sub_caste_list\" class=\"form-control\" ng-required=\"true\" id=\"sub_caste\"><option value=\"\">-- Select --</option></select></div><div class=\"col-sm-1\">OR</div><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" placeholder=\"Enter Sub Caste\" value=\"\" ng-model=\"registerInfo.sub_caste_enter\" style=\"text-transform:uppercase\"></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sibling Details</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.sibling_details\"></textarea></div></div></div></div><h3 class=\"with-line\">Your Requirement</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Age</label><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">From</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_age_from\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-9\"><label class=\"col-sm-3 control-label\">To</label> <input type=\"number\" class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_age_to\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Employed</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqemp\" value=\"Y\" ng-model=\"registerInfo.req_employed\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"requnemp\" value=\"N\" ng-model=\"registerInfo.req_employed\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqemployed\" id=\"reqnot\" value=\"E\" ng-model=\"registerInfo.req_employed\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\" ng-show=\"registerInfo.req_employed==\'Y\'\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Job Category</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_job_type\" id=\"cat1\" value=\"GOVT\" ng-model=\"registerInfo.req_job_type\"> <span>Govt</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_job_type\" id=\"cat2\" value=\"PVT\" ng-model=\"registerInfo.req_job_type\"> <span>Private</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_job_type\" id=\"cat2\" value=\"OTHER\" ng-model=\"registerInfo.req_job_type\"> <span>Doesn\'t Matter</span></label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><div class=\"col-sm-6\" ng-show=\"registerInfo.req_job_type==\'GOVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.req_job_title\" class=\"form-control\"></div><div class=\"col-sm-6\" ng-show=\"registerInfo.req_job_type==\'PVT\'\"><input type=\"text\" name=\"job\" ng-model=\"registerInfo.req_job_title\" class=\"form-control\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"age\" class=\"col-sm-3 control-label\">Height</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"req_height\" placeholder=\"\" ng-model=\"registerInfo.req_height\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Religion</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_religion\"><option>Buddhist</option><option>Christian</option><option>Hindu</option><option>Jain</option><option>Muslim</option><option>Sikh</option><option>Zoroastrian</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Should Be Same Caste</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"Y\" ng-model=\"registerInfo.req_same_caste\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"N\" ng-model=\"registerInfo.req_same_caste\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqcaste\" value=\"E\" ng-model=\"registerInfo.req_same_caste\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Gotra :</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"N\" ng-model=\"registerInfo.req_gotra_match\"> <span>Should Not<br>Be Same</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"Y\" ng-model=\"registerInfo.req_gotra_match\"> <span>Should Be<br>Same</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqgot\" value=\"E\" ng-model=\"registerInfo.req_gotra_match\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">State</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.req_state\" ng-options=\"obj.code as obj.name for obj in countries\" ng-change=\"getCountryStates(\'req_state\')\" class=\"form-control\" ng-required=\"true\" id=\"req_state\"><option value=\"\">-- Select --</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">District</label><div class=\"col-sm-9\"><select multiple=\"true\" ng-model=\"registerInfo.req_district\" ng-options=\"x.code as x.name for x in req_sates\" ng-change=\"getStateCities(\'req_district\')\" class=\"form-control\" ng-required=\"true\" id=\"req_district\"><option value=\"\">-- Select --</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tehshil/Taluk</label><div class=\"col-sm-9\"><select ng-model=\"registerInfo.req_tehsil\" ng-options=\"x.code as x.name for x in req_cities\" class=\"form-control\" ng-required=\"true\" id=\"city\"><option value=\"\">-- Select --</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Town/Village</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"req_town\" placeholder=\"\" ng-model=\"registerInfo.req_town\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Villages should not be among</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"\" value=\"\" ng-model=\"registerInfo.req_town_not_list\"></textarea></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Should Have Own House</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"Y\" ng-model=\"registerInfo.req_own_house\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"N\" ng-model=\"registerInfo.req_own_house\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"reqprop\" value=\"E\" ng-model=\"registerInfo.req_own_house\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking for a person with disability</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_disability\" id=\"req_disability_y\" value=\"Y\" ng-model=\"registerInfo.req_disability\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_disability\" id=\"req_disability_n\" value=\"N\" ng-model=\"registerInfo.req_disability\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_disability\" id=\"req_disability_e\" value=\"E\" ng-model=\"registerInfo.req_disability\"> <span>Doesn\'t Matter</span></label></div></div></div><div class=\"col-md-6\" ng-if=\"registerInfo.req_disability == \'Y\'\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Type of Disability</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\" ng-model=\"registerInfo.req_disability_type\"><option value=\"HI\">HI</option><option value=\"VI\">VI</option><option value=\"OC\">OC</option></select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking for widow/widower</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_widow\" id=\"req_is_widow_y\" value=\"Y\" ng-model=\"registerInfo.req_is_widow\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_widow\" id=\"req_is_widow_n\" value=\"N\" ng-model=\"registerInfo.req_is_widow\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_widow\" id=\"req_is_widow_e\" value=\"E\" ng-model=\"registerInfo.req_is_widow\"> <span>Doesn\'t Matter</span></label></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Looking for divorcee</label><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_divorcee\" id=\"req_is_divorcee_y\" value=\"Y\" ng-model=\"registerInfo.req_is_divorcee\"> <span>Yes</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_divorcee\" id=\"req_is_divorcee_n\" value=\"N\" ng-model=\"registerInfo.req_is_divorcee\"> <span>No</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"req_is_divorcee\" id=\"req_is_divorcee_e\" value=\"E\" ng-model=\"registerInfo.req_is_divorcee\"> <span>Doesn\'t Matter</span></label></div></div></div></div></div><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\" ng-click=\"registerUser()\" style=\"margin-top:3px;\"><i class=\"ion-android-checkmark-circle\"></i>Register</button></div></div>");
$templateCache.put("app/pages/register/registerModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Add Account</h4></div><form name=\"linkForm\"><div class=\"modal-body\"><p>Paste a link to your profile into the box below</p><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Link to Search\" ng-model=\"link\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok(link)\">Save changes</button></div></form></div>");
$templateCache.put("app/theme/components/baSidebar/ba-sidebar.html","<aside class=\"al-sidebar\" ng-swipe-right=\"$baSidebarService.setMenuCollapsed(false)\" ng-swipe-left=\"$baSidebarService.setMenuCollapsed(true)\" ng-mouseleave=\"hoverElemTop=selectElemTop\"><ul class=\"al-sidebar-list\" slimscroll=\"{height: \'{{menuHeight}}px\'}\" slimscroll-watch=\"menuHeight\"><li ng-repeat=\"item in ::menuItems\" class=\"al-sidebar-list-item\" ng-class=\"::{\'with-sub-menu\': item.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"item\"><a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"item.stateRef || \'\'\" ng-href=\"{{::(item.fixedHref ? item.fixedHref: \'\')}}\" ng-if=\"::!item.subMenu\" class=\"al-sidebar-list-link\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::item.subMenu\" class=\"al-sidebar-list-link\" ba-ui-sref-toggler=\"\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span> <b class=\"fa fa-angle-down\" ui-sref-active=\"fa-angle-up\" ng-if=\"::item.subMenu\"></b></a><ul ng-if=\"::item.subMenu\" class=\"al-sidebar-sublist\" ng-class=\"{\'slide-right\': item.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-repeat=\"subitem in ::item.subMenu\" ng-class=\"::{\'with-sub-menu\': subitem.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"subitem\" class=\"ba-sidebar-sublist-item\"><a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::subitem.subMenu\" ba-ui-sref-toggler=\"\" class=\"al-sidebar-list-link subitem-submenu-link\"><span>{{ ::subitem.title }}</span> <b class=\"fa\" ng-class=\"{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}\" ng-if=\"::subitem.subMenu\"></b></a><ul ng-if=\"::subitem.subMenu\" class=\"al-sidebar-sublist subitem-submenu-list\" ng-class=\"{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-mouseenter=\"hoverItem($event, item)\" ng-repeat=\"subSubitem in ::subitem.subMenu\" ui-sref-active=\"selected\"><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::subSubitem.disabled\" class=\"al-sidebar-list-link\">{{ ::item.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"subSubitem.stateRef || \'\'\" ng-if=\"::!subSubitem.disabled\" ng-href=\"{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}\">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::(!subitem.subMenu && subitem.disabled)\" class=\"al-sidebar-list-link\">{{ ::subitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" target=\"{{::(subitem.blank ? \'_blank\' : \'_self\')}}\" ng-if=\"::(!subitem.subMenu && !subitem.disabled)\" ui-state=\"subitem.stateRef || \'\'\" ng-href=\"{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}\">{{ ::subitem.title}}</a></li></ul></li></ul><div class=\"sidebar-hover-elem\" ng-style=\"{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}\" ng-class=\"{\'show-hover-elem\': showHoverElem }\"></div></aside>");
$templateCache.put("app/theme/components/baWizard/baWizard.html","<div class=\"ba-wizard\"><div class=\"ba-wizard-navigation-container\"><div ng-repeat=\"t in $baWizardController.tabs\" class=\"ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}\" ng-click=\"$baWizardController.selectTab($index)\">{{t.title}}</div></div><div class=\"progress ba-wizard-progress\"><div class=\"progress-bar progress-bar-danger active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: $baWizardController.progress + \'%\'}\"></div></div><div class=\"steps\" ng-transclude=\"\"></div><nav><ul class=\"pager ba-wizard-pager\"><li class=\"previous\"><button ng-disabled=\"$baWizardController.isFirstTab()\" ng-click=\"$baWizardController.previousTab()\" type=\"button\" class=\"btn btn-primary\"><span aria-hidden=\"true\">&larr;</span> previous</button></li><li class=\"next\"><button ng-disabled=\"$baWizardController.isLastTab()\" ng-click=\"$baWizardController.nextTab()\" type=\"button\" class=\"btn btn-primary\">next <span aria-hidden=\"true\">&rarr;</span></button></li></ul></nav></div>");
$templateCache.put("app/theme/components/baWizard/baWizardStep.html","<section ng-show=\"selected\" class=\"step\" ng-transclude=\"\"></section>");
$templateCache.put("app/theme/components/msgCenter/msgCenter.html","<ul class=\"al-msg-center clearfix\"><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-bell-o\"></i><span>5</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Notifications</strong> <a href=\"\">Mark All as Read</a> <a href=\"\">Settings</a></div><div class=\"msg-list\"><a href=\"\" class=\"clearfix\" ng-repeat=\"msg in notifications\"><div class=\"img-area\"><img ng-class=\"{\'photo-msg-item\' : !msg.image}\" ng-src=\"{{::( msg.image || (users[msg.userId].name | profilePicture) )}}\"></div><div class=\"msg-area\"><div ng-bind-html=\"getMessage(msg)\"></div><span>{{ msg.time }}</span></div></a></div><a href=\"\">See all notifications</a></div></li><li uib-dropdown=\"\"><a href=\"\" class=\"msg\" uib-dropdown-toggle=\"\"><i class=\"fa fa-envelope-o\"></i><span>5</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Messages</strong> <a href=\"\">Mark All as Read</a> <a href=\"\">Settings</a></div><div class=\"msg-list\"><a href=\"\" class=\"clearfix\" ng-repeat=\"msg in messages\"><div class=\"img-area\"><img class=\"photo-msg-item\" ng-src=\"{{::( users[msg.userId].name | profilePicture )}}\"></div><div class=\"msg-area\"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href=\"\">See all messages</a></div></li></ul>");
$templateCache.put("app/theme/components/backTop/backTop.html","<i class=\"fa fa-angle-up back-top\" id=\"backTop\" title=\"Back to Top\"></i>");
$templateCache.put("app/theme/components/contentTop/contentTop.html","<div class=\"content-top clearfix\"><h1 class=\"al-title\">{{ activePageTitle }}</h1><span class=\"register-page-quote\">\" &#2309;&#2348; &#2360;&#2327;&#2366;&#2312; &#2325;&#2352;&#2344;&#2366; &#2361;&#2369;&#2310; &#2310;&#2360;&#2366;&#2344; \"</span><ul class=\"breadcrumb al-breadcrumb\"><li><a href=\"#/dashboard\">Home</a></li><li>{{ activePageTitle }}</li></ul></div>");
$templateCache.put("app/theme/components/pageTop/pageTop.html","<div class=\"page-top clearfix\" scroll-position=\"scrolled\" max-height=\"50\" ng-class=\"{\'scrolled\': scrolled}\"><a href=\"#/dashboard\" class=\"al-logo clearfix\"><span>Sagai</span> Wale</a> <a href=\"\" class=\"collapse-menu-link ion-navicon\" ba-sidebar-toggle-menu=\"\"></a><div class=\"search\"><i class=\"ion-ios-search-strong\" ng-click=\"startSearch()\"></i> <input id=\"searchInput\" type=\"text\" placeholder=\"Search for...\"></div><div class=\"user-profile clearfix\" style=\"display:none;\"><div class=\"al-user-profile\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" class=\"profile-toggle-link\"><img style=\"display:none;\" ng-src=\"{{::( \'Nasta\' | profilePicture )}}\"></a><ul class=\"top-dropdown-menu profile-dropdown\" uib-dropdown-menu=\"\"><li><i class=\"dropdown-arr\"></i></li><li><a href=\"#/profile\"><i class=\"fa fa-user\"></i>Profile</a></li><li><a href=\"\"><i class=\"fa fa-cog\"></i>Settings</a></li><li><a href=\"\" class=\"signout\"><i class=\"fa fa-power-off\"></i>Sign out</a></li></ul></div><msg-center></msg-center></div></div>");
$templateCache.put("app/theme/components/widgets/widgets.html","<div class=\"widgets\"><div ng-repeat=\"widgetBlock in ngModel\" ng-class=\"{\'row\': widgetBlock.widgets.length > 1}\"><div ng-repeat=\"widgetCol in widgetBlock.widgets\" ng-class=\"{\'col-md-6\': widgetBlock.widgets.length === 2}\" ng-model=\"widgetCol\" class=\"widgets-block\"><div ba-panel=\"\" ba-panel-title=\"{{::widget.title}}\" ng-repeat=\"widget in widgetCol\" ba-panel-class=\"with-scroll {{widget.panelClass}}\"><div ng-include=\"widget.url\"></div></div></div></div></div>");
$templateCache.put("app/pages/dashboard/blurFeed/blurFeed.html","<div class=\"feed-messages-container\" track-width=\"smallContainerWidth\" min-width=\"360\"><div class=\"feed-message\" ng-repeat=\"message in requests\" ui-sref=\"profile({{ ::message.id_val }})\"><div class=\"message-icon\" ng-if=\"message.type == \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{::( message.author | profilePicture )}}\"></div><div class=\"message-icon\" ng-if=\"message.type != \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{::( message.author | profilePicture )}}\"> <span class=\"sub-photo-icon\" ng-class=\"::message.type\"></span></div><div class=\"text-block text-message\"><div class=\"message-header\"><span class=\"author\">{{ ::message.guardian_name }} ({{ ::message.header}})</span></div><div class=\"message-content line-clamp\" ng-class=\"{\'line-clamp-2\' : !message.expanded}\"><span ng-if=\"message.preview\">{{message.header}}</span>{{::message.text}}</div><div class=\"preview\" ng-show=\"message.expanded\" ng-if=\"message.preview\"><a href=\"{{::message.link}}\" target=\"_blank\"><img ng-src=\"{{ ::( message.preview | appImage )}}\"></a></div><div ng-show=\"message.expanded\" class=\"message-time\"><div class=\"post-time\">{{::message.time}}</div><div class=\"ago-time\">{{::message.ago}}</div></div></div></div></div>");
$templateCache.put("app/pages/dashboard/dashboardCalendar/dashboardCalendar.html","<div id=\"calendar\" class=\"blurCalendar\"></div>");
$templateCache.put("app/pages/dashboard/dashboardLineChart/dashboardLineChart.html","<div id=\"amchart\"></div>");
$templateCache.put("app/pages/dashboard/dashboardMap/dashboardMap.html","<div id=\"amChartMap\"></div>");
$templateCache.put("app/pages/dashboard/dashboardPieChart/dashboardPieChart.html","<div class=\"row pie-charts\"><div class=\"pie-chart-item-container\" ng-repeat=\"chart in charts\"><div ba-panel=\"\"><div class=\"pie-chart-item\"><div class=\"chart\" rel=\"{{ ::chart.color }}\" data-percent=\"60\"><span class=\"percent\"></span></div><div class=\"description\"><div>{{ ::chart.description }}</div><div class=\"description-stats\">{{ ::chart.stats }}</div></div><i class=\"chart-icon i-{{ ::chart.icon }}\"></i></div></div></div></div>");
$templateCache.put("app/pages/dashboard/trafficChart/trafficChart.html","<div class=\"channels-block\" ng-class=\"{\'transparent\': transparent}\"><div class=\"chart-bg\"></div><div class=\"traffic-chart\" id=\"trafficChart\"><div class=\"canvas-holder\"><canvas id=\"chart-area\" width=\"300\" height=\"300\"></canvas><div class=\"traffic-text\">1,900,128 <span>Views Total</span></div></div><div class=\"traffic-legend\"></div></div><div class=\"channels-info\"><div><div class=\"channels-info-item\" ng-repeat=\"item in doughnutData | orderBy:\'order\'\"><div class=\"legend-color\" style=\"background-color: {{::item.color}}\"></div><p>{{::item.label}}<span class=\"channel-number\">+{{item.percentage}}%</span></p><div class=\"progress progress-sm channel-progress\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{item.percentage}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: {{item.percentage}}%\"></div></div></div></div></div></div>");
$templateCache.put("app/pages/dashboard/dashboardTodo/dashboardTodo.html","<div class=\"task-todo-container\" ng-class=\"{\'transparent\': transparent}\"><input type=\"text\" value=\"\" class=\"form-control task-todo\" placeholder=\"Task to do..\" ng-keyup=\"addToDoItem($event)\" ng-model=\"newTodoText\"> <i ng-click=\"addToDoItem(\'\',true)\" class=\"add-item-icon ion-plus-round\"></i><div class=\"box-shadow-border\"></div><ul class=\"todo-list\" ui-sortable=\"\" ng-model=\"todoList\"><li ng-repeat=\"item in todoList\" ng-if=\"!item.deleted\" ng-init=\"activeItem=false\" ng-class=\"{checked: isChecked, active: activeItem}\" ng-mouseenter=\"activeItem=true\" ng-mouseleave=\"activeItem=false\"><div class=\"blur-container\"><div class=\"blur-box\"></div></div><i class=\"mark\" style=\"background-color: {{::item.color}}\"></i> <label class=\"todo-checkbox custom-checkbox custom-input-success\"><input type=\"checkbox\" ng-model=\"isChecked\"> <span class=\"cut-with-dots\">{{ item.text }}</span></label> <i class=\"remove-todo ion-ios-close-empty\" ng-click=\"item.deleted = true\"></i></li></ul></div>");
$templateCache.put("app/pages/dashboard/weather/weather.html","<div class=\"weather-wrapper\"><div class=\"weather-main-info\"><h5 class=\"city-date font-x1dot5\"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class=\"weather-description font-x1dot5\"><i class=\"font-x3 {{weatherIcons[weather.days[weather.current].icon]}}\"></i><div class=\"weather-info\">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class=\"weather-temp font-x1dot5\"><i class=\"font-x2 ion-thermometer\"></i><div class=\"weather-info\" ng-switch=\"\" on=\"units\"><span ng-switch-when=\"metric\">{{weather.days[weather.current].temp}} °C | <a ng-click=\"switchUnits(\'imperial\')\" href=\"\">°F</a></span> <span ng-switch-when=\"imperial\">{{weather.days[weather.current].temp}} °F | <a ng-click=\"switchUnits(\'metric\')\" href=\"\">°C</a></span></div></div></div><div id=\"tempChart\" class=\"temp-by-time\"></div><div class=\"select-day\"><div class=\"day\" ng-repeat=\"day in weather.days\" ng-click=\"switchDay($index)\"><div><span class=\"font-x1dot25\">{{day.temp}}</span></div><div><i class=\"weatherIcon font-x2 {{weatherIcons[day.icon]}}\"></i> <span class=\"select-day-info\">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>");
$templateCache.put("app/pages/dashboard/popularApp/popularApp.html","<div class=\"popular-app-img-container\"><div class=\"popular-app-img\"><img ng-src=\"{{::( \'app/my-app-logo.png\' | appImage )}}\"> <span class=\"logo-text\">Super&nbspApp</span></div></div><div class=\"popular-app-cost row\"><div class=\"col-xs-9\">Most Popular App</div><div class=\"col-xs-3 text-right\">175$</div></div><div class=\"popular-app-info row\"><div class=\"col-xs-4 text-left\"><div class=\"info-label\">Total Visits</div><div>47,512</div></div><div class=\"col-xs-4 text-center\"><div class=\"info-label\">New Visits</div><div>9,217</div></div><div class=\"col-xs-4 text-right\"><div class=\"info-label\">Sales</div><div>2,928</div></div></div>");
$templateCache.put("app/pages/form/inputs/inputs.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Standard Fields\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/standardFields.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Tags Input\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/tagsInput/tagsInput.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Input Groups\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/inputGroups.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Checkboxes & Radios\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/checkboxesRadios.html\'\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Validation States\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/validationStates.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Selects\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/select/select.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"On/Off Switches\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/switch/switch.html\'\"></div></div></div></div></div>");
$templateCache.put("app/pages/form/layouts/layouts.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Inline Form\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/layouts/widgets/inlineForm.html\'\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Basic Form\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/layouts/widgets/basicForm.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Horizontal Form\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/layouts/widgets/horizontalForm.html\'\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Form Without Labels\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/layouts/widgets/formWithoutLabels.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Block Form\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/layouts/widgets/blockForm.html\'\"></div></div></div></div></div>");
$templateCache.put("app/pages/form/wizard/wizard.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Form Wizard\" ba-panel-class=\"with-scroll\"><ba-wizard><ba-wizard-step title=\"Personal info\" form=\"vm.personalInfoForm\"><form name=\"vm.personalInfoForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': vm.personalInfoForm.username.$invalid && (vm.personalInfoForm.username.$dirty || vm.personalInfoForm.$submitted)}\"><label for=\"exampleUsername1\">Username</label> <input type=\"text\" class=\"form-control\" id=\"exampleUsername1\" name=\"username\" placeholder=\"Username\" ng-model=\"vm.personalInfo.username\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div><div class=\"form-group\" ng-class=\"{\'has-error\': vm.personalInfoForm.email.$invalid && (vm.personalInfoForm.email.$dirty || vm.personalInfoForm.$submitted)}\"><label for=\"exampleInputEmail1\">Email address</label> <input type=\"email\" class=\"form-control\" id=\"exampleInputEmail1\" name=\"email\" placeholder=\"Email\" ng-model=\"vm.personalInfo.email\" required=\"\"> <span class=\"help-block error-block basic-block\">Proper email required</span></div></div><div class=\"col-md-6\"><div class=\"form-group\" ng-class=\"{\'has-error\': vm.personalInfoForm.password.$invalid && (vm.personalInfoForm.password.$dirty || vm.personalInfoForm.$submitted)}\"><label for=\"exampleInputPassword1\">Password</label> <input type=\"password\" class=\"form-control\" id=\"exampleInputPassword1\" name=\"password\" placeholder=\"Password\" ng-model=\"vm.personalInfo.password\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div><div class=\"form-group\" ng-class=\"{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm.confirmPassword.$dirty || vm.personalInfoForm.$submitted)}\"><label for=\"exampleInputConfirmPassword1\">Confirm Password</label> <input type=\"password\" class=\"form-control\" id=\"exampleInputConfirmPassword1\" name=\"confirmPassword\" placeholder=\"Confirm Password\" ng-model=\"vm.personalInfo.confirmPassword\" required=\"\"> <span class=\"help-block error-block basic-block\">Passwords should match</span></div></div></div></form></ba-wizard-step><ba-wizard-step title=\"Product Info\" form=\"vm.productInfoForm\"><form name=\"vm.productInfoForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': vm.productInfoForm.productName.$invalid && (vm.productInfoForm.productName.$dirty || vm.productInfoForm.$submitted)}\"><label for=\"productName\">Product name</label> <input type=\"text\" class=\"form-control\" id=\"productName\" name=\"productName\" placeholder=\"Product name\" ng-model=\"vm.productInfo.productName\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div><div class=\"form-group\" ng-class=\"{\'has-error\': vm.productInfoForm.productId.$invalid && (vm.productInfoForm.productId.$dirty || vm.productInfoForm.$submitted)}\"><label for=\"productId\">Product id</label> <input type=\"text\" class=\"form-control\" id=\"productId\" name=\"productId\" placeholder=\"productId\" ng-model=\"vm.productInfo.productId\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"productName\">Category</label><select class=\"form-control\" title=\"Category\" selectpicker=\"\"><option selected=\"\">Electronics</option><option>Toys</option><option>Accessories</option></select></div></div></div></form></ba-wizard-step><ba-wizard-step title=\"Shipment\" form=\"vm.addressForm\"><form name=\"vm.addressForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': vm.addressForm.address.$invalid && (vm.addressForm.address.$dirty || vm.addressForm.$submitted)}\"><label for=\"productName\">Shipment address</label> <input type=\"text\" class=\"form-control\" id=\"address\" name=\"address\" placeholder=\"Shipment address\" ng-model=\"vm.shipment.address\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"productName\">Shipment method</label><select class=\"form-control\" title=\"Category\" selectpicker=\"\"><option selected=\"\">Fast & expensive</option><option>Cheap & free</option></select></div></div></div><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\"> <span>Save shipment info</span></label></div></form></ba-wizard-step><ba-wizard-step title=\"Finish\"><form class=\"form-horizontal\" name=\"vm.finishForm\" novalidate=\"\">Congratulations! You have successfully filled the form!</form></ba-wizard-step></ba-wizard></div></div></div></div>");
$templateCache.put("app/pages/tables/widgets/basicTable.html","<div class=\"horizontal-scroll\"><table class=\"table\"><thead><tr><th class=\"browser-icons\"></th><th>Browser</th><th class=\"align-right\">Visits</th><th class=\"table-arr\"></th><th class=\"align-right\">Downloads</th><th class=\"table-arr\"></th><th class=\"align-right\">Purchases</th><th class=\"table-arr\"></th><th class=\"align-right\">DAU</th><th class=\"table-arr\"></th><th class=\"align-right\">MAU</th><th class=\"table-arr\"></th><th class=\"align-right\">LTV</th><th class=\"table-arr\"></th><th class=\"align-right\">Users %</th><th class=\"table-arr\"></th></tr></thead><tbody><tr><td><img src=\"img/chrome.svg\" width=\"20\" height=\"20\"></td><td class=\"nowrap\">Google Chrome</td><td class=\"align-right\">10,392</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">3,822</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">4,214</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">899</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">7,098</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">178</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">45%</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td></tr><tr><td><img src=\"img/firefox.svg\" width=\"20\" height=\"20\"></td><td class=\"nowrap\">Mozilla Firefox</td><td class=\"align-right\">7,873</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">6,003</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">3,031</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">897</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">8,997</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">102</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">28%</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td></tr><tr><td><img src=\"img/ie.svg\" width=\"20\" height=\"20\"></td><td class=\"nowrap\">Internet Explorer</td><td class=\"align-right\">5,890</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">3,492</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">2,102</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">27</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">4,039</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">99</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">17%</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td></tr><tr><td><img src=\"img/safari.svg\" width=\"20\" height=\"20\"></td><td class=\"nowrap\">Safari</td><td class=\"align-right\">4,001</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">2,039</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">1,001</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">104</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">3,983</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">209</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">14%</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td></tr><tr><td><img src=\"img/opera.svg\" width=\"20\" height=\"20\"></td><td class=\"nowrap\">Opera</td><td class=\"align-right\">1,833</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">983</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">83</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">19</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">1,099</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">103</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">5%</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td></tr></tbody></table></div>");
$templateCache.put("app/pages/tables/widgets/borderedTable.html","<div class=\"horizontal-scroll\"><table class=\"table table-bordered\"><thead><tr><th class=\"browser-icons\"></th><th>Browser</th><th class=\"align-right\">Visits</th><th class=\"align-right\">Purchases</th><th class=\"align-right\">%</th></tr></thead><tbody><tr ng-repeat=\"item in metricsTableData\"><td><img ng-src=\"{{::( item.image | appImage )}}\" width=\"20\" height=\"20\"></td><td ng-class=\"nowrap\">{{item.browser}}</td><td class=\"align-right\">{{item.visits}}</td><td class=\"align-right\">{{item.purchases}}</td><td class=\"align-right\">{{item.percent}}</td></tr></tbody></table></div>");
$templateCache.put("app/pages/tables/widgets/condensedTable.html","<div class=\"horizontal-scroll\"><table class=\"table table-condensed\"><thead><tr><th class=\"table-id\">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat=\"item in peopleTableData\"><td class=\"table-id\">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class=\"email-link\" ng-href=\"mailto:{{item.email}}\">{{item.email}}</a></td><td><button class=\"status-button btn btn-xs btn-{{item.status}}\">{{item.status}}</button></td></tr></tbody></table></div>");
$templateCache.put("app/pages/tables/widgets/contextualTable.html","<table class=\"table\"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class=\"primary\"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class=\"email-link\" ng-href=\"mailto:mdo@gmail.com\" href=\"mailto:mdo@gmail.com\">mdo@gmail.com</a></td><td>28</td></tr><tr class=\"success\"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class=\"email-link\" ng-href=\"mailto:fat@yandex.ru\" href=\"mailto:fat@yandex.ru\">fat@yandex.ru</a></td><td>45</td></tr><tr class=\"warning\"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class=\"email-link\" ng-href=\"mailto:twitter@outlook.com\" href=\"mailto:twitter@outlook.com\">twitter@outlook.com</a></td><td>18</td></tr><tr class=\"danger\"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class=\"email-link\" ng-href=\"mailto:snow@gmail.com\" href=\"mailto:snow@gmail.com\">snow@gmail.com</a></td><td>20</td></tr><tr class=\"info\"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class=\"email-link\" ng-href=\"mailto:jack@yandex.ru\" href=\"mailto:jack@yandex.ru\">jack@yandex.ru</a></td><td>30</td></tr></table>");
$templateCache.put("app/pages/tables/widgets/editableRowTable.html","<div class=\"add-row-editable-table\"><button class=\"btn btn-primary\" ng-click=\"addUser()\">Add row</button></div><table class=\"table table-bordered table-hover table-condensed\"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat=\"user in users\" class=\"editable-row\"><td>{{$index}}</td><td><span editable-text=\"user.name\" e-name=\"name\" e-form=\"rowform\" e-required=\"\">{{ user.name || \'empty\' }}</span></td><td class=\"select-td\"><span editable-select=\"user.status\" e-name=\"status\" e-form=\"rowform\" e-selectpicker=\"\" e-ng-options=\"s.value as s.text for s in statuses\">{{ showStatus(user) }}</span></td><td class=\"select-td\"><span editable-select=\"user.group\" e-name=\"group\" onshow=\"loadGroups()\" e-form=\"rowform\" e-selectpicker=\"\" e-ng-options=\"g.id as g.text for g in groups\">{{ showGroup(user) }}</span></td><td><form editable-form=\"\" name=\"rowform\" ng-show=\"rowform.$visible\" class=\"form-buttons form-inline\" shown=\"inserted == user\"><button type=\"submit\" ng-disabled=\"rowform.$waiting\" class=\"btn btn-primary editable-table-button btn-xs\">Save</button> <button type=\"button\" ng-disabled=\"rowform.$waiting\" ng-click=\"rowform.$cancel()\" class=\"btn btn-default editable-table-button btn-xs\">Cancel</button></form><div class=\"buttons\" ng-show=\"!rowform.$visible\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"rowform.$show()\">Edit</button> <button class=\"btn btn-danger editable-table-button btn-xs\" ng-click=\"removeUser($index)\">Delete</button></div></td></tr></table>");
$templateCache.put("app/pages/tables/widgets/editableTable.html","<div class=\"horizontal-scroll\"><table class=\"table table-hover\" st-table=\"editableTableData\"><tr class=\"sortable header-row\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">#</th><th st-sort=\"firstName\">First Name</th><th st-sort=\"lastName\">Last Name</th><th st-sort=\"username\">Username</th><th st-sort=\"email\">Email</th><th st-sort=\"age\">Age</th></tr><tr ng-repeat=\"item in editableTableData\" class=\"editable-tr-wrap\"><td class=\"table-id\">{{item.id}}</td><td><span editable-text=\"item.firstName\" blur=\"cancel\">{{item.firstName}}</span></td><td><span editable-text=\"item.lastName\" blur=\"cancel\">{{item.lastName}}</span></td><td><span editable-text=\"item.username\" blur=\"cancel\">{{item.username}}</span></td><td><a class=\"email-link\" ng-href=\"mailto:{{item.email}}\">{{item.email}}</a></td><td><span editable-text=\"item.age\" blur=\"cancel\">{{item.age}}</span></td></tr><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"12\" st-displayed-pages=\"5\"></div></td></tr></tfoot></table></div>");
$templateCache.put("app/pages/tables/widgets/hoverRows.html","<div class=\"horizontal-scroll\"><table class=\"table table-hover\"><thead><tr class=\"black-muted-bg\"><th class=\"browser-icons\"></th><th>Browser</th><th class=\"align-right\">Visits</th><th class=\"table-arr\"></th><th class=\"align-right\">Purchases</th><th class=\"table-arr\"></th><th class=\"align-right\">%</th><th class=\"table-arr\"></th></tr></thead><tbody><tr ng-repeat=\"item in metricsTableData\" class=\"no-top-border\"><td><img ng-src=\"{{::( item.image | appImage )}}\" width=\"20\" height=\"20\"></td><td ng-class=\"nowrap\">{{item.browser}}</td><td class=\"align-right\">{{item.visits}}</td><td class=\"table-arr\"><i ng-class=\"{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }\"></i></td><td class=\"align-right\">{{item.purchases}}</td><td class=\"table-arr\"><i ng-class=\"{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }\"></i></td><td class=\"align-right\">{{item.percent}}</td><td class=\"table-arr\"><i ng-class=\"{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }\"></i></td></tr></tbody></table></div>");
$templateCache.put("app/pages/tables/widgets/responsiveTable.html","<div class=\"table-responsive\"><table class=\"table\"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class=\"email-link\" ng-href=\"mailto:mdo@gmail.com\" href=\"mailto:mdo@gmail.com\">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class=\"email-link\" ng-href=\"mailto:fat@yandex.ru\" href=\"mailto:fat@yandex.ru\">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class=\"email-link\" ng-href=\"mailto:twitter@outlook.com\" href=\"mailto:twitter@outlook.com\">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class=\"email-link\" ng-href=\"mailto:snow@gmail.com\" href=\"mailto:snow@gmail.com\">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class=\"email-link\" ng-href=\"mailto:jack@yandex.ru\" href=\"mailto:jack@yandex.ru\">jack@yandex.ru</a></td><td>30</td></tr></table></div>");
$templateCache.put("app/pages/tables/widgets/smartTable.html","<div class=\"horizontal-scroll\"><div class=\"form-group select-page-size-wrap\"><label>Rows on page<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,20,25]\"></select></label></div><table class=\"table\" st-table=\"smartTableData\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">#</th><th st-sort=\"firstName\">First Name</th><th st-sort=\"lastName\">Last Name</th><th st-sort=\"username\">Username</th><th st-sort=\"email\">Email</th><th st-sort=\"age\">Age</th></tr><tr><th></th><th><input st-search=\"firstName\" placeholder=\"Search First Name\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"lastName\" placeholder=\"Search Last Name\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"username\" placeholder=\"Search Username\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"email\" placeholder=\"Search Email\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"age\" placeholder=\"Search Age\" class=\"input-sm form-control search-input\" type=\"search\"></th></tr></thead><tbody><tr ng-repeat=\"item in smartTableData\"><td class=\"table-id\">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class=\"email-link\" ng-href=\"mailto:{{item.email}}\">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"5\"></div></td></tr></tfoot></table></div>");
$templateCache.put("app/pages/tables/widgets/stripedRows.html","<div class=\"vertical-scroll\"><table class=\"table table-striped\"><thead><tr><th class=\"table-id\">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat=\"item in smartTableData\"><td class=\"table-id\">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class=\"email-link\" ng-href=\"mailto:{{item.email}}\">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>");
$templateCache.put("app/pages/ui/buttons/buttons.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-3\" ba-panel=\"\" ba-panel-title=\"Flat Buttons\" ba-panel-class=\"with-scroll button-panel\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-default\">Default</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary\">Primary</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-success\">Success</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info\">Info</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-warning\">Warning</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-danger\">Danger</button></div></div><div class=\"col-md-3\" ba-panel=\"\" ba-panel-title=\"Raised Buttons\" ba-panel-class=\"with-scroll button-panel\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-default btn-raised\">Default</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-raised\">Primary</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-success btn-raised\">Success</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info btn-raised\">Info</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-warning btn-raised\">Warning</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-danger btn-raised\">Danger</button></div></div><div class=\"col-md-3\" ba-panel=\"\" ba-panel-title=\"Different sizes\" ba-panel-class=\"with-scroll button-panel df-size-button-panel\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-default btn-xs\">Default</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-sm\">Primary</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-success btn-mm\">Success</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info btn-md\">Info</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-warning btn-xm\">Warning</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-danger btn-lg\">Danger</button></div></div><div class=\"col-md-3\" ba-panel=\"\" ba-panel-title=\"Disabled\" ba-panel-class=\"with-scroll button-panel\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-default\" disabled=\"disabled\">Default</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary\" disabled=\"disabled\">Primary</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-success\" disabled=\"disabled\">Success</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info\" disabled=\"disabled\">Info</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-warning\" disabled=\"disabled\">Warning</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-danger\" disabled=\"disabled\">Danger</button></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Icon Buttons\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/buttons/widgets/iconButtons.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Large Buttons\" ba-panel-class=\"with-scroll large-buttons-panel\"><div ng-include=\"\'app/pages/ui/buttons/widgets/largeButtons.html\'\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Button Dropdowns\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/buttons/widgets/dropdowns.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Button Groups\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/buttons/widgets/buttonGroups.html\'\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Progress Buttons\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/buttons/widgets/progressButtons.html\'\"></div></div></div></div>");
$templateCache.put("app/pages/tables/basic/tables.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Hover Rows\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/hoverRows.html\"></div></div></div><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Bordered Table\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/borderedTable.html\"></div></div></div></div><div class=\"row\"><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Condensed Table\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/condensedTable.html\"></div></div></div><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Striped Rows\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/stripedRows.html\"></div></div></div></div><div class=\"row\"><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Contextual Table\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/contextualTable.html\"></div></div></div><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Responsive Table\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/responsiveTable.html\"></div></div></div></div></div>");
$templateCache.put("app/pages/ui/icons/icons.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Kameleon SVG Icons\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/ui/icons/widgets/kameleon.html\"></div></div><div ba-panel=\"\" ba-panel-title=\"Socicon\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/ui/icons/widgets/socicon.html\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Icons With Rounded Background\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/ui/icons/widgets/kameleonRounded.html\"></div></div><div ba-panel=\"\" ba-panel-title=\"ionicons\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/ui/icons/widgets/ionicons.html\"></div></div><div ba-panel=\"\" ba-panel-title=\"Font Awesome Icons\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/ui/icons/widgets/fontAwesomeIcons.html\"></div></div></div></div></div>");
$templateCache.put("app/pages/ui/modals/modals.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Modals\" ba-panel-class=\"with-scroll\"><div class=\"modal-buttons clearfix\"><button type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')\">Default modal</button> <button type=\"button\" class=\"btn btn-success\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')\">Large modal</button> <button type=\"button\" class=\"btn btn-warning\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')\">Small modal</button></div></div></div><div class=\"row\"><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Message Modals\" ba-panel-class=\"with-scroll\"><div class=\"modal-buttons same-width clearfix\"><button type=\"button\" class=\"btn btn-success\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/successModal.html\')\">Success Message</button> <button type=\"button\" class=\"btn btn-info\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')\">Info Message</button> <button type=\"button\" class=\"btn btn-warning\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')\">Warning Message</button> <button type=\"button\" class=\"btn btn-danger\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')\">Danger Message</button></div></div><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Notifications\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/modals/notifications/notifications.html\'\"></div></div></div></div>");
$templateCache.put("app/pages/tables/smart/tables.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Editable Rows\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/tables/widgets/editableRowTable.html\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Editable Cells\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/tables/widgets/editableTable.html\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Smart Table With Filtering, Sorting And Pagination\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/tables/widgets/smartTable.html\"></div></div></div></div></div>");
$templateCache.put("app/pages/ui/notifications/notifications.html","<div ba-panel=\"\" ba-panel-class=\"with-scroll notification-panel\"><div class=\"row\"><div class=\"col-md-3 col-sm-4\"><div class=\"control\"><label for=\"title\">Title</label> <input ng-model=\"options.title\" type=\"text\" class=\"form-control\" id=\"title\" placeholder=\"Enter a title ...\"></div><div class=\"control\"><label for=\"message\">Message</label> <textarea ng-model=\"options.msg\" class=\"form-control\" id=\"message\" rows=\"3\" placeholder=\"Enter a message ...\"></textarea></div><div class=\"control-group\"><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.closeButton\" type=\"checkbox\" id=\"closeButton\"> <span>Close Button</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.allowHtml\" type=\"checkbox\" id=\"html\"> <span>Allow html</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.progressBar\" type=\"checkbox\" id=\"progressBar\"> <span>Progress bar</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.preventDuplicates\" type=\"checkbox\" id=\"preventDuplicates\"> <span>Prevent duplicates</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.preventOpenDuplicates\" type=\"checkbox\" id=\"preventOpenDuplicates\"> <span>Prevent open duplicates</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.tapToDismiss\" type=\"checkbox\" id=\"tapToDismiss\"> <span>Tap to dismiss</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.newestOnTop\" type=\"checkbox\" id=\"newestOnTop\"> <span>Newest on top</span></label></div></div></div><div class=\"col-md-2 col-sm-3 toastr-radio-setup\"><div id=\"toastTypeGroup\"><div class=\"controls radio-controls\"><label class=\"radio-header\">Toast Type</label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.type\" name=\"toasts\" value=\"success\"><span>Success</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.type\" name=\"toasts\" value=\"info\"><span>Info</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.type\" name=\"toasts\" value=\"warning\"><span>Warning</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.type\" name=\"toasts\" value=\"error\"><span>Error</span></label></div></div><div id=\"positionGroup\"><div class=\"controls radio-controls\"><label class=\"radio-header position-header\">Position</label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-top-right\"> <span>Top Right</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-bottom-right\"> <span>Bottom Right</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-bottom-left\"> <span>Bottom Left</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-top-left\"> <span>Top Left</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-top-full-width\"> <span>Top Full Width</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-bottom-full-width\"> <span>Bottom Full Width</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-top-center\"> <span>Top Center</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-bottom-center\"> <span>Bottom Center</span></label></div></div></div><div class=\"col-md-2 col-sm-3\"><div class=\"control\"><label for=\"timeOut\">Time out</label> <input type=\"text\" class=\"form-control\" id=\"timeOut\" ng-model=\"options.timeOut\" placeholder=\"ms\"> <label class=\"sub-label\" for=\"timeOut\">If you set it to 0, it will stick</label></div><div class=\"control\"><label for=\"extendedTimeOut\">Extended time out</label> <input type=\"text\" class=\"form-control\" id=\"extendedTimeOut\" ng-model=\"options.extendedTimeOut\" placeholder=\"ms\"></div><div class=\"control\"><label for=\"maxOpened\">Maximum number of toasts</label> <input type=\"text\" class=\"form-control\" id=\"maxOpened\" ng-model=\"options.maxOpened\" value=\"0\"> <label for=\"maxOpened\" class=\"sub-label\">0 means no limit</label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.autoDismiss\" type=\"checkbox\" id=\"autoDismiss\"> <span>Auto dismiss</span></label></div></div><div class=\"col-md-5 col-sm-12\"><label>Result:</label><pre class=\"result-toastr\" id=\"toastrOptions\">{{optionsStr}}</pre></div></div><div class=\"row\"><div class=\"col-md-12 button-row\"><button ng-click=\"openToast()\" class=\"btn btn-primary\">Open Toast</button> <button ng-click=\"openRandomToast()\" class=\"btn btn-primary\">Random Toast</button> <button ng-click=\"clearToasts()\" class=\"btn btn-danger\">Clear Toasts</button> <button ng-click=\"clearLastToast()\" class=\"btn btn-danger\">Clear Last Toast</button></div></div></div>");
$templateCache.put("app/pages/ui/tabs/contextualAccordion.html","<uib-accordion><uib-accordion-group heading=\"Primary\" panel-class=\"panel-primary bootstrap-panel accordion-panel\">Primary <i class=\"ion-heart\"></i></uib-accordion-group><uib-accordion-group heading=\"Success\" panel-class=\"panel-success bootstrap-panel accordion-panel\">Success <i class=\"ion-checkmark-round\"></i></uib-accordion-group><uib-accordion-group heading=\"Info\" panel-class=\"panel-info bootstrap-panel accordion-panel\">Info <i class=\"ion-information-circled\"></i></uib-accordion-group><uib-accordion-group heading=\"Warning\" panel-class=\"panel-warning bootstrap-panel accordion-panel\">Warning <i class=\"ion-alert\"></i></uib-accordion-group><uib-accordion-group heading=\"Danger\" panel-class=\"panel-danger bootstrap-panel accordion-panel\">Danger <i class=\"ion-nuclear\"></i></uib-accordion-group></uib-accordion>");
$templateCache.put("app/pages/ui/tabs/mainTabs.html","<uib-tabset><uib-tab heading=\"Start\"><p>Take up one idea. Make that one idea your life--think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success.</p><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even become a self-fulfilling prophecy.</p><div class=\"text-center\"><div class=\"kameleon-icon with-round-bg primary inline-icon\"><img ng-src=\"{{::( \'Shop\' | kameleonImg )}}\"></div><div class=\"kameleon-icon with-round-bg primary inline-icon\"><img ng-src=\"{{::( \'Programming\' | kameleonImg )}}\"></div><div class=\"kameleon-icon with-round-bg primary inline-icon\"><img ng-src=\"{{::( \'Dna\' | kameleonImg )}}\"></div></div><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading=\"Getting Done\"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab ng-init=\"$dropdownTabActive = 1\" class=\"with-dropdown\"><uib-tab-heading uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" ng-click=\"$event.stopPropagation()\">Dropdown tab <i class=\"caret\"></i></a><ul class=\"uib-dropdown-menu\"><li><a ng-click=\"$dropdownTabActive = 1\">Tab 1</a></li><li><a ng-click=\"$dropdownTabActive = 2\">Tab 2</a></li></ul></uib-tab-heading><div ng-show=\"$dropdownTabActive == 1\"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></div><div ng-show=\"$dropdownTabActive == 2\"><p class=\"text-center\"><button class=\"btn btn-danger\">I\'m just a dummy button</button></p></div></uib-tab></uib-tabset>");
$templateCache.put("app/pages/ui/tabs/sampleAccordion.html","<uib-accordion><uib-accordion-group is-open=\"true\" heading=\"Static Header, initially expanded\" panel-class=\"bootstrap-panel accordion-panel panel-default\">This content is straight in the template.</uib-accordion-group><uib-accordion-group heading=\"Dynamic Body Content\" panel-class=\"bootstrap-panel accordion-panel panel-default\"><p>The body of the uib-accordion group grows to fit the contents</p><button type=\"button\" class=\"btn btn-primary btn-sm\">Add Item</button></uib-accordion-group><uib-accordion-group heading=\"Custom template\" panel-class=\"bootstrap-panel accordion-panel panel-default\">Hello</uib-accordion-group><uib-accordion-group panel-class=\"bootstrap-panel accordion-panel panel-default\"><uib-accordion-heading>I can have markup, too! <i class=\"fa pull-right ion-settings\"></i></uib-accordion-heading>This is just some content to illustrate fancy headings.</uib-accordion-group></uib-accordion>");
$templateCache.put("app/pages/ui/tabs/sideTabs.html","<div ba-panel=\"\" ba-panel-class=\"tabs-panel xsmall-panel with-scroll\"><uib-tabset class=\"tabs-left\"><uib-tab heading=\"Start\"><p class=\"text-center\">Take up one idea.</p><div class=\"kameleon-icon-tabs kameleon-icon with-round-bg danger\"><img ng-src=\"{{::( \'Key\' | kameleonImg )}}\"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading=\"Get it done\"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading=\"Achieve\"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div><div ba-panel=\"\" ba-panel-class=\"tabs-panel xsmall-panel with-scroll\"><uib-tabset class=\"tabs-right\"><uib-tab heading=\"Start\"><p class=\"text-center\">Take up one idea.</p><div class=\"kameleon-icon-tabs kameleon-icon with-round-bg warning\"><img ng-src=\"{{::( \'Phone-Booth\' | kameleonImg )}}\"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading=\"Get it done\"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading=\"Achieve\"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div>");
$templateCache.put("app/pages/ui/tabs/tabs.html","<div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"with-scroll horizontal-tabs tabs-panel medium-panel\"><div ng-include=\"\'app/pages/ui/tabs/mainTabs.html\'\"></div></div></div><div class=\"col-md-6 tabset-group\" ng-include=\"\'app/pages/ui/tabs/sideTabs.html\'\"></div></div><div class=\"row accordions-row\"><div class=\"col-md-6\" ng-include=\"\'app/pages/ui/tabs/sampleAccordion.html\'\"></div><div class=\"col-md-6\" ng-include=\"\'app/pages/ui/tabs/contextualAccordion.html\'\"></div></div></div>");
$templateCache.put("app/pages/ui/progressBars/progressBars.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Basic\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/progressBars/widgets/basic.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Striped\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/progressBars/widgets/striped.html\'\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"With label\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/progressBars/widgets/label.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Animated\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/progressBars/widgets/animated.html\'\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Stacked\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/progressBars/widgets/stacked.html\'\"></div></div></div></div>");
$templateCache.put("app/pages/ui/grid/baseGrid.html","<h4 class=\"grid-h\">Stacked to horizontal</h4><div class=\"row show-grid\"><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div></div><div class=\"row show-grid\"><div class=\"col-md-8\"><div>.col-md-8</div></div><div class=\"col-md-4\"><div>.col-md-4</div></div></div><div class=\"row show-grid\"><div class=\"col-md-4\"><div>.col-md-4</div></div><div class=\"col-md-4\"><div>.col-md-4</div></div><div class=\"col-md-4\"><div>.col-md-4</div></div></div><div class=\"row show-grid\"><div class=\"col-md-6\"><div>.col-md-6</div></div><div class=\"col-md-6\"><div>.col-md-6</div></div></div><h4 class=\"grid-h\">Mobile and desktop</h4><div class=\"row show-grid\"><div class=\"col-xs-12 col-md-8\"><div>xs-12 .col-md-8</div></div><div class=\"col-xs-6 col-md-4\"><div>xs-6 .col-md-4</div></div></div><div class=\"row show-grid\"><div class=\"col-xs-6 col-md-4\"><div>xs-6 .col-md-4</div></div><div class=\"col-xs-6 col-md-4\"><div>xs-6 .col-md-4</div></div><div class=\"col-xs-6 col-md-4\"><div>xs-6 .col-md-4</div></div></div><div class=\"row show-grid\"><div class=\"col-xs-6\"><div>.col-xs-6</div></div><div class=\"col-xs-6\"><div>.col-xs-6</div></div></div><h4 class=\"grid-h\">Mobile, tablet, desktop</h4><div class=\"row show-grid\"><div class=\"col-xs-12 col-sm-6 col-md-8\"><div>.col-xs-12 .col-sm-6 .col-md-8</div></div><div class=\"col-xs-6 col-md-4\"><div>.col-xs-6 .col-md-4</div></div></div><div class=\"row show-grid\"><div class=\"col-xs-6 col-sm-4\"><div>.col-xs-6 .col-sm-4</div></div><div class=\"col-xs-6 col-sm-4\"><div>.col-xs-6 .col-sm-4</div></div><div class=\"clearfix visible-xs-block\"></div><div class=\"col-xs-6 col-sm-4\"><div>.col-xs-6 .col-sm-4</div></div></div><h4 class=\"grid-h\">Column wrapping</h4><div class=\"row show-grid\"><div class=\"col-xs-9\"><div>.col-xs-9</div></div><div class=\"col-xs-4\"><div>.col-xs-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous unit.</div></div><div class=\"col-xs-6\"><div>.col-xs-6<br>Subsequent columns continue along the new line.</div></div></div><h4 class=\"grid-h\">Responsive column resets</h4><div class=\"row show-grid\"><div class=\"col-xs-6 col-sm-3\"><div>.col-xs-6 .col-sm-3<p>Resize your viewport or check it out on your phone for an example.</p></div></div><div class=\"col-xs-6 col-sm-3\"><div>.col-xs-6 .col-sm-3</div></div><div class=\"clearfix visible-xs-block\"></div><div class=\"col-xs-6 col-sm-3\"><div>.col-xs-6 .col-sm-3</div></div><div class=\"col-xs-6 col-sm-3\"><div>.col-xs-6 .col-sm-3</div></div></div><h4 class=\"grid-h\">Offsetting columns</h4><div class=\"row show-grid\"><div class=\"col-md-4\"><div>.col-md-4</div></div><div class=\"col-md-4 col-md-offset-4\"><div>.col-md-4 .col-md-offset-4</div></div></div><div class=\"row show-grid\"><div class=\"col-md-3 col-md-offset-3\"><div>.col-md-3 .col-md-offset-3</div></div><div class=\"col-md-3 col-md-offset-3\"><div>.col-md-3 .col-md-offset-3</div></div></div><div class=\"row show-grid\"><div class=\"col-md-6 col-md-offset-3\"><div>.col-md-6 .col-md-offset-3</div></div></div><h4 class=\"grid-h\">Grid options</h4><div class=\"table-responsive\"><table class=\"table table-bordered table-striped\"><thead><tr><th></th><th>Extra small devices <small>Phones (&lt;768px)</small></th><th>Small devices <small>Tablets (≥768px)</small></th><th>Medium devices <small>Desktops (≥992px)</small></th><th>Large devices <small>Desktops (≥1200px)</small></th></tr></thead><tbody><tr><th class=\"text-nowrap\" scope=\"row\">Grid behavior</th><td>Horizontal at all times</td><td colspan=\"3\">Collapsed to start, horizontal above breakpoints</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Container width</th><td>None (auto)</td><td>750px</td><td>970px</td><td>1170px</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Class prefix</th><td><code>.col-xs-</code></td><td><code>.col-sm-</code></td><td><code>.col-md-</code></td><td><code>.col-lg-</code></td></tr><tr><th class=\"text-nowrap\" scope=\"row\"># of columns</th><td colspan=\"4\">12</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Column width</th><td class=\"text-muted\">Auto</td><td>~62px</td><td>~81px</td><td>~97px</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Gutter width</th><td colspan=\"4\">30px (15px on each side of a column)</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Nestable</th><td colspan=\"4\">Yes</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Offsets</th><td colspan=\"4\">Yes</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Column ordering</th><td colspan=\"4\">Yes</td></tr></tbody></table></div>");
$templateCache.put("app/pages/ui/grid/grid.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Inline Form\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/grid/baseGrid.html\'\"></div></div></div></div>");
$templateCache.put("app/pages/ui/panels/panels.html","<h2>Default panels</h2><div class=\"row\"><div class=\"col-md-12 col-lg-4\"><div ba-panel=\"\" ba-panel-class=\"xsmall-panel light-text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac mi erat. Phasellus placerat, elit a laoreet semper, enim ipsum ultricies orci, ac tincidunt tellus massa eu est. Nam non porta purus, sed facilisis justo. Nam pulvinar sagittis quam.</div></div><div class=\"col-md-12 col-lg-4\"><div ba-panel=\"\" ba-panel-title=\"Panel with header\" ba-panel-class=\"xsmall-panel light-text\">Phasellus maximus venenatis augue, et vestibulum neque aliquam ut. Morbi mattis libero vitae vulputate dignissim. Praesent placerat, sem non dapibus cursus, lacus nisi blandit quam, vitae porttitor lectus lacus non turpis. Donec suscipit consequat tellus.</div></div><div class=\"col-md-12 col-lg-4\"><div ba-panel=\"\" ba-panel-title=\"Panel with header & scroll\" ba-panel-class=\"xsmall-panel with-scroll light-text\"><p>Suspendisse nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Sed dapibus, purus vel hendrerit consectetur, lectus orci gravida massa, sed bibendum dui mauris et eros. Nulla dolor massa, posuere et dictum sit amet, dignissim quis odio. Fusce mollis finibus dignissim. Integer sodales augue erat. Pellentesque laoreet vestibulum urna at iaculis. Nulla libero augue, euismod at diam eget, aliquam condimentum ligula. Donec a leo eu est molestie lacinia hendrerit sed lorem. Duis id diam eu metus sodales consequat vel eu elit. Praesent dolor nibh, convallis eleifend feugiat a, finibus porttitor nibh. Ut non libero vel velit pulvinar scelerisque non vel lorem. Integer porta tempor nulla. Sed nibh erat, ultrices vel lorem eu, rutrum vehicula sem.</p><p>Donec nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum nec ligula egestas rhoncus. Sed dignissim, augue vel scelerisque vulputate, nisi ante posuere lorem, quis iaculis eros dolor eu nisl. Etiam sagittis, ipsum ac tempor iaculis, justo neque mattis ante, ac maximus sapien risus eu sapien. Morbi erat urna, varius et lectus vel, porta dictum orci. Duis bibendum euismod elit, et lobortis purus venenatis in. Mauris eget lacus enim. Cras quis sem et magna fringilla convallis. Proin hendrerit nulla vel gravida mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vestibulum consectetur quis purus vel aliquam.</p></div></div></div><h2>Bootstrap panels</h2><div class=\"row\"><div class=\"col-md-12 col-lg-4\"><div class=\"panel panel-default bootstrap-panel xsmall-panel\"><div class=\"panel-body\"><p>A panel in bootstrap is a bordered box with some padding around its content.</p><p class=\"p-with-code\">Panels are created with the <code>.panel</code> class, and content inside the panel has a <code>.panel-body</code> class. The <code>.panel-default .panel-primary .panel-danger</code> and other classes are used to style the color of the panel. See the next example on this page for more contextual classes.</p></div></div></div><div class=\"col-md-12 col-lg-4\"><div class=\"panel panel-default bootstrap-panel xsmall-panel\"><div class=\"panel-heading\">Panel Heading</div><div class=\"panel-body\"><p class=\"p-with-code\">The <code>.panel-heading</code> class adds a heading to the panel.Easily add a heading container to your panel with .panel-heading. You may also include any <code>h1-h6</code> with a <code>.panel-title</code> class to add a pre-styled heading.</p></div></div></div><div class=\"col-md-12 col-lg-4\"><div class=\"panel panel-default bootstrap-panel\"><div class=\"panel-body footer-panel\"><p class=\"p-with-code\">Wrap buttons or secondary text in <code>.panel-footer</code>. Note that panel footers do not inherit colors and borders when using contextual variations as they are not meant to be in the foreground.</p></div><div class=\"panel-footer\">Panel Footer</div></div></div></div><h2>Panels with Contextual Classes</h2><div class=\"row\"><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-default contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-default class</div><div class=\"panel-body\">To color the panel, use contextual classes. This is sample <code>.panel-default</code> panel</div></div></div><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-primary contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-primary class</div><div class=\"panel-body\">Sample <code>.panel-primary</code> panel</div></div></div><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-success contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-success class</div><div class=\"panel-body\">Sample <code>.panel-success</code> panel</div></div></div><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-info contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-info class</div><div class=\"panel-body\">Sample <code>.panel-info</code> panel</div></div></div><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-warning contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-warning class</div><div class=\"panel-body\">Sample <code>.panel-warning</code> panel</div></div></div><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-danger contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-danger class</div><div class=\"panel-body\">Sample <code>.panel-danger</code> panel</div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><h2>Panel Group</h2><div class=\"panel-group\"><div class=\"panel panel-default bootstrap-panel\"><div class=\"panel-heading\">Panel group 1</div><div class=\"panel-body\"><p>To group many panels together, wrap a <code>&lt;div&gt;</code> with class <code>\n            .panel-group</code> around them.</p></div></div><div class=\"panel panel-default bootstrap-panel\"><div class=\"panel-heading\">Panel group 2</div><div class=\"panel-body\"><p>The <code>.panel-group</code> class clears the bottom-margin of each panel.</p></div></div></div></div></div>");
$templateCache.put("app/pages/ui/alerts/alerts.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Basic\" ba-panel-class=\"with-scroll\"><div><div class=\"alert bg-success\"><strong>Well done!</strong> You successfully read this important alert message.</div><div class=\"alert bg-info\"><strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class=\"alert bg-warning\"><strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class=\"alert bg-danger\"><strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Dismissible alerts\" ba-panel-class=\"with-scroll\"><div><div class=\"alert bg-success closeable\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <strong>Well done!</strong> You successfully read this important alert message.</div><div class=\"alert bg-info closeable\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class=\"alert bg-warning closeable\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class=\"alert bg-danger closeable\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div></div><div class=\"row\"><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Links in alerts\" ba-panel-class=\"with-scroll\"><div><div class=\"alert bg-success\"><strong>Well done!</strong> You successfully read <a href=\"\" class=\"alert-link\">this important alert message</a>.</div><div class=\"alert bg-info\"><strong>Heads up!</strong> This <a href=\"\" class=\"alert-link\">alert needs your attention</a>, but it\'s not super important.</div><div class=\"alert bg-warning\"><strong>Warning!</strong> Better check yourself, you\'re <a href=\"\" class=\"alert-link\">not looking too good</a>.</div><div class=\"alert bg-danger\"><strong>Oh snap!</strong> <a href=\"\" class=\"alert-link\">Change a few things up</a> and try submitting again.</div></div></div><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Composite alerts\" ba-panel-class=\"with-scroll\"><div><div class=\"alert bg-warning\"><h4>Warning!</h4><strong>Pay attention.</strong> Change a few things up and try submitting again.<div class=\"control-alert\"><button type=\"button\" class=\"btn btn-danger\">Pay Attention</button> <button type=\"button\" class=\"btn btn-primary\">Ignore</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/ui/slider/slider.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Ion Range Slider\" ba-panel-class=\"with-scroll\"><div class=\"slider-box\"><h5>Basic</h5><ion-slider type=\"single\" grid=\"false\" min=\"0\" max=\"100\" from=\"45\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>With prefix</h5><ion-slider type=\"single\" grid=\"true\" min=\"100\" max=\"1200\" prefix=\"$\" from=\"420\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>With postfix</h5><ion-slider type=\"single\" grid=\"true\" min=\"-90\" max=\"90\" postfix=\"°\" from=\"36\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>Two way range</h5><ion-slider type=\"double\" grid=\"true\" min=\"100\" max=\"1200\" from=\"420\" to=\"900\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>With Steps</h5><ion-slider type=\"single\" grid=\"true\" min=\"0\" max=\"1000\" from=\"300\" step=\"50\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>Decorating numbers</h5><ion-slider type=\"single\" grid=\"true\" min=\"0\" max=\"1000000\" from=\"300000\" step=\"1000\" prettify-separator=\".\" prettify=\"true\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>Using custom values array</h5><ion-slider type=\"single\" grid=\"true\" from=\"5\" step=\"1000\" values=\"[\'January\', \'February\', \'March\', \'April\', \'May\', \'June\', \'July\', \'August\', \'September\', \'October\', \'November\', \'December\']\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>Disabled</h5><ion-slider type=\"single\" grid=\"false\" min=\"0\" max=\"100\" from=\"45\" disable=\"true\"></ion-slider></div></div></div></div>");
$templateCache.put("app/pages/ui/typography/typography.html","<div class=\"typography-document-samples row-fluid\"><div class=\"col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget\"><div ba-panel=\"\" ba-panel-class=\"with-scroll heading-widget\" ba-panel-title=\"Text Size\"><div class=\"section-block\"><h1>H1. Heading 1</h1><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class=\"section-block\"><h2>H2. Heading 2</h2><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class=\"section-block\"><h3>H3. Heading 3</h3><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class=\"section-block\"><h4>H4. Heading 4</h4><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra,.</p></div><div class=\"section-block\"><h5>H5. Heading 5</h5><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</p></div></div></div><div class=\"col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget\"><div ba-panel=\"\" ba-panel-class=\"with-scroll more-text-widget\" ba-panel-title=\"Some more text\"><div class=\"section-block light-text\"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis.</p></div><div class=\"section-block regular-text\"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id.</p></div><div class=\"section-block upper-text bold-text\"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class=\"section-block bold-text\"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullam-corper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class=\"section-block small-text\"><p>Secondary text. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar,</p><p>lacinia scelerisque pharetra, placerat vestibulum eleifend</p><p>pellentesque, mi nam.</p></div></div></div><div class=\"col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget\"><div ba-panel=\"\" ba-panel-class=\"with-scroll lists-widget\" ba-panel-title=\"Lists\"><div class=\"section-block\"><h5 class=\"list-header\">Unordered list:</h5><ul class=\"blur\"><li>Lorem ipsum dolor sit amet</li><li>Сlacinia scelerisque pharetra<ul><li>Dui rhoncus quisque integer lorem<ul><li>Libero iaculis vestibulum eu vitae</li></ul></li></ul></li><li>Nisl lectus nibh habitasse suspendisse ut</li><li><span>Posuere cursus hac, vestibulum wisi nulla bibendum</span></li></ul><h5 class=\"list-header\">Ordered Lists:</h5><ol class=\"blur\"><li><span>Eu non nec cursus quis mollis, amet quam nec</span></li><li><span>Et suspendisse, adipiscing fringilla ornare sit ligula sed</span><ol><li><span>Interdum et justo nulla</span><ol><li><span>Magna amet, suscipit suscipit non amet</span></li></ol></li></ol></li><li><span>Metus duis eu non eu ridiculus turpis</span></li><li><span>Neque egestas id fringilla consectetuer justo curabitur, wisi magna neque commodo volutpat</span></li></ol><div class=\"accent\">Important text fragment. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</div></div></div></div><div class=\"col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget\"><div ba-panel=\"\" ba-panel-class=\"with-scroll color-widget\" ba-panel-title=\"Text Color\"><div class=\"section-block red-text\"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p></div><div class=\"section-block yellow-text\"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula ut id elit. In sed ornare nulla.</p></div><div class=\"section-block links\"><p>Lorem ipsum <a href=\"\">dolor</a> sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis <a href=\"\">ullamcorper</a> ligula sodales at. Nulla tellus elit, varius non commodo eget, <a href=\"\">mattis</a> vel eros. In sed ornare nulla.</p></div><div class=\"section-block links\"><p><a href=\"\">Active link — #209e91</a></p><p class=\"hovered\"><a href=\"\">Hover link — #17857a</a></p></div></div></div></div><div class=\"row-fluid\"><div class=\"col-lg-12 col-sm-12 col-xs-12\"><div ba-panel=\"\" ba-panel-class=\"banner-column-panel\"><div class=\"banner\"><div class=\"large-banner-wrapper\"><img ng-src=\"{{::( \'app/typography/banner.png\' | appImage )}}\" alt=\"\"></div><div class=\"banner-text-wrapper\"><div class=\"banner-text\"><h1>Simple Banner Text</h1><p>Lorem ipsum dolor sit amet</p><p>Odio amet viverra rutrum</p></div></div></div><div class=\"section\"><h2>Columns</h2><div class=\"row\"><div class=\"col-sm-6\"><div class=\"img-wrapper\"><img ng-src=\"{{::( \'app/typography/typo03.png\' | appImage )}}\" alt=\"\" title=\"\"></div><p>Vel elit, eros elementum, id lacinia, duis non ut ut tortor blandit. Mauris <a href=\"\">dapibus</a> magna rutrum. Ornare neque suspendisse <a href=\"\">phasellus wisi</a>, quam cras pede rutrum suspendisse, <a href=\"\">felis amet eu</a>. Congue magna elit quisque quia, nullam justo sagittis, ante erat libero placerat, proin condimentum consectetuer lacus. Velit condimentum velit, sed penatibus arcu nulla.</p></div><div class=\"col-sm-6\"><div class=\"img-wrapper\"><img ng-src=\"{{::( \'app/typography/typo01.png\' | appImage )}}\" alt=\"\" title=\"\"></div><p>Et suspendisse, adipiscing fringilla ornare sit ligula sed, vel nam. Interdum et justo nulla, fermentum lobortis purus ut eu, duis nibh dolor massa tristique elementum, nibh iste potenti risus fusce aliquet fusce, ullamcorper debitis primis arcu tellus vestibulum ac.</p></div></div><div class=\"separator\"></div><div class=\"row\"><div class=\"col-sm-4\"><h4>Column heading example</h4><div class=\"img-wrapper\"><img ng-src=\"{{::( \'app/typography/typo04.png\' | appImage )}}\" alt=\"\"></div><p>Eget augue, lacus erat ante egestas scelerisque aliquam, metus molestie leo in habitasse magna maecenas</p><a href=\"\" class=\"learn-more\">Lean more</a></div><div class=\"col-sm-4\"><h4>Yet another column heading example</h4><div class=\"img-wrapper\"><img ng-src=\"{{::( \'app/typography/typo05.png\' | appImage )}}\" alt=\"\"></div><p>Augue massa et parturient, suspendisse orci nec scelerisque sit, integer nam mauris pede consequat in velit</p><a href=\"\" class=\"learn-more\">Lean more</a></div><div class=\"col-sm-4\"><h4>Third column heading example</h4><div class=\"img-wrapper\"><img ng-src=\"{{::( \'app/typography/typo06.png\' | appImage )}}\" alt=\"\"></div><p>Eget turpis, tortor lobortis porttitor, vestibulum nullam vehicula aliquam</p><a href=\"\" class=\"learn-more\">Lean more</a></div></div><div class=\"separator\"></div></div></div></div></div>");
$templateCache.put("app/pages/form/inputs/widgets/checkboxesRadios.html","<div class=\"checkbox-demo-row\"><div class=\"input-demo checkbox-demo row\"><div class=\"col-md-4\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"inlineCheckbox01\" value=\"option1\"> <span>Check 1</span></label></div><div class=\"col-md-4\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"inlineCheckbox02\" value=\"option2\"> <span>Check 2</span></label></div><div class=\"col-md-4\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"inlineCheckbox03\" value=\"option3\"> <span>Check 3</span></label></div></div><div class=\"input-demo radio-demo row\"><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"inlineRadio1\" value=\"option1\"> <span>Option 1</span></label></div><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"inlineRadio2\" value=\"option2\"> <span>Option 2</span></label></div><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"inlineRadio3\" value=\"option3\"> <span>Option3</span></label></div></div></div><div><div class=\"checkbox disabled\"><label class=\"custom-checkbox nowrap\"><input type=\"checkbox\" value=\"\" disabled=\"\"> <span>Checkbox is disabled</span></label></div><div class=\"radio disabled\"><label class=\"custom-radio nowrap\"><input type=\"radio\" name=\"optionsRadios\" id=\"optionsRadios3\" value=\"option3\" disabled=\"\"> <span>Disabled option</span></label></div></div>");
$templateCache.put("app/pages/form/inputs/widgets/inputGroups.html","<div class=\"input-group\"><span class=\"input-group-addon input-group-addon-primary addon-left\" id=\"basic-addon1\">@</span> <input type=\"text\" class=\"form-control with-primary-addon\" placeholder=\"Username\" aria-describedby=\"basic-addon1\"></div><div class=\"input-group\"><input type=\"text\" class=\"form-control with-warning-addon\" placeholder=\"Recipient\'s username\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-addon input-group-addon-warning addon-right\" id=\"basic-addon2\">@example.com</span></div><div class=\"input-group\"><span class=\"input-group-addon addon-left input-group-addon-success\">$</span> <input type=\"text\" class=\"form-control with-success-addon\" aria-label=\"Amount (to the nearest dollar)\"> <span class=\"input-group-addon addon-right input-group-addon-success\">.00</span></div><div class=\"input-group\"><input type=\"text\" class=\"form-control with-danger-addon\" placeholder=\"Search for...\"> <span class=\"input-group-btn\"><button class=\"btn btn-danger\" type=\"button\">Go!</button></span></div>");
$templateCache.put("app/pages/form/inputs/widgets/standardFields.html","<form><div class=\"form-group\"><label for=\"input01\">Text</label> <input type=\"text\" class=\"form-control\" id=\"input01\" placeholder=\"Text\"></div><div class=\"form-group\"><label for=\"input02\">Password</label> <input type=\"password\" class=\"form-control\" id=\"input02\" placeholder=\"Password\"></div><div class=\"form-group\"><label for=\"input03\">Rounded Corners</label> <input type=\"text\" class=\"form-control form-control-rounded\" id=\"input03\" placeholder=\"Rounded Corners\"></div><div class=\"form-group\"><label for=\"input04\">With help</label> <input type=\"text\" class=\"form-control\" id=\"input04\" placeholder=\"With help\"> <span class=\"help-block sub-little-text\">A block of help text that breaks onto a new line and may extend beyond one line.</span></div><div class=\"form-group\"><label for=\"input05\">Disabled Input</label> <input type=\"text\" class=\"form-control\" id=\"input05\" placeholder=\"Disabled Input\" disabled=\"\"></div><div class=\"form-group\"><label for=\"textarea01\">Textarea</label> <textarea placeholder=\"Default Input\" class=\"form-control\" id=\"textarea01\"></textarea></div><div class=\"form-group\"><input type=\"text\" class=\"form-control input-sm\" id=\"input2\" placeholder=\"Small Input\"></div><div class=\"form-group\"><input type=\"text\" class=\"form-control input-lg\" id=\"input4\" placeholder=\"Large Input\"></div></form>");
$templateCache.put("app/pages/form/inputs/widgets/validationStates.html","<div class=\"form-group has-success\"><label class=\"control-label\" for=\"inputSuccess1\">Input with success</label> <input type=\"text\" class=\"form-control\" id=\"inputSuccess1\"></div><div class=\"form-group has-warning\"><label class=\"control-label\" for=\"inputWarning1\">Input with warning</label> <input type=\"text\" class=\"form-control\" id=\"inputWarning1\"></div><div class=\"form-group has-error\"><label class=\"control-label\" for=\"inputError1\">Input with error</label> <input type=\"text\" class=\"form-control\" id=\"inputError1\"></div><div class=\"has-success\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxSuccess\" value=\"option1\"> <span>Checkbox with success</span></label></div></div><div class=\"has-warning\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxWarning\" value=\"option1\"> <span>Checkbox with warning</span></label></div></div><div class=\"has-error\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxError\" value=\"option1\"> <span>Checkbox with error</span></label></div></div><div class=\"form-group has-success has-feedback\"><label class=\"control-label\" for=\"inputSuccess2\">Input with success</label> <input type=\"text\" class=\"form-control\" id=\"inputSuccess2\" aria-describedby=\"inputSuccess2Status\"> <i class=\"ion-checkmark-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputSuccess2Status\" class=\"sr-only\">(success)</span></div><div class=\"form-group has-warning has-feedback\"><label class=\"control-label\" for=\"inputWarning2\">Input with warning</label> <input type=\"text\" class=\"form-control\" id=\"inputWarning2\" aria-describedby=\"inputWarning2Status\"> <i class=\"ion-alert-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputWarning2Status\" class=\"sr-only\">(warning)</span></div><div class=\"form-group has-error has-feedback\"><label class=\"control-label\" for=\"inputError2\">Input with error</label> <input type=\"text\" class=\"form-control\" id=\"inputError2\" aria-describedby=\"inputError2Status\"> <i class=\"ion-android-cancel form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputError2Status\" class=\"sr-only\">(error)</span></div><div class=\"form-group has-success has-feedback\"><label class=\"control-label\" for=\"inputGroupSuccess1\">Input group with success</label><div class=\"input-group\"><span class=\"input-group-addon addon-left\">@</span> <input type=\"text\" class=\"form-control\" id=\"inputGroupSuccess1\" aria-describedby=\"inputGroupSuccess1Status\"></div><i class=\"ion-checkmark-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputGroupSuccess1Status\" class=\"sr-only\">(success)</span></div>");
$templateCache.put("app/pages/form/layouts/widgets/basicForm.html","<form><div class=\"form-group\"><label for=\"exampleInputEmail1\">Email address</label> <input type=\"email\" class=\"form-control\" id=\"exampleInputEmail1\" placeholder=\"Email\"></div><div class=\"form-group\"><label for=\"exampleInputPassword1\">Password</label> <input type=\"password\" class=\"form-control\" id=\"exampleInputPassword1\" placeholder=\"Password\"></div><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\"> <span>Check me out</span></label></div><button type=\"submit\" class=\"btn btn-danger\">Submit</button></form>");
$templateCache.put("app/pages/form/layouts/widgets/blockForm.html","<div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">First Name</label> <input type=\"text\" class=\"form-control\" id=\"inputFirstName\" placeholder=\"First Name\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputLastName\">Last Name</label> <input type=\"text\" class=\"form-control\" id=\"inputLastName\" placeholder=\"Last Name\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">Email</label> <input type=\"email\" class=\"form-control\" id=\"inputEmail\" placeholder=\"Email\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputWebsite\">Website</label> <input type=\"text\" class=\"form-control\" id=\"inputWebsite\" placeholder=\"Website\"></div></div></div><button type=\"submit\" class=\"btn btn-primary\">Submit</button>");
$templateCache.put("app/pages/form/layouts/widgets/formWithoutLabels.html","<form><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Recipients\"></div><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Subject\"></div><div class=\"form-group\"><textarea class=\"form-control\" placeholder=\"Message\"></textarea></div><button type=\"submit\" class=\"btn btn-success\">Send</button></form>");
$templateCache.put("app/pages/form/layouts/widgets/horizontalForm.html","<form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">Email</label><div class=\"col-sm-10\"><input type=\"email\" class=\"form-control\" id=\"inputEmail3\" placeholder=\"Email\"></div></div><div class=\"form-group\"><label for=\"inputPassword3\" class=\"col-sm-2 control-label\">Password</label><div class=\"col-sm-10\"><input type=\"password\" class=\"form-control\" id=\"inputPassword3\" placeholder=\"Password\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\"> <span>Remember me</span></label></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-warning\">Sign in</button></div></div></form>");
$templateCache.put("app/pages/form/layouts/widgets/inlineForm.html","<form class=\"row form-inline\"><div class=\"form-group col-sm-3 col-xs-6\"><input type=\"text\" class=\"form-control\" id=\"exampleInputName2\" placeholder=\"Name\"></div><div class=\"form-group col-sm-3 col-xs-6\"><input type=\"email\" class=\"form-control\" id=\"exampleInputEmail2\" placeholder=\"Email\"></div><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\"> <span>Remember me</span></label></div><button type=\"submit\" class=\"btn btn-primary\">Send invitation</button></form>");
$templateCache.put("app/pages/ui/buttons/widgets/buttonGroups.html","<div class=\"btn-group-example\"><div class=\"btn-group\" role=\"group\" aria-label=\"Basic example\"><button type=\"button\" class=\"btn btn-danger\">Left</button> <button type=\"button\" class=\"btn btn-danger\">Middle</button> <button type=\"button\" class=\"btn btn-danger\">Right</button></div></div><div class=\"btn-toolbar-example\"><div class=\"btn-toolbar\" role=\"toolbar\" aria-label=\"Toolbar with button groups\"><div class=\"btn-group\" role=\"group\" aria-label=\"First group\"><button type=\"button\" class=\"btn btn-primary\">1</button> <button type=\"button\" class=\"btn btn-primary\">2</button> <button type=\"button\" class=\"btn btn-primary\">3</button> <button type=\"button\" class=\"btn btn-primary\">4</button></div><div class=\"btn-group\" role=\"group\" aria-label=\"Second group\"><button type=\"button\" class=\"btn btn-primary\">5</button> <button type=\"button\" class=\"btn btn-primary\">6</button> <button type=\"button\" class=\"btn btn-primary\">7</button></div><div class=\"btn-group\" role=\"group\" aria-label=\"Third group\"><button type=\"button\" class=\"btn btn-primary\">8</button></div></div></div>");
$templateCache.put("app/pages/ui/buttons/widgets/buttons.html","<div class=\"basic-btns\"><div class=\"row\"><div class=\"col-md-2\"><h5>Default button</h5></div><div class=\"col-md-10\"><div class=\"row btns-row btns-same-width-md\"><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-primary\">Primary</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-default\">Default</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-success\">Success</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-info\">Info</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-warning\">Warning</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-danger\">Danger</button></div></div></div></div><div class=\"row\"><div class=\"col-md-2\"><h5 class=\"row-sm\">Small button</h5></div><div class=\"col-md-10\"><div class=\"row btns-row btns-same-width-md\"><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-primary btn-sm\">Primary</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-default btn-sm\">Default</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-success btn-sm\">Success</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-info btn-sm\">Info</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-warning btn-sm\">Warning</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-danger btn-sm\">Danger</button></div></div></div></div><div class=\"row\"><div class=\"col-md-2\"><h5 class=\"row-xs\">Extra small button</h5></div><div class=\"col-md-10\"><div class=\"row btns-row btns-same-width-md\"><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-primary btn-xs\">Primary</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-default btn-xs\">Default</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-success btn-xs\">Success</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-info btn-xs\">Info</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-warning btn-xs\">Warning</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-danger btn-xs\">Danger</button></div></div></div></div><div class=\"row\"><div class=\"col-md-2\"><h5>Disabled button</h5></div><div class=\"col-md-10\"><div class=\"row btns-row btns-same-width-md\"><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-primary\" disabled=\"disabled\">Primary</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-default\" disabled=\"disabled\">Default</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-success\" disabled=\"disabled\">Success</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-info\" disabled=\"disabled\">Info</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-warning\" disabled=\"disabled\">Warning</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-danger\" disabled=\"disabled\">Danger</button></div></div></div></div></div>");
$templateCache.put("app/pages/ui/buttons/widgets/dropdowns.html","<div class=\"row btns-row\"><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle=\"\">Primary <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-success\" uib-dropdown-toggle=\"\">Success <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-info\" uib-dropdown-toggle=\"\">Info <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\">Default <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-warning\" uib-dropdown-toggle=\"\">Warning <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-danger\" uib-dropdown-toggle=\"\">Danger <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div></div><h5 class=\"panel-subtitle\">Split button dropdowns</h5><div class=\"row btns-row\"><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-primary\">Primary</button> <button type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-success\">Success</button> <button type=\"button\" class=\"btn btn-success\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-info\">Info</button> <button type=\"button\" class=\"btn btn-info\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-default\">Default</button> <button type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-warning\">Warning</button> <button type=\"button\" class=\"btn btn-warning\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-danger\">Danger</button> <button type=\"button\" class=\"btn btn-danger\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div></div>");
$templateCache.put("app/pages/ui/buttons/widgets/iconButtons.html","<ul class=\"btn-list clearfix\"><li><button type=\"button\" class=\"btn btn-primary btn-icon\"><i class=\"ion-android-download\"></i></button></li><li><button type=\"button\" class=\"btn btn-default btn-icon\"><i class=\"ion-stats-bars\"></i></button></li><li><button type=\"button\" class=\"btn btn-success btn-icon\"><i class=\"ion-android-checkmark-circle\"></i></button></li><li><button type=\"button\" class=\"btn btn-info btn-icon\"><i class=\"ion-information\"></i></button></li><li><button type=\"button\" class=\"btn btn-warning btn-icon\"><i class=\"ion-android-warning\"></i></button></li><li><button type=\"button\" class=\"btn btn-danger btn-icon\"><i class=\"ion-nuclear\"></i></button></li></ul><h5 class=\"panel-subtitle\">Buttons with icons</h5><ul class=\"btn-list clearfix\"><li><button type=\"button\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-android-download\"></i>Primary</button></li><li><button type=\"button\" class=\"btn btn-default btn-with-icon\"><i class=\"ion-stats-bars\"></i>Default</button></li><li><button type=\"button\" class=\"btn btn-success btn-with-icon\"><i class=\"ion-android-checkmark-circle\"></i>Success</button></li><li><button type=\"button\" class=\"btn btn-info btn-with-icon\"><i class=\"ion-information\"></i>Info</button></li><li><button type=\"button\" class=\"btn btn-warning btn-with-icon\"><i class=\"ion-android-warning\"></i>Warning</button></li><li><button type=\"button\" class=\"btn btn-danger btn-with-icon\"><i class=\"ion-nuclear\"></i>Danger</button></li></ul>");
$templateCache.put("app/pages/ui/buttons/widgets/largeButtons.html","<div class=\"row btns-row btns-same-width-lg\"><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-primary btn-lg\">Primary</button></div><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-success btn-lg\">Success</button></div><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-info btn-lg\">Info</button></div><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-default btn-lg\">Default</button></div><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-warning btn-lg\">Warning</button></div><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-danger btn-lg\">Danger</button></div></div>");
$templateCache.put("app/pages/ui/buttons/widgets/progressButtons.html","<div class=\"progress-buttons-container text-center default-text\"><div class=\"row\"><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">fill horizontal</span> <button progress-button=\"progressFunction()\" class=\"btn btn-success\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">fill vertical</span> <button progress-button=\"progressFunction()\" pb-direction=\"vertical\" class=\"btn btn-danger\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">shrink horizontal</span> <button progress-button=\"progressFunction()\" pb-style=\"shrink\" class=\"btn btn-warning\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">shrink vertical</span> <button progress-button=\"progressFunction()\" pb-style=\"shrink\" pb-direction=\"vertical\" class=\"btn btn-info\">Submit</button></section></div><div class=\"row\"><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-angle-bottom<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-angle-bottom\" class=\"btn btn-success\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-angle-top<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-angle-top\" class=\"btn btn-danger\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-angle-left<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-angle-left\" class=\"btn btn-warning\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-angle-right<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-angle-right\" class=\"btn btn-info\">Submit</button></section></div><div class=\"row\"><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-side-down<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-side-down\" class=\"btn btn-success\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-side-up<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-side-up\" class=\"btn btn-danger\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-side-left<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-side-left\" class=\"btn btn-warning\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-side-right<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-side-right\" class=\"btn btn-info\">Submit</button></section></div><div class=\"row\"><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-back<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-back\" class=\"btn btn-success\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">flip-open<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"flip-open\" class=\"btn btn-danger\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">slide-down<br>horizontal</span> <button progress-button=\"progressFunction()\" pb-style=\"slide-down\" class=\"btn btn-warning\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">move-up<br>horizontal</span> <button progress-button=\"progressFunction()\" pb-style=\"move-up\" class=\"btn btn-info\">Submit</button></section></div><div class=\"row\"><section class=\"col-md-6\"><span class=\"button-title\">top-line<br>horizontal</span> <button progress-button=\"progressFunction()\" pb-style=\"top-line\" class=\"btn btn-success\">Submit</button></section><section class=\"col-md-6\"><span class=\"button-title\">lateral-lines<br>vertical</span> <button progress-button=\"progressFunction()\" pb-style=\"lateral-lines\" class=\"btn btn-info\">Submit</button></section></div></div>");
$templateCache.put("app/pages/ui/modals/modalTemplates/basicModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Modal title</h4></div><div class=\"modal-body\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss()\">Save changes</button></div></div>");
$templateCache.put("app/pages/ui/modals/modalTemplates/dangerModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-danger\"><i class=\"ion-flame modal-icon\"></i><span>Error</span></div><div class=\"modal-body text-center\">Your information hasn\'t been saved!</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">OK</button></div></div>");
$templateCache.put("app/pages/ui/modals/modalTemplates/infoModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Information</span></div><div class=\"modal-body text-center\">You\'ve got a new email!</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"$dismiss()\">OK</button></div></div>");
$templateCache.put("app/pages/ui/modals/modalTemplates/largeModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\">Modal title</h4></div><div class=\"modal-body\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss()\">Save changes</button></div></div>");
$templateCache.put("app/pages/ui/modals/modalTemplates/smallModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\">Modal title</h4></div><div class=\"modal-body\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss()\">Save changes</button></div></div>");
$templateCache.put("app/pages/ui/modals/modalTemplates/successModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-success\"><i class=\"ion-checkmark modal-icon\"></i><span>Success</span></div><div class=\"modal-body text-center\">Your information has been saved successfully</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"$dismiss()\">OK</button></div></div>");
$templateCache.put("app/pages/ui/modals/modalTemplates/warningModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-warning\"><i class=\"ion-android-warning modal-icon\"></i><span>Warning</span></div><div class=\"modal-body text-center\">Your computer is about to explode!</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-warning\" ng-click=\"$dismiss()\">OK</button></div></div>");
$templateCache.put("app/pages/ui/icons/widgets/fontAwesomeIcons.html","<div class=\"row icons-list success awesomeIcons\"><div class=\"col-xs-2\" ng-repeat=\"icon in icons.fontAwesomeIcons\"><i class=\"fa {{icon}}\"></i></div></div><a href=\"http://fortawesome.github.io/Font-Awesome/icons/\" target=\"_blank\" class=\"see-all-icons\">See all Font Awesome icons</a>");
$templateCache.put("app/pages/ui/icons/widgets/ionicons.html","<div class=\"row icons-list primary\"><div class=\"col-xs-2\" ng-repeat=\"icon in icons.ionicons\"><i class=\"{{icon}}\"></i></div></div><a href=\"http://ionicons.com/\" target=\"_blank\" class=\"see-all-icons\">See all ionicons icons</a>");
$templateCache.put("app/pages/ui/icons/widgets/kameleon.html","<div class=\"row clearfix\"><div class=\"kameleon-row\" ng-repeat=\"icon in icons.kameleonIcons\"><div class=\"kameleon-icon\"><img ng-src=\"{{:: (icon.img | kameleonImg )}}\"><span>{{icon.name}}</span></div></div></div><a href=\"http://www.kameleon.pics/\" target=\"_blank\" class=\"see-all-icons\">See all Kamaleon icons</a>");
$templateCache.put("app/pages/ui/icons/widgets/kameleonRounded.html","<div class=\"row clearfix\"><div class=\"kameleon-row\" ng-repeat=\"icon in icons.kameleonRoundedIcons\"><div class=\"kameleon-icon with-round-bg {{icon.color}}\"><img ng-src=\"{{::( icon.img | kameleonImg )}}\"><span>{{ icon.name }}</span></div></div></div><a href=\"http://www.kameleon.pics/\" target=\"_blank\" class=\"see-all-icons\">See all Kamaleon icons</a>");
$templateCache.put("app/pages/ui/icons/widgets/socicon.html","<div class=\"row icons-list danger\"><div class=\"col-xs-2\" ng-repeat=\"icon in icons.socicon\"><i class=\"socicon\">{{ icon }}</i></div></div><a href=\"http://www.socicon.com/chart.php\" target=\"_blank\" class=\"see-all-icons\">See all Socicon icons</a>");
$templateCache.put("app/pages/ui/progressBars/widgets/animated.html","<div class=\"progress\"><div class=\"progress-bar progress-bar-success progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"40\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 40%\"><span class=\"sr-only\">40% Complete (success)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-info progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"20\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 20%\"><span class=\"sr-only\">20% Complete</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-warning progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 60%\"><span class=\"sr-only\">60% Complete (warning)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-danger progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"80\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 80%\"><span class=\"sr-only\">80% Complete (danger)</span></div></div>");
$templateCache.put("app/pages/ui/progressBars/widgets/basic.html","<div class=\"progress\"><div class=\"progress-bar progress-bar-success\" role=\"progressbar\" aria-valuenow=\"40\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 40%\"><span class=\"sr-only\">40% Complete (success)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"20\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 20%\"><span class=\"sr-only\">20% Complete</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-warning\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 60%\"><span class=\"sr-only\">60% Complete (warning)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-danger\" role=\"progressbar\" aria-valuenow=\"80\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 80%\"><span class=\"sr-only\">80% Complete (danger)</span></div></div>");
$templateCache.put("app/pages/ui/progressBars/widgets/label.html","<div class=\"progress\"><div class=\"progress-bar progress-bar-success\" role=\"progressbar\" aria-valuenow=\"40\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 40%\">40% Complete (success)</div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"20\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 20%\">20% Complete</div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-warning\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 60%\">60% Complete (warning)</div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-danger\" role=\"progressbar\" aria-valuenow=\"80\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 80%\">80% Complete (danger)</div></div>");
$templateCache.put("app/pages/ui/progressBars/widgets/stacked.html","<div class=\"progress\"><div class=\"progress-bar progress-bar-success\" style=\"width: 35%\"><span class=\"sr-only\">35% Complete (success)</span></div><div class=\"progress-bar progress-bar-warning progress-bar-striped\" style=\"width: 20%\"><span class=\"sr-only\">20% Complete (warning)</span></div><div class=\"progress-bar progress-bar-danger\" style=\"width: 10%\"><span class=\"sr-only\">10% Complete (danger)</span></div><div class=\"progress-bar progress-bar-info progress-bar-striped active\" style=\"width: 20%\"><span class=\"sr-only\">20% Complete (warning)</span></div></div>");
$templateCache.put("app/pages/ui/progressBars/widgets/striped.html","<div class=\"progress\"><div class=\"progress-bar progress-bar-success progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"40\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 40%\"><span class=\"sr-only\">40% Complete (success)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-info progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"20\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 20%\"><span class=\"sr-only\">20% Complete</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-warning progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 60%\"><span class=\"sr-only\">60% Complete (warning)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-danger progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"80\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 80%\"><span class=\"sr-only\">80% Complete (danger)</span></div></div>");
$templateCache.put("app/pages/ui/modals/notifications/notifications.html","<div class=\"modal-buttons same-width clearfix\" ng-controller=\"NotificationsCtrl\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"showSuccessMsg()\">Success Notification</button> <button type=\"button\" class=\"btn btn-info\" ng-click=\"showInfoMsg()\">Info Notification</button> <button type=\"button\" class=\"btn btn-warning\" ng-click=\"showWarningMsg()\">Warning Notification</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"showErrorMsg()\">Danger Notification</button></div>");
$templateCache.put("app/pages/form/inputs/widgets/select/select.html","<div ng-controller=\"SelectpickerPanelCtrl as selectpickerVm\"><div class=\"form-group\"><select class=\"form-control selectpicker\" selectpicker=\"\" title=\"Standard Select\" ng-model=\"selectpickerVm.standardSelected\" ng-options=\"item as item.label for item in selectpickerVm.standardSelectItems\"></select></div><div class=\"form-group\"><select class=\"form-control selectpicker with-search\" data-live-search=\"true\" title=\"Select With Search\" selectpicker=\"\" ng-model=\"selectpickerVm.searchSelectedItem\" ng-options=\"item as item.label for item in selectpickerVm.selectWithSearchItems\"></select></div><div class=\"form-group\"><select class=\"form-control selectpicker\" title=\"Option Types\" selectpicker=\"\"><option>Standard option</option><option data-subtext=\"option subtext\">Option with subtext</option><option disabled=\"\">Disabled Option</option><option data-icon=\"glyphicon-heart\">Option with cion</option></select></div><div class=\"form-group\"><select class=\"form-control selectpicker\" disabled=\"\" title=\"Disabled Select\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><select class=\"form-control\" title=\"Select with Option Groups\" selectpicker=\"\" ng-model=\"selectpickerVm.groupedSelectedItem\" ng-options=\"item as item.label group by item.group for item in selectpickerVm.groupedSelectItems\"></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><select class=\"form-control\" title=\"Select with Divider\" selectpicker=\"\"><option>Group 1 - Option 1</option><option>Group 1 - Option 2</option><option data-divider=\"true\"></option><option>Group 2 - Option 1</option><option>Group 2 - Option 2</option></select></div></div></div><div class=\"form-group\"><select class=\"form-control\" title=\"Multiple Select\" multiple=\"\" selectpicker=\"\" ng-model=\"selectpickerVm.multipleSelectedItems\" ng-options=\"item as item.label for item in selectpickerVm.standardSelectItems\"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class=\"form-group\"><select class=\"form-control\" title=\"Multiple Select with Limit\" multiple=\"\" data-max-options=\"2\" selectpicker=\"\" ng-model=\"selectpickerVm.multipleSelectedItems2\" ng-options=\"item as item.label for item in selectpickerVm.standardSelectItems\"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><select class=\"form-control\" title=\"Primary Select\" data-style=\"btn-primary\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class=\"form-group\"><select class=\"form-control\" title=\"Success Select\" data-style=\"btn-success\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class=\"form-group\"><select class=\"form-control\" title=\"Warning Select\" data-style=\"btn-warning\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><select class=\"form-control\" title=\"Info Select\" data-style=\"btn-info\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class=\"form-group\"><select class=\"form-control\" title=\"Danger Select\" data-style=\"btn-danger\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class=\"form-group\"><select class=\"form-control\" title=\"Inverse Select\" data-style=\"btn-inverse\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div></div></div>");
$templateCache.put("app/pages/form/inputs/widgets/tagsInput/tagsInput.html","<div class=\"form-group\"><div class=\"form-group\"><input type=\"text\" tag-input=\"primary\" value=\"Amsterdam,Washington,Sydney,Beijing,Cairo\" data-role=\"tagsinput\" placeholder=\"Add Tag\"></div><div class=\"form-group\"><input type=\"text\" tag-input=\"warning\" value=\"Minsk,Prague,Vilnius,Warsaw\" data-role=\"tagsinput\" placeholder=\"Add Tag\"></div><div class=\"form-group\"><input type=\"text\" tag-input=\"danger\" value=\"London,Berlin,Paris,Rome,Munich\" data-role=\"tagsinput\" placeholder=\"Add Tag\"></div></div>");
$templateCache.put("app/pages/form/inputs/widgets/switch/switch.html","<div ng-controller=\"SwitchPanelCtrl as switchPanelVm\" class=\"switches clearfix\"><switch color=\"primary\" ng-model=\"switchPanelVm.switcherValues.primary\"></switch><switch color=\"warning\" ng-model=\"switchPanelVm.switcherValues.warning\"></switch><switch color=\"danger\" ng-model=\"switchPanelVm.switcherValues.danger\"></switch><switch color=\"info\" ng-model=\"switchPanelVm.switcherValues.info\"></switch><switch color=\"success\" ng-model=\"switchPanelVm.switcherValues.success\"></switch></div>");}]);